
// Custom Scripts
(function ($) {
	console.log('Scripts succesfully loaded!');
	document.addEventListener( 'wpcf7mailsent', function( event ) {
		var et = $(event.target);
		et.find('.wpcf7-response-output').addClass('alert-success');
		// setTimeout(function(){
		// 	et.find('.wpcf7-response-output').removeClass('alert-success');
		// },3000);

	}, false );

	$(window).load(function() {
		$(this).on('wpcf7mailsent', function(){
			jQuery.noConflict();
			jQuery('.modal').modal('hide');
			jQuery('#emailSentModal').modal('show');
		})
		/* document.addEventListener( 'wpcf7mailsent', function( event ) {
			console.log($('.modal'));

			console.log($('#emailSentModal'));
			// if ($('.modal')) {
			// 	$('.modal').modal('hide');
			// }
			// document.querySelectorAll('.modal').forEach(modal=>{
			// 	console.log(modal);
			// });
			$('#emailSentModal').modal('show');
		}, false ); */
	});



	$(window).load(function() {
		$('[data-toggle="tooltip"]').on('mouseover', function(event){
			$(event.target).tooltip("show");
		});
	});

  	$('.mobile-menu-trigger').click(function(e){
  		if ($(this).hasClass('main-menu')) {
			e.preventDefault();
  			$('.user-menu-nav').removeClass('active');
  			$('.mobile-menu-trigger.user-menu').removeClass('active');

  			if ($('.main-menu-nav').hasClass('active')) {
  				$('.main-menu-nav').removeClass('active');
  				$('.mobile-menu-trigger.main-menu').removeClass('active');
  			}else{
  				$('.main-menu-nav').addClass('active');
  				$('.mobile-menu-trigger.main-menu').addClass('active');
  			}

  		}else if ($(this).hasClass('user-menu')) {
			/*
  			$('.main-menu-nav').removeClass('active');
  			$('.mobile-menu-trigger.main-menu').removeClass('active');

  			if ($('.user-menu-nav').hasClass('active')) {
  				$('.user-menu-nav').removeClass('active');
  				$('.mobile-menu-trigger.user-menu').removeClass('active');
  			}else{
  				$('.user-menu-nav').addClass('active');
  				$('.mobile-menu-trigger.user-menu').addClass('active');
  			}
			*/
  		}
  	});
  	$('#mobile-menu>.menu-item').click(function(e){
		//e.preventDefault();
  		$('#mobile-menu>.menu-item>.sub-menu').removeClass('active');
  		if ($(this).children().hasClass('active')) {
  			$(this).children().removeClass('active');
  		}else{
  			$(this).children().addClass('active');
  		}
  	});
  	$('.input-cv').change(function(e){
          $(this).parent().siblings('.file-name-display').val(e.target.files[0].name);
      });
  	$('.file-attachment-trigger').click(function(){
  		$('.input-cv').trigger('click');
  	});
	$('.search-trigger').click(function(e){
		e.preventDefault();
		var tr = $(this);
		var car = $(this).closest('.section-menu').find('.search-dropdown');
		if (tr.find('.icon-buscar').length) {
			car.addClass('showing');
			tr.children().removeClass('icon-buscar').addClass('icon-no');
		}else{
			car.removeClass('showing');
			tr.children().removeClass('icon-no').addClass('icon-buscar');
		}

	});
	$('.expand-btn-download').click(function(e){
		e.preventDefault();
		var list = $(this).parent().parent().find('.downloads-list');
		if (list.hasClass('open')) {
			list.removeClass('open');
			$(this).addClass('hidden');
			$(this).parent().find('.more').removeClass('hidden');
		}else{
			list.addClass('open');
			$(this).addClass('hidden');
			$(this).parent().find('.less').removeClass('hidden');
		}
	});
	if ($('.section-menu').length) {
		var current_item = $('.section-menu').find('.current-menu-item')
		if (current_item.length) {
			var scroll_menu_left = current_item[0].offsetLeft;
			$('.section-menu').find('.top-menu').scrollLeft(scroll_menu_left);
			$('.section-menu').find('.container').scrollLeft(scroll_menu_left);
		}
	}
	/*
	if ($('.content-tabs').length) {
		var scroll_tabs_left = $('.content-tabs').find('.active')[0].offsetLeft;
		$('.wp-block-ub-tabbed-content-tabs-title').scrollLeft(scroll_tabs_left);
	}
	*/

	// Mutualist code
	$(document).ready($('body').on('click', '#form_acc_val_desk button', function(e){
		e.preventDefault();
		var mutualist_id_input = $("#form_acc_val_desk input[name=mutualist_code]");
		mutualist_id_input.removeClass('error');
		$('#form_acc_val_desk').removeClass('error');
		if ($.isNumeric(mutualist_id_input.val()) && mutualist_id_input.val().length == 8) {
			$('#form_acc_val_desk').submit();
		}else{
			mutualist_id_input.addClass('error');
			$('#form_acc_val_desk').addClass('error');
		}
	}));

	$(document).ready($('body').on('click', '#form_acc_val_mob button', function(e){
		e.preventDefault();
		var mutualist_id_input = $("#form_acc_val_mob input[name=mutualist_code]");
		mutualist_id_input.removeClass('error');
		$('#form_acc_val_mob').removeClass('error');
		if ($.isNumeric(mutualist_id_input.val()) && mutualist_id_input.val().length == 8) {
			$('#form_acc_val_mob').submit();
		}else{
			mutualist_id_input.addClass('error');
			$('#form_acc_val_mob').addClass('error');
		}
	}));


	// CP code
	$(document).ready($('body').on('click', '#form_cp_val_desk button', function(e){
		e.preventDefault();
		var cp_id_input = $("#form_cp_val_desk input[name=cp_code]");
		cp_id_input.removeClass('error');
		$('#form_cp_val_desk').removeClass('error');
		if ($.isNumeric(cp_id_input.val()) && cp_id_input.val().length == 5) {
			$('#form_cp_val_desk').submit();
		}else{
			cp_id_input.addClass('error');
			$('#form_cp_val_desk').addClass('error');
		}
	}));

	$(document).ready($('body').on('click', '#form_cp_val_mob button', function(e){
		e.preventDefault();
		var cp_id_input = $("#form_cp_val_mob input[name=cp_code]");
		cp_id_input.removeClass('error');
		$('#form_cp_val_mob').removeClass('error');
		if ($.isNumeric(cp_id_input.val()) && cp_id_input.val().length == 5) {
			$('#form_cp_val_mob').submit();
		}else{
			cp_id_input.addClass('error');
			$('#form_cp_val_mob').addClass('error');
		}
	}));


	$(window).scroll(function(e){
		const background = $('.background');
		if (background.length) {
			var scrolled = $(window).scrollTop();
			var offset = -(scrolled * 0.5);
			background.css('top', (offset.toString() + 'px'));
		}
	});
	if ($('#contactModal_main').length) {
		$('footer').append($('#contactModal_main'));
	}
	if ($('.graphModal').length) {
		var graphs = $('.graphModal');
		for (var i = 0; i < graphs.length; i++) {
			$('footer').append(graphs[i]);
		}

	}
	if ($('.solInfoModal').length) {
		var modals = $('.solInfoModal');
		for (var i = 0; i < modals.length; i++) {
			$('footer').append(modals[i]);
		}

	}

	$(window).scroll(stick_header);
	stick_header();






})(jQuery);

$(document).ready(function(){
	$.fn.fixedRrss = function(options) {

		if (!this.length) return;

		var stick = $('aside.rrss'),
			stickTop = stick.offset().top,
			foot = $('.related-posts'),
			margin = 100,
			offtop = stick.offset().top - margin;

		$(window).scroll(function() {
			var scrtop = $(window).scrollTop(),
				offbtm = foot.offset().top - (margin * 2 + stick.height()),
				offbtmpos = foot.offset().top - (margin + stick.height()) - stickTop + margin;

			if (scrtop > offtop && stick.hasClass('natural')) {
				stick.removeClass('natural').addClass('fixed').css('top', margin);
			}
			if (offtop > scrtop && stick.hasClass('fixed')) {
				stick.removeClass('fixed').addClass('natural').css('top', '100px');
			}
			if (scrtop > offbtm && stick.hasClass('fixed')) {
				stick.removeClass('fixed').addClass('bottom').css('top', offbtmpos);
			}
			if (offbtm > scrtop && stick.hasClass('bottom')) {
				stick.removeClass('bottom').addClass('fixed').css('top', margin);
			}
		});
	};
	if ($('aside.rrss')) {
		$('aside.rrss').fixedRrss();
	}else{
		console.log('This component doesn\'t exist');
	}
});


$(function(){
	if ($('#map').length) {
		$(document).ready(function(){
			if ($(window).width() <= 767) {
				$('#map_carrier_mobile').append($("#map"));
			}
		});
		var app = new Vue({
			el: '.map-carrier-section',
			data: {
				message: 'Hello Vue!',
				offices: [],
				specialities: [],
				selected: false,
				selectedHtml: '',
				markers: [],
				hover: false,

				emptyMessage: "",
				emptyList: false,
				loading: false,
				ofiAddress: "",
				address: "",
				speciality_in: "",
				speciality_in_snaked: "",
				specialist: "",
				coords: "",


				main_info: "Barcelona",
				extra_info: "Todas las especialidades",

				closestOfficeCity: "Barcelona",
				closestOfficeAddress: "C/Tuset 5-11",


				isHidden: false,
				secStage:false,
				minimized: false,
				displaying: false,
				isMoved: false,
				reset: false,

				map: null,
				infoWindow: null,
				autocomplete: null,

				selOffice: "",
				currentOffiSpecs: [],

				cp_code: "",

				franquicia: "",

				tooltipContent: "",
				openTooltipModal: false

			},
			mounted(){

				this.autocomplete = new google.maps.places.Autocomplete(
					(this.$refs.autocomplete),
					{types: ['geocode'],componentRestrictions: {country: "es"}}
				);

				this.autocomplete.addListener('place_changed', () => {
					let place = this.autocomplete.getPlace();
					this.address = place.formatted_address;
					this.ofiAddress = place.formatted_address;
					this.coords = place.geometry.location;

				});

				var myStyles =[
				    {
				        featureType: "poi",
				        elementType: "labels",
				        stylers: [
				              { visibility: "off" }
				        ]
				    }
				];
				this.map = new google.maps.Map((document.getElementById("map")), {
					center: {
						lat: 41.388545,
						lng: 2.167073
					},
					zoom: 16,
					disableDefaultUI: true,
					clickableIcons: false,
					styles: myStyles
				});

				google.maps.Map.prototype.setCenterWithOffset= function(latlng, offsetX, offsetY) {
					var map = this;
					var ov = new google.maps.OverlayView();
					ov.onAdd = function() {
						var proj = this.getProjection();
						var aPoint = proj.fromLatLngToContainerPixel(latlng);
						aPoint.x = aPoint.x+offsetX;
						aPoint.y = aPoint.y+offsetY;
						map.setCenter(proj.fromContainerPixelToLatLng(aPoint));
					};
					ov.draw = function() {};
					ov.setMap(this);
				};

				// Using

				this.infoWindow = new google.maps.InfoWindow({
					maxWidth: 300
				});
				var request = new XMLHttpRequest();
				var vm = this;

				vm.loading = true;
				if (lang_code == 'es') {
					vm.emptyMessage = "Lo sentimos, no hemos podido encontrar centros cerca."
				}else if(lang_code == 'ca'){
					vm.emptyMessage = "Ho sentim, no hem pogut trobar centres aprop."
				}
				vm.emptyList = false;
				var url = "";

				//  console.log('mutua code: ' + mutua_code);
				//  console.log('cp code: ' + cp_code);
				//------------------------------------------------------------------
				// Dislpaying med centers or offices markers on the map
				if (mutua_code.length || cp_code.length) {
					// default
					let lat = 41.3917636;
					let lng = 2.178108;

					// CP has value, mutualist code (-1)
					if (mutua_code == "-1" && cp_code != "-1") {

						getLatLngByZipcode(cp_code, (lt, ln) => {
							lat = lt;
							lng = ln;



							url = '/wp-content/themes/mgc/curl_petition.php?petition=fillSelect&idMutua=-1&lang=' + lang_code  + '&cpCode=' + cp_code;
							var fillRequest = new XMLHttpRequest();
							fillRequest.open('GET', url);
							fillRequest.onload = () => {
								console.log(fillRequest)
								if (isValidJSON(fillRequest.response)) {
									let data = JSON.parse(fillRequest.response);
									this.specialities = data.data;
								} else {
									this.specialities = [];
								}
							}
                            let sendRequest = () => {
                                fillRequest.send();
                                console.log("sended fill request")
                            }
                            setTimeout(() => sendRequest(), 500);

							url = '/wp-content/themes/mgc/curl_petition.php?petition=initClinics&idMutua=-1&cpCode=' + cp_code + '&lang=' + lang_code + '&lat=' + lat + '&lng=' + lng;

							request.open('GET', url);
							request.onload = () => {
								var isThereOffices = true;
								var data;
								try
									{ data = JSON.parse(request.response); }
								catch (e)
									{ isThereOffices = false; }

								vm.loading = false;
								vm.map.setCenter({
									lat: lat,
									lng: lng
								});
								if (isThereOffices) {
									this.offices = data.data;
									let contador = 0;
									if(vm.coords.lat!=null && vm.coords.lng!=null){
										lat = vm.coords.lat;
										lng = vm.coords.lng;
									}
									this.offices.forEach(function(e){
										//e['DISTANCE'] = vm.getDistance(lat, lng, parseFloat(e.LATITUD), parseFloat(e.LONGITUD));
										e['DISTANCE_FINAL'] = vm.getDistanceAlt(e.DISTANCE);

										if ('CODI_METGE' in e) {
											let underscoredID = e['CODI_METGE'].replaceAll(" ", "_");
											e['CODI_METGE'] = underscoredID;
										}

										let iconURLA;
										!+e.PREFERENT || 0
											? iconURLA = "/wp-content/themes/mgc/src/img/pin_A.svg"
											: iconURLA = "/wp-content/themes/mgc/src/img/pin_AP.svg"
										let marker = new google.maps.Marker({
											position: {lat: parseFloat(e.LATITUD), lng: parseFloat(e.LONGITUD)},
											map: vm.map,
											icon: iconURLA,
											html: '',
											index: contador,
											preferent: parseInt(e.PREFERENT)
										});
										contador++;
										google.maps.event.addListener(marker, 'click', function () {
											for (let i = 0; i < vm.markers.length - 1; i++) {
												let currentMarker = vm.markers[i];
												!+currentMarker.preferent || 0
													? currentMarker.setIcon("/wp-content/themes/mgc/src/img/pin_A.svg")
													: currentMarker.setIcon("/wp-content/themes/mgc/src/img/pin_AP.svg");
												currentMarker.setZIndex(2);
											}

											vm.infoWindow.setContent(vm.$refs['oficina'+marker.index][0].innerHTML);
											!+this.preferent || 0
												? this.setIcon("/wp-content/themes/mgc/src/img/pin_B.svg")
												: this.setIcon("/wp-content/themes/mgc/src/img/pin_BP.svg");
											this.setZIndex(100);
											vm.infoWindow.open(map, marker);


											//vm.map.panTo(new google.maps.LatLng(marker.position.lat(), marker.position.lng()));
											let latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
											vm.map.setCenterWithOffset(latlng, 0, -125);
										});
										vm.markers.push(marker);
									});
									let marker = new google.maps.Marker({
										position: {lat: parseFloat(lat), lng: parseFloat(lng)},
										map: vm.map,
										icon: '/wp-content/themes/mgc/src/img/marcador_01.svg',
										html: '',
										index: contador
									});
									marker.setZIndex(1);
									contador++;
									vm.markers.push(marker);
								} else {
									vm.mapEmpty();
									this.offices = [];
								}
							};
							request.send();

						});

					// Mutualist code has value, cp (-1)
					} else if (mutua_code !== "-1" && cp_code == "-1") {

						this.franquicia = false;
						url = '/wp-content/themes/mgc/curl_petition.php?petition=checkFranchise&idMutua=' + mutua_code;
						var franchiseRequest = new XMLHttpRequest();
						franchiseRequest.open('GET', url);
						franchiseRequest.onload = () => {
							if (isValidJSON(franchiseRequest.response)) {
								let franchData = JSON.parse(franchiseRequest.response);
								if (franchData.data == "NO") {
									this.franquicia = true;
								}
							}else{
								console.log('error')
								console.log(franchiseRequest)
								console.log(franchiseRequest.response)
							}
						}
						franchiseRequest.send();

						url = '/wp-content/themes/mgc/curl_petition.php?petition=initClinics&cpCode=-1&idMutua=' + mutua_code + '&lang=' + lang_code + '&lat=' + lat + '&lng=' + lng;
						var isThereOffices = true;
						request.open('GET', url);
						request.onload = () => {
							var data;
							try
								{ data = JSON.parse(request.response); }
							catch (e)
								{
									console.log(request);
									isThereOffices = false; }


							vm.loading = false;
							if (isThereOffices) {
								this.offices = data.data;
								let contador = 0;
								if(vm.coords.lat!=null && vm.coords.lng!=null){
									lat = vm.coords.lat;
									lng = vm.coords.lng;
								}
								let testBool = true;
								this.offices.forEach(function(e){
									//e['DISTANCE'] = vm.getDistance(lat, lng, parseFloat(e.LATITUD), parseFloat(e.LONGITUD));
									e['DISTANCE_FINAL'] = vm.getDistanceAlt(e.DISTANCE);

									if ('CODI_METGE' in e) {
										let underscoredID = e['CODI_METGE'].replaceAll(" ", "_");
										e['CODI_METGE'] = underscoredID;
									}

									let iconURLA;
									!+e.PREFERENT || 0
										? iconURLA = "/wp-content/themes/mgc/src/img/pin_A.svg"
										: iconURLA = "/wp-content/themes/mgc/src/img/pin_AP.svg"

									let marker = new google.maps.Marker({
										position: {lat: parseFloat(e.LATITUD), lng: parseFloat(e.LONGITUD)},
										map: vm.map,
										icon: iconURLA,
										html: '',
										index: contador,
										preferent: parseInt(e.PREFERENT)
									});
									contador++;
									google.maps.event.addListener(marker, 'click', function () {
										for (let i = 0; i < vm.markers.length - 1; i++) {
											let currentMarker = vm.markers[i];

											!+currentMarker.preferent || 0
												? currentMarker.setIcon("/wp-content/themes/mgc/src/img/pin_A.svg")
												: currentMarker.setIcon("/wp-content/themes/mgc/src/img/pin_AP.svg");
											currentMarker.setZIndex(2);
										}

										vm.infoWindow.setContent(vm.$refs['oficina'+marker.index][0].innerHTML);

										!+this.preferent || 0
											? this.setIcon("/wp-content/themes/mgc/src/img/pin_B.svg")
											: this.setIcon("/wp-content/themes/mgc/src/img/pin_BP.svg");

										this.setZIndex(100);
										vm.infoWindow.open(map, marker);


										//vm.map.panTo(new google.maps.LatLng(marker.position.lat(), marker.position.lng()));
										let latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
										vm.map.setCenterWithOffset(latlng, 0, -125);
										setTimeout(()=>{
											let element = document.querySelector('.gm-style');
											let tooltips;
											if (element) {
												tooltips = element.querySelectorAll('[data-toggle="tooltip"]');
												tooltips.forEach(e=>{
													e.addEventListener('mouseover',(event)=>{
														if (window.innerWidth >= 768) {
															$(event.target).tooltip("show");
														}
													});
													//console.log('Add event list')
													e.addEventListener('click',vm.showTooltipModal)
												})
											}
										}, 100)
									});
									vm.markers.push(marker);
								});
								let marker = new google.maps.Marker({
									position: {lat: parseFloat(lat), lng: parseFloat(lng)},
									map: vm.map,
									icon: '/wp-content/themes/mgc/src/img/marcador_01.svg',
									html: '',
									index: contador
								});
								marker.setZIndex(1);
								contador++;
								vm.markers.push(marker);
							} else {
								vm.mapEmpty();
								this.offices = [];
							}
						};
						request.send();
						url = '/wp-content/themes/mgc/curl_petition.php?petition=fillSelect&idMutua=' + mutua_code + '&lang=' + lang_code + '&cpCode=-1';
						var fillRequest = new XMLHttpRequest();
						fillRequest.open('GET', url);
						fillRequest.onload = () => {
							if (isValidJSON(fillRequest.response)) {
								let data = JSON.parse(fillRequest.response);
								this.specialities = data.data;
							} else {
								this.specialities = []
							}
							this.initTooltips();
						}
						fillRequest.send();

					// Fallback
					} else {
						var isThereOffices = true;
						// Madrid
						lat = 40.416729;
						lng = -3.703339;
						let dist = 200;
						let nResults = 100;
						url = '/wp-content/themes/mgc/curl_petition.php?petition=initClinics&idMutua=-1&cpCode=28001&distance=' + dist + '&num_resultats_mostrar=' + nResults + '&lang=' + lang_code + '&lat=' + lat + '&lng=' + lng;
						request.open('GET', url);
						request.onload = () => {
							var data;
							try
								{ data = JSON.parse(request.response); }
							catch (e)
								{ isThereOffices = false; }

							vm.loading = false;
							vm.map.setZoom(7);
							vm.map.setCenter({
								lat: lat,
								lng: lng
							});
							if (isThereOffices) {
								this.offices = data.data;
								let contador = 0;
								if(vm.coords.lat!=null && vm.coords.lng!=null){
									lat = vm.coords.lat;
									lng = vm.coords.lng;
								}
								this.offices.forEach(function(e){
									//e['DISTANCE'] = vm.getDistance(lat, lng, parseFloat(e.LATITUD), parseFloat(e.LONGITUD));
									e['DISTANCE_FINAL'] = vm.getDistanceAlt(e.DISTANCE);

									let iconURLA;
									!+e.PREFERENT || 0
										? iconURLA = "/wp-content/themes/mgc/src/img/pin_A.svg"
										: iconURLA = "/wp-content/themes/mgc/src/img/pin_AP.svg"

										let marker = new google.maps.Marker({
										position: {lat: parseFloat(e.LATITUD), lng: parseFloat(e.LONGITUD)},
										map: vm.map,
										icon: iconURLA,
										html: '',
										index: contador,
										preferent: parseInt(e.PREFERENT)
									});
									contador++;
									google.maps.event.addListener(marker, 'click', function () {
										for (let i = 0; i < vm.markers.length - 1; i++) {
											let currentMarker = vm.markers[i];
											!+currentMarker.preferent || 0
												? currentMarker.setIcon("/wp-content/themes/mgc/src/img/pin_A.svg")
												: currentMarker.setIcon("/wp-content/themes/mgc/src/img/pin_AP.svg");
											currentMarker.setZIndex(2);
										}

										vm.infoWindow.setContent(vm.$refs['oficina'+marker.index][0].innerHTML);
										!+this.preferent || 0
											? this.setIcon("/wp-content/themes/mgc/src/img/pin_B.svg")
											: this.setIcon("/wp-content/themes/mgc/src/img/pin_BP.svg");
										this.setZIndex(100);
										vm.infoWindow.open(map, marker);


										//vm.map.panTo(new google.maps.LatLng(marker.position.lat(), marker.position.lng()));
										let latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
										vm.map.setCenterWithOffset(latlng, 0, -125);
									});
									vm.markers.push(marker);
								});
								let marker = new google.maps.Marker({
									position: {lat: parseFloat(lat), lng: parseFloat(lng)},
									map: vm.map,
									icon: '/wp-content/themes/mgc/src/img/marcador_01.svg',
									html: '',
									index: contador
								});
								marker.setZIndex(1);
								contador++;
								vm.markers.push(marker);
							} else {
								vm.mapEmpty();
								this.offices = [];
							}
						};
						request.send();
						url = '/wp-content/themes/mgc/curl_petition.php?petition=fillSelect&idMutua=-1&cpCode=-1&lang=' + lang_code;
						var fillRequest = new XMLHttpRequest();
						fillRequest.open('GET', url);
						fillRequest.onload = () => {
							if (isValidJSON(fillRequest.response)) {
								let data = JSON.parse(fillRequest.response);
								this.specialities = data.data;
							} else {
								this.specialities = [];
							}
						}
						fillRequest.send();
					}

				// Neither both setted [ mutualist code (-1), cp code (-1) ]
				} else if (mutua_code == "-1" && cp_code == "-1") {
					$("#accMutopModal").modal();
					$('#accCPModal').data('backdrop', 'static');
					$('#accCPModal').data('keyboard', false);
					$('#accNumberModal').data('backdrop', 'static');
					$('#accNumberModal').data('keyboard', false);
					$('.refresh-btn-carrier').addClass('d-md-none');

					var isThereOffices = true;
					// Madrid
					let lat = 40.416729;
					let lng = -3.703339;

					vm.loading = false;
					vm.map.setZoom(7);
					vm.map.setCenter({
						lat: lat,
						lng: lng
					});

				// Displaying offices [ mutualist code (""), cp ("")]
				} else {

					url = '/wp-content/themes/mgc/curl_petition.php?petition=initOffices&lang='+lang_code;
					vm.map.setCenter({
						lat: 40.0374764,
						lng: -3.3378899
					});
					vm.map.setZoom(7);
					var officesRequest = new XMLHttpRequest();
					officesRequest.open('GET', url);
					officesRequest.onload = () => {
						if (isValidJSON(officesRequest.response))
						{
							let data = JSON.parse(officesRequest.response);
							this.offices = data;
							vm.loading = false;
							var contador = 0;
							this.offices.forEach(function(e){
								var marker = new google.maps.Marker({
									position: {lat: parseFloat(e.LATITUD), lng: parseFloat(e.LONGITUD)},
									map: vm.map,
									icon: "/wp-content/themes/mgc/src/img/pin_A.svg",
									html: '',
									index: contador
								});
								contador++;
								google.maps.event.addListener(marker, 'click', function () {
									for (var i = 0; i < vm.markers.length; i++) {
										let currentMarker = vm.markers[i]
										currentMarker.setIcon("/wp-content/themes/mgc/src/img/pin_A.svg");
										currentMarker.setZIndex(1);
									}
									vm.infoWindow.setContent(vm.$refs['oficina'+marker.index][0].innerHTML);
									this.setIcon("/wp-content/themes/mgc/src/img/pin_B.svg");

									this.setZIndex(100);
									vm.infoWindow.open(map, marker);
									vm.map.panTo(new google.maps.LatLng(marker.position.lat(), marker.position.lng()));
									vm.map.setZoom(16);
								});
								vm.markers.push(marker);
							});
						} else {
							this.offices = [];
						}
					}
					officesRequest.send();
				}
			},
			updated(){

				//!isMoved evita que actualice la lista al mostrar las especialidades del centro seleccionado
				if (!this.reset) {
					if (mutua_code.length && !this.isMoved) {

						if (this.$refs['oficina0'] != 'undefined' && this.markers[0] != undefined) {
							this.infoWindow.setContent(this.$refs['oficina0'][0].innerHTML);
							//this.map.panTo(new google.maps.LatLng(this.markers[0].position.lat(), this.markers[0].position.lng()));
							let latlng = new google.maps.LatLng(this.markers[this.markers.length-1].position.lat(), this.markers[this.markers.length-1].position.lng());
							this.map.setCenterWithOffset(latlng, 0, -125);
						}
					}
				}else{
					this.reset = false;
				}
				this.initTooltips();

			},
			methods:{
				seleccionaOficina: function(oficina,index) {
					this.hover = true;
					//this.infoWindow.setContent(this.$refs['oficina'+index][0]);
					new google.maps.event.trigger( this.markers[index], 'click' );
					this.map.panTo(new google.maps.LatLng(this.markers[index].position.lat(), this.markers[index].position.lng()));
					this.hover = false;
					var vm = this;
					setTimeout(()=>{
						let element = document.querySelector('.gm-style');
						let tooltips;
						if (element) {
							tooltips = element.querySelectorAll('[data-toggle="tooltip"]');
							tooltips.forEach(e=>{
								e.addEventListener('mouseover',(event)=>{
									if (window.innerWidth >= 768) {
										$(event.target).tooltip("show");
									}
								});
								//console.log('Add event list')
								e.addEventListener('click',vm.showTooltipModal)
							})
						}
					}, 100)
				},
				mapEmpty: function() {
					var vm = this;
					vm.markers.forEach(function(e){
						e.setMap(null);
					});
					vm.markers.length = 0;
					vm.offices.length = 0;
					vm.emptyList = true;
				},
				refreshMap: function(lat, lng, speciality, specialist){

					var request = new XMLHttpRequest();
					var url = '/wp-content/themes/mgc/curl_petition.php?petition=updateClinics&lang='+lang_code;

					if (speciality != null && speciality != "") {
						url = url + '&speciality=' + speciality;
					}
					if (specialist != null && specialist != "") {
						url = url + '&specialist=' + specialist;
					}

					// If there was direct access via url to the map,
					// and neither mutualist code or CP code was setted,
					// throw  pop-up again
					if (mutua_code == "-1" && cp_code == "-1"){
						$("#accMutopModal").modal();

					// Case no mutualist code -> get zipcode from current position -> display centers.
					} else if (mutua_code == "-1") {

						if ( vm !== undefined && vm.coords != "") {
							lat = vm.coords.lat;
							lng = vm.coords.lng;
						} else {
							lat = this.map.getCenter().lat();
							lng = this.map.getCenter().lng();
						}

						getZipcodeByLatLng(lat, lng, (zipcode) => {

							// same cp code for same 'cuadro sesion',
							// just update position for medical centers retrievement
							url = url + '&lat=' + lat + '&lng=' + lng + '&cpCode=' + window.cp_code;

							var vm = this;
							vm.loading = true;
							vm.offices = {};
							vm.markers.forEach(function(e){
								e.setMap(null);
							});
							vm.markers.length = 0;
							vm.emptyList = false;

							request.open('GET', url);
							request.onload = () => {
								var isThereOffices = true;
								var data;
								try
									{ data = JSON.parse(request.response);}
								catch (e)
									{ isThereOffices = false; }

								console.log("el data");
								console.log(data);

								vm.loading = false;
								if (isThereOffices) {
									this.offices = data.data;
									let contador = 0;
									if(vm.coords.lat!=null && vm.coords.lng!=null){
										lat = vm.coords.lat;
										lng = vm.coords.lng;
									}

									this.offices.forEach(function(e){
										//e['DISTANCE'] = vm.getDistance(lat, lng, parseFloat(e.LATITUD), parseFloat(e.LONGITUD));
										e['DISTANCE_FINAL'] = vm.getDistanceAlt(e.DISTANCE);

										let iconURLA;
										!+e.PREFERENT || 0
											? iconURLA = "/wp-content/themes/mgc/src/img/pin_A.svg"
											: iconURLA = "/wp-content/themes/mgc/src/img/pin_AP.svg"
										let marker = new google.maps.Marker({
											position: {lat: parseFloat(e.LATITUD), lng: parseFloat(e.LONGITUD)},
											map: vm.map,
											icon: iconURLA,
											html: '',
											index: contador,
											preferent: parseInt(e.PREFERENT)
										});
										contador++;
										google.maps.event.addListener(marker, 'click', function () {
											for (let i = 0; i < vm.markers.length - 1; i++) {
												let currentMarker = vm.markers[i];
												!+currentMarker.preferent || 0
													? currentMarker.setIcon("/wp-content/themes/mgc/src/img/pin_A.svg")
													: currentMarker.setIcon("/wp-content/themes/mgc/src/img/pin_AP.svg");
												currentMarker.setZIndex(2);
											}

											vm.infoWindow.setContent(vm.$refs['oficina'+marker.index][0].innerHTML);
											!+this.preferent || 0
												? this.setIcon("/wp-content/themes/mgc/src/img/pin_B.svg")
												: this.setIcon("/wp-content/themes/mgc/src/img/pin_BP.svg");
											this.setZIndex(100);
											vm.infoWindow.open(map, marker);


											//vm.map.panTo(new google.maps.LatLng(marker.position.lat(), marker.position.lng()));
											let latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
											vm.map.setCenterWithOffset(latlng, 0, -125);
											setTimeout(()=>{
												let element = document.querySelector('.gm-style');
												let tooltips;
												if (element) {
													tooltips = element.querySelectorAll('[data-toggle="tooltip"]');
													tooltips.forEach(e=>{
														e.addEventListener('mouseover',(event)=>{
															if (window.innerWidth >= 768) {
																$(event.target).tooltip("show");
															}
														});
														//console.log('Add event list')
														e.addEventListener('click',vm.showTooltipModal)
													})
												}
											}, 100)
										});
										vm.markers.push(marker);
									});
									let marker = new google.maps.Marker({
										position: {lat: parseFloat(lat), lng: parseFloat(lng)},
										map: vm.map,
										icon: '/wp-content/themes/mgc/src/img/marcador_01.svg',
										html: '',
										index: contador
									});
									marker.setZIndex(1);
									contador++;
									vm.markers.push(marker);
									this.initTooltips();
								} else {
									vm.mapEmpty();
									this.offices = [];
								}
							}
							request.send();

						});


					// Case mutualist code
					} else {


						lat || (lat = this.map.getCenter().lat());
						lng || (lng = this.map.getCenter().lng());
						url = url + '&lat=' + lat + '&lng=' + lng + '&cpCode=-1';

						var vm = this;
						vm.loading = true;
						vm.offices = {};
						vm.markers.forEach(function(e){
							e.setMap(null);
						});
						vm.markers.length = 0;
						vm.emptyList = false;

						var isThereOffices = true;
						request.open('GET', url);
						request.onload = () => {
							var data;
							try
								{ data = JSON.parse(request.response); }
							catch (e)
								{ isThereOffices = false; }


							vm.loading = false;
							if (isThereOffices) {
								let data = JSON.parse(request.response);
								this.offices = data.data;
								vm.loading = false;
								var contador = 0;
								this.offices.forEach(function(e){
									//e['DISTANCE'] = vm.getDistance(lat, lng, parseFloat(e.LATITUD), parseFloat(e.LONGITUD));
									e['DISTANCE_FINAL'] = vm.getDistanceAlt(e.DISTANCE);

									let iconURLA;
									!+e.PREFERENT || 0
										? iconURLA = "/wp-content/themes/mgc/src/img/pin_A.svg"
										: iconURLA = "/wp-content/themes/mgc/src/img/pin_AP.svg"
									let marker = new google.maps.Marker({
										position: {lat: parseFloat(e.LATITUD), lng: parseFloat(e.LONGITUD)},
										map: vm.map,
										icon: iconURLA,
										html: '',
										index: contador,
										preferent: parseInt(e.PREFERENT)
									});
									contador++;
									google.maps.event.addListener(marker, 'click', function () {
										for (var i = 0; i < vm.markers.length-1; i++) {
											let currentMarker = vm.markers[i]
											!+currentMarker.preferent || 0
												? currentMarker.setIcon("/wp-content/themes/mgc/src/img/pin_A.svg")
												: currentMarker.setIcon("/wp-content/themes/mgc/src/img/pin_AP.svg");
											currentMarker.setZIndex(2);
										}

										vm.infoWindow.setContent(vm.$refs['oficina'+marker.index][0].innerHTML);
										//vm.$refs['listaOffice'].scrollTop = vm.$refs['oficina'+marker.index][0].offsetTop;
										!+this.preferent || 0
											? this.setIcon("/wp-content/themes/mgc/src/img/pin_B.svg")
											: this.setIcon("/wp-content/themes/mgc/src/img/pin_BP.svg");
										this.setZIndex(100);
										vm.infoWindow.open(map, marker);
										//vm.map.panTo(new google.maps.LatLng(marker.position.lat(), marker.position.lng()));
										let latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
										vm.map.setCenterWithOffset(latlng, 0, -125);
										setTimeout(()=>{
											let element = document.querySelector('.gm-style');
											let tooltips;
											if (element) {
												tooltips = element.querySelectorAll('[data-toggle="tooltip"]');
												tooltips.forEach(e=>{
													e.addEventListener('mouseover',(event)=>{
														if (window.innerWidth >= 768) {
															$(event.target).tooltip("show");
														}
													});
													//console.log('Add event list')
													e.addEventListener('click',vm.showTooltipModal)
												})
											}
										}, 100)
									});
									vm.markers.push(marker);
								});
								let marker = new google.maps.Marker({
									position: {lat: parseFloat(lat), lng: parseFloat(lng)},
									map: vm.map,
									icon: '/wp-content/themes/mgc/src/img/marcador_01.svg',
									html: '',
									index: contador
								});
								marker.setZIndex(1);
								vm.markers.push(marker);
								$('.office-list').scrollTop(0);
								vm.convertClinicsMobile();
								this.initTooltips();

							} else {
								vm.mapEmpty();
								this.offices = [];

							}
							this.initTooltips();
						};
						request.send();
					}

				},
				refreshPosition: function(){
					var vm = this;
					var newLat = vm.map.getCenter().lat();
					var newLng = vm.map.getCenter().lng();
					this.refreshMap(newLat, newLng, this.speciality_in, this.specialist)
				},
				cuadroClick: function(){

					if ($(window).width() >= 768) {
						$('html, body').animate({
							scrollTop: ($('.doctor-search-bar').offset().top) - 70
						}, 500);
					}

					var vm = this;
					var spec_el = "";
					var sy_change = false;
					var st_change = false;

					if (this.speciality_in != "") {
						spec_el = vm.specialities.find(function(element){
							return element.CODI_SERV === vm.speciality_in;
						});
					}

					if (this.address != "") {

						if (vm.coords != "") {
							vm.map.setCenter({
								lat : vm.coords.lat(),
								lng : vm.coords.lng()
							});
							vm.refreshMap(vm.coords.lat(), vm.coords.lng(), this.speciality_in, this.specialist);
						}
						vm.main_info = vm.address;
						var spec = "Todas las especialidades";
						if (this.speciality_in != "") {

							spec = spec_el.NOM_SERVEI;
						}
						if (this.specialist != "") {
							spec = spec + ", " + this.specialist;
						}
						vm.extra_info = spec;

					}else{
						var spec = "Todas las especialidades";
						if (this.speciality_in != "") {
							sy_change = true;
							spec = spec_el.NOM_SERVEI;
						}
						if (this.specialist != "") {
							st_change = true;
							spec = spec + ", " + this.specialist;
						}

						if (sy_change || st_change) {
							//Update map with new points
							vm.refreshMap(null, null, this.speciality_in, this.specialist);
							vm.extra_info = spec;
						}
					}

					this.speciality_in_snaked = this.speciality_in.replaceAll(" ", "_");
					this.initTooltips();

					//mecánicas mobile - si hay algún cambio en los inputs, se activa. Si no, no se que hace
					this.isHidden = true;
					this.secStage = true;
					this.minimized = true;
					this.displaying = true;


				},
				ofiClick: function(){
					if ($(window).width() >= 768) {
						$('html, body').animate({
							scrollTop: ($('.office-search-bar').offset().top) - 70
						}, 500);
					}
					var vm = this;

					if (vm.ofiAddress != "") {
						var aux_coords = vm.coords;
						if (aux_coords != "") {
							vm.map.setCenter({
								lat : aux_coords.lat(),
								lng : aux_coords.lng()
							});
							vm.searchClosestOffice(vm.coords);
							aux_coords = "";
						}else{
							var geocoder = new google.maps.Geocoder();
							geocoder.geocode({
								address: vm.ofiAddress, componentRestrictions:{country:'ES'}
							}, function(results, status){
								if (status == google.maps.GeocoderStatus.OK) {
									var location = results[0].geometry.location;
									vm.map.setCenter({
										lat : location.lat(),
										lng : location.lng()
									});
									vm.searchClosestOffice(location);
								}
								if (status == google.maps.GeocoderStatus.ZERO_RESULTS) {
									console.log('Empty!!!');
								}
							});
						}
					}
					//mecánicas mobile - si hay algún cambio en los inputs, se activa. Si no, no se que hace
					if (true) {
						this.isHidden = true;
						this.minimized = true;
						this.displaying = true;
					}
				},
				convertClinicsMobile: function(){
					this.isHidden = true;
					this.secStage = true;
					this.minimized = true;
					this.displaying = true;
				},
				newSearchClick: function(){
					this.isHidden = false;
					this.secStage = false;
					this.minimized = false;
					this.displaying = false;

				},
				cleanCoords: function(){
					this.coords = "";
				},
				searchClosestOffice: function(location){
					var vm = this;
					var min_d = 100000;
					var index;
					var counter = 0;
					var officeSel = ""
					vm.offices.forEach(function(e){
						let lat_dest = parseFloat(e.LATITUD);
						let lng_dest = parseFloat(e.LONGITUD);
						var R = 6371; // Radius of the earth in km
						var dLat = (lat_dest-location.lat()) * (Math.PI/180);  // deg2rad below
						var dLon = (lng_dest-location.lng()) * (Math.PI/180);
						var a =
							Math.sin(dLat/2) * Math.sin(dLat/2) +
							Math.cos((location.lat()) * (Math.PI/180)) * Math.cos((lat_dest) * (Math.PI/180)) *
							Math.sin(dLon/2) * Math.sin(dLon/2)
						;
						var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
						var d = R * c;
						if (d < min_d) {
							min_d = d;
							index = counter;
							officeSel = e;
						}
						counter = counter + 1;
					});
					vm.seleccionaOficina(officeSel,index);
					vm.closestOfficeCity = officeSel.DESC_OFICINA;
					vm.closestOfficeAddress = officeSel.DIRECCIO;
					$('.office-list').scrollTop((vm.$refs['oficina'+ index][0].offsetTop) - 40);
				},
				openSideSpecialities: function(oficina){
					var vm = this;
					vm.selOffice = oficina;

					vm.isMoved = true;
				},
				returnToOffices: function(){
					var vm = this;
					vm.isMoved = false;
					vm.reset = true;
				},
				getDistanceAlt: function(dist){
					var distance;
					//console.log(dist);
					if (dist < 1){
						let d_alt = dist*1000;
						//console.log(d_alt);
						distance = d_alt.toFixed().toString() + ' m';
						//console.log(distance);
					}else{
						let d_alt = dist*1;
						distance = d_alt.toFixed(2).toString() + ' km';
						//console.log(distance);
					}
					return distance;
				},
				getDistance: function(localLat, localLng, officeLat, officeLng){
					var R = 6371;
					var dLat = (officeLat - localLat) * (Math.PI/180);
					var dLng = (officeLng - localLng) * (Math.PI/180);
					var a =
						Math.sin(dLat/2) * Math.sin(dLat/2) +
						Math.cos((localLat) * (Math.PI/180)) * Math.cos((officeLat) * (Math.PI/180)) *
						Math.sin(dLng/2) * Math.sin(dLng/2)
					;
					var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
					var d = R * c;
					var distance;
					if (d < 1){
						let d_alt = d*1000;
						distance = d_alt.toFixed().toString() + ' m';
					}else{
						distance = d.toFixed(2).toString() + ' km';
					}

					return distance;
				},
				initTooltips: function() {
					var vm = this;
					$('[data-toggle="tooltip"]').on('mouseover', function(event){
						if (window.innerWidth >= 768) {
							$(event.target).tooltip("show");
						}
					});
					$('[data-toggle="tooltip"]').on('click', vm.showTooltipModal);
				},
				showTooltipModal: function(event){
					event.preventDefault();
					if (window.innerWidth < 768) {
						event.stopPropagation();
						$('#mapModal').modal('hide');
						this.openTooltipModal = true;
						this.tooltipContent = event.target.title;
					}
				},
				closeTooltipModal: function(){
					this.openTooltipModal = false;
				}
			}
		});


	}
	if ($('#contact_map').length) {
		$(document).ready(function(){
			if ($(window).width() <= 767) {
				$('#contact_map_mobile').append($("#contact_map"));
			}
		});
		function initContactMap(){
			var myStyles =[
			    {
			        featureType: "poi",
			        elementType: "labels",
			        stylers: [
			              { visibility: "off" }
			        ]
			    }
			];
			var geocoder = new google.maps.Geocoder();

			geocoder.geocode({
				address: 'C/Tuset 5, 08006 Barcelona', componentRestrictions:{country:'ES'}
			}, function(results, status){
				if (status == google.maps.GeocoderStatus.OK) {
					var contact_map = new google.maps.Map((document.getElementById("contact_map")), {
						zoom: 15,
						center: results[0].geometry.location,
						disableDefaultUI: true,
						clickableIcons: false,
						styles: myStyles
					});
					var marker = new google.maps.Marker({
						position: results[0].geometry.location,
						map: contact_map,
						icon: "/wp-content/themes/mgc/src/img/pin_B.svg"
					});
				}
			});
		}
		google.maps.event.addDomListener(window, 'load', initContactMap);
	}
});

$( document ).ready(function() {
	$(function(){
		if ($('#bannerBackground').length) {
			var backFrame = $('iframe#bannerBackground');
			window.backPlayer = new Vimeo.Player(backFrame);
			backPlayer.play();
		}
		if ($('#videoModal').length) {
			$('footer').append($('#videoModal'));
			setTimeout(() => {
				var frame = document.querySelector('iframe#promotionVideo');
				var vidsrc = frame.src;
				var player = new Vimeo.Player(frame);
				//console.log(player)
				//console.log($('#videoModal'))
				$('#videoModal').on('show.bs.modal', function(e) {
					//console.log("modal did open")
					if (window.backPlayer) {
						window.backPlayer.pause();
					}
					player.play();
				});
				$('#videoModal').on('hide.bs.modal', function(e) {
					//console.log("modal did close")
					frame.src = '';
					frame.src = vidsrc;
					if (window.backPlayer) {
						window.backPlayer.play();
					}
				});
			}, 100);
		}
		if ($('#videoModal_banner').length) {
			$('footer').append($('#videoModal_banner'));
			setTimeout(() => {
				var frame_banner = document.querySelector('iframe#promotionVideo_banner');
				var vidsrc_banner = frame_banner.src;
				var player_banner = new Vimeo.Player(frame_banner);
				$('#videoModal_banner').on('show.bs.modal', function(e) {
					if (window.backPlayer) {
						window.backPlayer.pause();
					}
					player_banner.play();
				});
				$('#videoModal_banner').on('hide.bs.modal', function(e) {
					frame_banner.src = '';
					frame_banner.src = vidsrc_banner;
					if (window.backPlayer) {
						window.backPlayer.play();
					}
				});
			}, 100);
		}
	});
});

function stick_header(){
	var window_top = $(window).scrollTop();
	if (window_top > 40 ) {
		$('.nav-main').addClass('fixed');
		$('.site-content').addClass('scrolled');
    } else {
        $('.nav-main').removeClass('fixed');
		$('.site-content').removeClass('scrolled');
    }
}
function findObjectByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
            return array[i];
        }
    }
    return null;
}




function getLatLngByZipcode(zipcode, callback)
{
	const zipcodeExceptions = [
		{
			zip: '08611',
			town_name: 'Olvan'
		}
	]
	var latitude = '';
	var longitude = '';
	var geocoder = new google.maps.Geocoder();

	if (zipcodeExceptions.filter((v) => (v.zip === zipcode.toString())).length === 0) {
		geocoder.geocode({
			componentRestrictions: {
				country: 'ES',
				postalCode: zipcode
			}
		}, function (results, status) {
			/* console.log(status)
			console.log(results) */
			if (status == google.maps.GeocoderStatus.OK) {
				latitude = results[0].geometry.location.lat();
				longitude = results[0].geometry.location.lng();
				callback(latitude, longitude);
			} else {
				alert("Request failed.")
			}
		});
	}else{
		geocoder.geocode({
			address: 'Olvan',
			componentRestrictions: {
				country: 'ES'
			}
		}, function (results, status) {
			/* console.log(status)
			console.log(results) */
			if (status == google.maps.GeocoderStatus.OK) {
				latitude = results[0].geometry.location.lat();
				longitude = results[0].geometry.location.lng();
				callback(latitude, longitude);
			} else {
				alert("Request failed.")
			}
		});
	}

}
function getZipcodeByLatLng(lat, lng, callback)
{
	var zipcode
	const latlng = {
		lat: parseFloat(lat),
		lng: parseFloat(lng),
	  };
	  var geocoder = new google.maps.Geocoder();
	  geocoder.geocode({ location: latlng, componentRestrictions:{country:'ES'} }, (results, status) => {
		if (status === "OK") {
		  if (results[0]) {
			var decodedAddress = results[0].address_components;
			var zipcode;
			decodedAddress.forEach(comp => {
				if (comp.types[0] == "postal_code") {
				zipcode = comp.short_name;
			  }
			});
			callback(zipcode);

		  } else {
			//window.alert("No results found");
			callback(-1);
		  }
		} else {
		  //window.alert("Geocoder failed due to: " + status);
		  callback(-1);
		}
	  });
}

function isValidJSON(json) {
	try {
	  JSON.parse(json);
	  return true;
	} catch (error) {
	  return false;
	}
}




//Funciones tarificador
import Datepicker from 'vuejs-datepicker';
import {es, ca} from 'vuejs-datepicker/dist/locale';


$(function(){
	console.log('initializing tarificador')
	if($('.tarificador-module').length){
		var tariff_app = new Vue({
			el: '.tarificador-module',
			data: {
				tarificador_people_number: 0,
				tarif_zipcode: "",
				tarif_phone: "",
				tarif_birthdate: "",
				output_date: "",
				selectPlaceholder: true,
				tarif_num_people_error: false,
				tarif_zipcode_error: false,
				tarif_zipcode_empty: false,
				tarif_phone_error: false,
				tarif_birthdate_error: false,
				tarif_birthdate_error_alt: false,
				people_select_options: [],
				disabledDates: {
					from: new Date
				},
				dateToOpen: new Date,
				es: es,
				ca: ca

			},
			components: {
				Datepicker
			},
			mounted(){
				console.log('Component did mount');
				this.disabledDates = {
					from: this.calculateLastDate()
				}
				this.dateToOpen = this.calculateLastDate()
				for (let index = 1; index < 16; index++) {
					this.people_select_options[index-1] = (index + 1);
				}
				if(sessionStorage.getItem('insured_list')){
					sessionStorage.removeItem('insured_list')
				}
			},
			updated(){

			},
			methods:{
				calculateLastDate: function(){
					let date = new Date();
					//console.log(date)
					date.setFullYear(date.getFullYear() - 18);
					//console.log(date)
					return date
				},
				rateCalculationHome: function(event){
					if (this.tarificador_people_number === 1){
						this.rateCalculationOne(event);
					}else{
						this.rateCalculationOptim(event);
					}
				},
				rateCalculationTotal: function(event){
					if (this.tarificador_people_number != 0 && this.tarif_zipcode!="" && this.checkZipcode(this.tarif_zipcode) && this.tarif_phone!="" && this.tarif_birthdate!="" && this.getAge(this.tarif_birthdate) >= 18 ){
						sessionStorage.setItem('tarificador_num_people', this.tarificador_people_number);
						sessionStorage.setItem('tarificador_zipcode', this.tarif_zipcode);
						sessionStorage.setItem('tarificador_phone', this.tarif_phone);
						sessionStorage.setItem('tarificador_birthdate', this.tarif_birthdate);
						sessionStorage.setItem('insurance_type', "total");
					}else{
						event.preventDefault();

						this.tarif_num_people_error = false;
						this.tarif_zipcode_error = false;
						this.tarif_zipcode_empty = false;
						this.tarif_phone_error = false;
						this.tarif_birthdate_error = false;
						if(this.tarificador_people_number==0){this.tarif_num_people_error = true}
						if(this.tarif_zipcode==""){this.tarif_zipcode_empty = true}
						if(this.checkZipcode(this.tarif_zipcode)==false) {this.tarif_zipcode_error = true}
						if(this.tarif_phone==0){this.tarif_phone_error = true}
						if(this.tarif_birthdate==0){this.tarif_birthdate_error = true}
						if (this.getAge(this.tarif_birthdate) != NaN && this.getAge(this.tarif_birthdate) < 18) {
							this.tarif_birthdate_error = true;
							this.tarif_birthdate_error_alt = true
						}
					}

				},
				rateCalculationOne: function(event){
					if (this.tarif_zipcode!="" && this.checkZipcode(this.tarif_zipcode) && this.tarif_phone!="" && this.tarif_birthdate!="" && this.getAge(this.tarif_birthdate) >= 18 ){
						sessionStorage.setItem('tarificador_num_people', 1);
						sessionStorage.setItem('tarificador_zipcode', this.tarif_zipcode);
						sessionStorage.setItem('tarificador_phone', this.tarif_phone);
						sessionStorage.setItem('tarificador_birthdate', this.tarif_birthdate);
						sessionStorage.setItem('insurance_type', "one");
					}else{
						event.preventDefault();
						this.tarif_zipcode_error = false;
						this.tarif_zipcode_empty = false;
						this.tarif_phone_error = false;
						this.tarif_birthdate_error = false;
						if(this.tarif_zipcode==""){this.tarif_zipcode_empty = true}
						if(this.checkZipcode(this.tarif_zipcode)==false) {this.tarif_zipcode_error = true}
						if(this.tarif_phone==0){this.tarif_phone_error = true}
						if(this.tarif_birthdate==0){this.tarif_birthdate_error = true}
						if (this.getAge(this.tarif_birthdate) != NaN && this.getAge(this.tarif_birthdate) < 18) {
							this.tarif_birthdate_error = true;
							this.tarif_birthdate_error_alt = true
						}
					}
				},
				rateCalculationGlobal: function(event){
					if (this.tarificador_people_number != 0 && this.tarif_zipcode!="" && this.checkZipcode(this.tarif_zipcode) && this.tarif_phone!="" && this.tarif_birthdate!="" && this.getAge(this.tarif_birthdate) >= 18 ){
						sessionStorage.setItem('tarificador_num_people', this.tarificador_people_number);
						sessionStorage.setItem('tarificador_zipcode', this.tarif_zipcode);
						sessionStorage.setItem('tarificador_phone', this.tarif_phone);
						sessionStorage.setItem('tarificador_birthdate', this.tarif_birthdate);
						sessionStorage.setItem('insurance_type', "global");
					}else{
						event.preventDefault();

						this.tarif_num_people_error = false;
						this.tarif_zipcode_error = false;
						this.tarif_zipcode_empty = false;
						this.tarif_phone_error = false;
						this.tarif_birthdate_error = false;
						if(this.tarificador_people_number==0){this.tarif_num_people_error = true}
						if(this.tarif_zipcode==""){this.tarif_zipcode_empty = true}
						if(this.checkZipcode(this.tarif_zipcode)==false) {this.tarif_zipcode_error = true}
						if(this.tarif_phone==0){this.tarif_phone_error = true}
						if(this.tarif_birthdate==0){this.tarif_birthdate_error = true}
						if (this.getAge(this.tarif_birthdate) != NaN && this.getAge(this.tarif_birthdate) < 18) {
							this.tarif_birthdate_error = true;
							this.tarif_birthdate_error_alt = true
						}
					}

				},
				rateCalculationExit: function(event){
					if (this.tarificador_people_number != 0 && this.tarif_zipcode!="" && this.checkZipcode(this.tarif_zipcode) && this.tarif_phone!="" && this.tarif_birthdate!="" && this.getAge(this.tarif_birthdate) >= 18 ){
						sessionStorage.setItem('tarificador_num_people', this.tarificador_people_number);
						sessionStorage.setItem('tarificador_zipcode', this.tarif_zipcode);
						sessionStorage.setItem('tarificador_phone', this.tarif_phone);
						sessionStorage.setItem('tarificador_birthdate', this.tarif_birthdate);
						sessionStorage.setItem('insurance_type', "exit");
					}else{
						event.preventDefault();

						this.tarif_num_people_error = false;
						this.tarif_zipcode_error = false;
						this.tarif_zipcode_empty = false;
						this.tarif_phone_error = false;
						this.tarif_birthdate_error = false;
						if(this.tarificador_people_number==0){this.tarif_num_people_error = true}
						if(this.tarif_zipcode==""){this.tarif_zipcode_empty = true}
						if(this.checkZipcode(this.tarif_zipcode)==false) {this.tarif_zipcode_error = true}
						if(this.tarif_phone==0){this.tarif_phone_error = true}
						if(this.tarif_birthdate==0){this.tarif_birthdate_error = true}
						if (this.getAge(this.tarif_birthdate) != NaN && this.getAge(this.tarif_birthdate) < 18) {
							this.tarif_birthdate_error = true;
							this.tarif_birthdate_error_alt = true
						}
					}

				},
				rateCalculationOptim: function(event){
					if (this.tarificador_people_number != 0 && this.tarif_zipcode!="" && this.checkZipcode(this.tarif_zipcode) && this.tarif_phone!="" && this.tarif_birthdate!="" && this.getAge(this.tarif_birthdate) >= 18 ){
						sessionStorage.setItem('tarificador_num_people', this.tarificador_people_number);
						sessionStorage.setItem('tarificador_zipcode', this.tarif_zipcode);
						sessionStorage.setItem('tarificador_phone', this.tarif_phone);
						sessionStorage.setItem('tarificador_birthdate', this.tarif_birthdate);
						sessionStorage.setItem('insurance_type', "optim");
					}else{
						event.preventDefault();

						this.tarif_num_people_error = false;
						this.tarif_zipcode_error = false;
						this.tarif_zipcode_empty = false;
						this.tarif_phone_error = false;
						this.tarif_birthdate_error = false;
						if(this.tarificador_people_number==0){this.tarif_num_people_error = true}
						if(this.tarif_zipcode==""){this.tarif_zipcode_empty = true}
						if(this.checkZipcode(this.tarif_zipcode)==false) {this.tarif_zipcode_error = true}
						if(this.tarif_phone==0){this.tarif_phone_error = true}
						if(this.tarif_birthdate==0){this.tarif_birthdate_error = true}
						if (this.getAge(this.tarif_birthdate) != NaN && this.getAge(this.tarif_birthdate) < 18) {
							this.tarif_birthdate_error = true;
							this.tarif_birthdate_error_alt = true
						}
					}

				},
				rateCalculationFlex: function(event){
					if (this.tarificador_people_number != 0 && this.tarif_zipcode!="" && this.checkZipcode(this.tarif_zipcode) && this.tarif_phone!="" && this.tarif_birthdate!="" && this.getAge(this.tarif_birthdate) >= 18 ){
						sessionStorage.setItem('tarificador_num_people', this.tarificador_people_number);
						sessionStorage.setItem('tarificador_zipcode', this.tarif_zipcode);
						sessionStorage.setItem('tarificador_phone', this.tarif_phone);
						sessionStorage.setItem('tarificador_birthdate', this.tarif_birthdate);
						sessionStorage.setItem('insurance_type', "flex");
					}else{
						event.preventDefault();

						this.tarif_num_people_error = false;
						this.tarif_zipcode_error = false;
						this.tarif_zipcode_empty = false;
						this.tarif_phone_error = false;
						this.tarif_birthdate_error = false;
						if(this.tarificador_people_number==0){this.tarif_num_people_error = true}
						if(this.tarif_zipcode==""){this.tarif_zipcode_empty = true}
						if(this.checkZipcode(this.tarif_zipcode)==false) {this.tarif_zipcode_error = true}
						if(this.tarif_phone==0){this.tarif_phone_error = true}
						if(this.tarif_birthdate==0){this.tarif_birthdate_error = true}
						if (this.getAge(this.tarif_birthdate) != NaN && this.getAge(this.tarif_birthdate) < 18) {
							this.tarif_birthdate_error = true;
							this.tarif_birthdate_error_alt = true
						}
					}

				},
				rateCalculationEssencial: function(event){
					if (this.tarificador_people_number != 0 && this.tarif_zipcode!="" && this.checkZipcode(this.tarif_zipcode) && this.tarif_phone!="" && this.tarif_birthdate!="" && this.getAge(this.tarif_birthdate) >= 18 ){
						sessionStorage.setItem('tarificador_num_people', this.tarificador_people_number);
						sessionStorage.setItem('tarificador_zipcode', this.tarif_zipcode);
						sessionStorage.setItem('tarificador_phone', this.tarif_phone);
						sessionStorage.setItem('tarificador_birthdate', this.tarif_birthdate);
						sessionStorage.setItem('insurance_type', "essencial");
					}else{
						event.preventDefault();

						this.tarif_num_people_error = false;
						this.tarif_zipcode_error = false;
						this.tarif_zipcode_empty = false;
						this.tarif_phone_error = false;
						this.tarif_birthdate_error = false;
						if(this.tarificador_people_number==0){this.tarif_num_people_error = true}
						if(this.tarif_zipcode==""){this.tarif_zipcode_empty = true}
						if(this.checkZipcode(this.tarif_zipcode)==false) {this.tarif_zipcode_error = true}
						if(this.tarif_phone==0){this.tarif_phone_error = true}
						if(this.tarif_birthdate==0){this.tarif_birthdate_error = true}
						if (this.getAge(this.tarif_birthdate) != NaN && this.getAge(this.tarif_birthdate) < 18) {
							this.tarif_birthdate_error = true;
							this.tarif_birthdate_error_alt = true
						}
					}
				},
				getAge: function(dateString) {
					var today = new Date();
					var birthDate = new Date(dateString);
					var age = today.getFullYear() - birthDate.getFullYear();
					var m = today.getMonth() - birthDate.getMonth();
					if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
						age--;
					}
					return age;
				},
				fechaSeleccionada: function(){
					this.$nextTick(() => {
						let date = this.tarif_birthdate;
						let day = date.getDate();
						let month = date.getMonth() + 1;
						let year = date.getFullYear();

						if(month < 10){
							this.output_date = `${day}/0${month}/${year}`;
						}else{
							this.output_date =`${day}/${month}/${year}`;
						}
					});
				},
				selectChange: function(event){
					if(this.tarificador_people_number != 0){
						this.selectPlaceholder = false;
					}
				},
				checkZipcode: function(zipcode){
					let result = false;
					zipcode = zipcode.toString().toUpperCase();
					let first_chars = zipcode.substring(0, 2);
					let last_chars = zipcode.substring(2);
					let checkAgainst = [
						{CODI_PROVINCIA: "01", PROVINCIA: "Alava"},
						{CODI_PROVINCIA: "02", PROVINCIA: "Albacete"},
						{CODI_PROVINCIA: "03", PROVINCIA: "Alicante"},
						{CODI_PROVINCIA: "04", PROVINCIA: "Almeria"},
						{CODI_PROVINCIA: "AD", PROVINCIA: "Andorra"},
						{CODI_PROVINCIA: "05", PROVINCIA: "Avila"},
						{CODI_PROVINCIA: "06", PROVINCIA: "Badajoz"},
						{CODI_PROVINCIA: "07", PROVINCIA: "Balears"},
						{CODI_PROVINCIA: "08", PROVINCIA: "Barcelona"},
						{CODI_PROVINCIA: "09", PROVINCIA: "Burgos"},
						{CODI_PROVINCIA: "10", PROVINCIA: "Caceres"},
						{CODI_PROVINCIA: "11", PROVINCIA: "Cadiz"},
						{CODI_PROVINCIA: "12", PROVINCIA: "Castellon"},
						{CODI_PROVINCIA: "13", PROVINCIA: "Ciudad Real"},
						{CODI_PROVINCIA: "14", PROVINCIA: "Cordoba"},
						{CODI_PROVINCIA: "16", PROVINCIA: "Cuenca"},
						{CODI_PROVINCIA: "17", PROVINCIA: "Girona"},
						{CODI_PROVINCIA: "18", PROVINCIA: "Granada"},
						{CODI_PROVINCIA: "19", PROVINCIA: "Guadalajara"},
						{CODI_PROVINCIA: "20", PROVINCIA: "Guipuzcoa"},
						{CODI_PROVINCIA: "21", PROVINCIA: "Huelva"},
						{CODI_PROVINCIA: "22", PROVINCIA: "Huesca"},
						{CODI_PROVINCIA: "23", PROVINCIA: "Jaen"},
						{CODI_PROVINCIA: "15", PROVINCIA: "La Coruña"},
						{CODI_PROVINCIA: "35", PROVINCIA: "Las Palmas"},
						{CODI_PROVINCIA: "24", PROVINCIA: "Leon"},
						{CODI_PROVINCIA: "25", PROVINCIA: "Lleida"},
						{CODI_PROVINCIA: "26", PROVINCIA: "Logroño"},
						{CODI_PROVINCIA: "27", PROVINCIA: "Lugo"},
						{CODI_PROVINCIA: "28", PROVINCIA: "Madrid"},
						{CODI_PROVINCIA: "29", PROVINCIA: "Malaga"},
						{CODI_PROVINCIA: "30", PROVINCIA: "Murcia"},
						{CODI_PROVINCIA: "31", PROVINCIA: "Navarra"},
						{CODI_PROVINCIA: "32", PROVINCIA: "Orense"},
						{CODI_PROVINCIA: "33", PROVINCIA: "Oviedo"},
						{CODI_PROVINCIA: "34", PROVINCIA: "Palencia"},
						{CODI_PROVINCIA: "36", PROVINCIA: "Pontevedra"},
						{CODI_PROVINCIA: "37", PROVINCIA: "Salamanca"},
						{CODI_PROVINCIA: "39", PROVINCIA: "Santander"},
						{CODI_PROVINCIA: "40", PROVINCIA: "Segovia"},
						{CODI_PROVINCIA: "41", PROVINCIA: "Sevilla"},
						{CODI_PROVINCIA: "42", PROVINCIA: "Soria"},
						{CODI_PROVINCIA: "43", PROVINCIA: "Tarragona"},
						{CODI_PROVINCIA: "38", PROVINCIA: "Tenerife"},
						{CODI_PROVINCIA: "44", PROVINCIA: "Teruel"},
						{CODI_PROVINCIA: "45", PROVINCIA: "Toledo"},
						{CODI_PROVINCIA: "46", PROVINCIA: "Valencia"},
						{CODI_PROVINCIA: "47", PROVINCIA: "Valladolid"},
						{CODI_PROVINCIA: "48", PROVINCIA: "Vizcaya"},
						{CODI_PROVINCIA: "49", PROVINCIA: "Zamora"},
						{CODI_PROVINCIA: "50", PROVINCIA: "Zaragoza"}
					];
					if(zipcode.length === 0){
						result = true;
					}else{
						if (zipcode.length === 5 && checkAgainst.find(item=>item.CODI_PROVINCIA === first_chars) !== undefined && /^\d+$/.test(last_chars)) {
							result = true;
						}
					}
					return result;
				}
			}
		});
	}
});

$(function(){
	if($('.page-calcula-precio-tarificador').length){
		var price_calculation_page_app = new Vue({
			el: '.page-calcula-precio-tarificador',
			data: {
				parentius_list: [],
				selected_people_number: sessionStorage.getItem('tarificador_num_people') - 1, //number of people selected in the tarificador_module - 1 (the one that's contracting)
				loading: false,
				loadingComplete: false,
				loadingError: false,
				loadingAnnotation: 0,
				typeTrigger: "",
				productCode: "",
				output_link: "",
				disabledDates: {
					from: new Date
				},
				disabledDatesTomador: {
					from: new Date
				},
				es: es,
				ca: ca,


				tomador_object: {
					birthdate: "",
					formated_birthdate: "",
					zipcode: sessionStorage.getItem('tarificador_zipcode'),
					phone_number: sessionStorage.getItem('tarificador_phone'),
					parentiu: "01"
				},
				insured_array:[],

				export_array: {
					birthdates: [],
					parentius: []
				},

				tomador_birthdate_error: false,
				tomador_zipcode_error: false,
				tomador_phone_error: false

			},
			components: {
				Datepicker
			},
			mounted(){
				this.loading = false;
				this.loadingComplete = false;
				this.typeTrigger = sessionStorage.getItem('insurance_type');
				this.tomador_object.birthdate = new Date(sessionStorage.getItem('tarificador_birthdate'));
				this.reformatDateTomador();
				this.output_link = window.output_link;

				this.disabledDatesTomador = {
					from: this.calculateLastDate()
				}
				if(this.typeTrigger=="one"){
					this.productCode = "0067";
					this.$nextTick(() => {
						let export_array= {
							birthdates: [this.tomador_object.formated_birthdate],
							parentius: [this.tomador_object.parentiu]
						}
						this.generateInsuranceKey(export_array);
					});
				}else if(this.typeTrigger=="total"){
					this.productCode = "0001";
					this.recoverParentius();

					let insured_array_input = JSON.parse(sessionStorage.getItem('insured_list'));
					if(insured_array_input){
						for (let index = 0; index < insured_array_input.length; index++) {
							this.insured_array.push(insured_array_input[index]);
						}
					}else{
						for (let index = 0; index < this.selected_people_number; index++) {
							this.insured_array.push({
								birthdate: "",
								formated_birthdate: "",
								parentiu: "00",
								selectPlaceholder: true,
								birthday_input_error: false,
								parentius_input_error: false
							})
						}
					}
				}else if(this.typeTrigger=="global"){
					this.productCode = "0042";
					this.recoverParentius();

					let insured_array_input = JSON.parse(sessionStorage.getItem('insured_list'));
					if(insured_array_input){
						for (let index = 0; index < insured_array_input.length; index++) {
							this.insured_array.push(insured_array_input[index]);
						}
					}else{
						for (let index = 0; index < this.selected_people_number; index++) {
							this.insured_array.push({
								birthdate: "",
								formated_birthdate: "",
								parentiu: "00",
								selectPlaceholder: true,
								birthday_input_error: false,
								parentius_input_error: false
							})
						}
					}
				}else if(this.typeTrigger=="exit"){
					this.productCode = "0078";
					this.recoverParentius();

					let insured_array_input = JSON.parse(sessionStorage.getItem('insured_list'));
					if(insured_array_input){
						for (let index = 0; index < insured_array_input.length; index++) {
							this.insured_array.push(insured_array_input[index]);
						}
					}else{
						for (let index = 0; index < this.selected_people_number; index++) {
							this.insured_array.push({
								birthdate: "",
								formated_birthdate: "",
								parentiu: "00",
								selectPlaceholder: true,
								birthday_input_error: false,
								parentius_input_error: false
							})
						}
					}
				}else if(this.typeTrigger=="optim"){
					this.productCode = "0079";
					this.recoverParentius();

					let insured_array_input = JSON.parse(sessionStorage.getItem('insured_list'));
					if(insured_array_input){
						for (let index = 0; index < insured_array_input.length; index++) {
							this.insured_array.push(insured_array_input[index]);
						}
					}else{
						for (let index = 0; index < this.selected_people_number; index++) {
							this.insured_array.push({
								birthdate: "",
								formated_birthdate: "",
								parentiu: "00",
								selectPlaceholder: true,
								birthday_input_error: false,
								parentius_input_error: false
							})
						}
					}
				}else if(this.typeTrigger=="flex"){
					this.productCode = "0088";
					this.recoverParentius();

					let insured_array_input = JSON.parse(sessionStorage.getItem('insured_list'));
					if(insured_array_input){
						for (let index = 0; index < insured_array_input.length; index++) {
							this.insured_array.push(insured_array_input[index]);
						}
					}else{
						for (let index = 0; index < this.selected_people_number; index++) {
							this.insured_array.push({
								birthdate: "",
								formated_birthdate: "",
								parentiu: "00",
								selectPlaceholder: true,
								birthday_input_error: false,
								parentius_input_error: false
							})
						}
					}
				}else if(this.typeTrigger=="essencial"){
					this.productCode = "0085";
					this.recoverParentius();

					let insured_array_input = JSON.parse(sessionStorage.getItem('insured_list'));
					if(insured_array_input){
						for (let index = 0; index < insured_array_input.length; index++) {
							this.insured_array.push(insured_array_input[index]);
						}
					}else{
						for (let index = 0; index < this.selected_people_number; index++) {
							this.insured_array.push({
								birthdate: "",
								formated_birthdate: "",
								parentiu: "00",
								selectPlaceholder: true,
								birthday_input_error: false,
								parentius_input_error: false
							})
						}
					}
				}
			},
			updated(){

			},
			methods: {
				calculateLastDate: function(){
					let date = new Date();
					//console.log(date)
					date.setFullYear(date.getFullYear() - 18);
					//console.log(date)
					return date
				},
				generateExportArray: function(event){
					let ins_arr = this.insured_array;
					let exit = false;
					event.preventDefault();
					//set error flags to false
					this.tomador_birthdate_error = false;
					this.tomador_zipcode_error= false;
					this.tomador_phone_error = false;
					for (let i = 0; i < ins_arr.length; i++) {
						ins_arr[i].birthday_input_error = false;
						ins_arr[i].parentius_input_error = false;
					}
					//check error flags
					if(this.tomador_object.formated_birthdate=="" || this.tomador_object.formated_birthdate==null){this.tomador_birthdate_error = true}
					if(this.tomador_object.zipcode=="" || this.tomador_object.zipcode==null || !this.checkZipcode(this.tomador_object.zipcode)){this.tomador_zipcode_error = true}
					if(this.tomador_object.phone_number=="" || this.tomador_object.phone_number==null){this.tomador_phone_error = true}
					for (let i = 0; i < ins_arr.length; i++) {
						if(ins_arr[i].formated_birthdate==""){ins_arr[i].birthday_input_error = true}
						if(ins_arr[i].parentiu=="00"){ins_arr[i].parentius_input_error = true}
					}
					if(
						!this.tomador_birthdate_error
						&&
						!this.tomador_zipcode_error
						&&
						!this.tomador_phone_error
						&&
						ins_arr.filter(function(x){return x.formated_birthdate==""}).length == 0
						&&
						ins_arr.filter(function(x){return x.parentiu=="00"}).length == 0
					)
					{
						exit = true;
					}

					if(exit){
						this.export_array = {
							birthdates: [],
							parentius: []
						}
						this.export_array.birthdates.push(this.tomador_object.formated_birthdate);
						this.export_array.parentius.push(this.tomador_object.parentiu);
						for (let i = 0; i < ins_arr.length; i++) {
							this.export_array.birthdates.push(ins_arr[i].formated_birthdate);
							this.export_array.parentius.push(ins_arr[i].parentiu);
						}

						this.generateInsuranceKey(this.export_array);
					}
				},
				reformatDateTomador: function(){
					this.$nextTick(() => {
						let date = this.tomador_object.birthdate;
						let day = date.getDate();
						let month = date.getMonth() + 1;
						let year = date.getFullYear();

						if(day < 10){
							this.tomador_object.formated_birthdate = `0${day}/`
						}else{
							this.tomador_object.formated_birthdate = `${day}/`
						}
						if(month < 10){
							this.tomador_object.formated_birthdate = this.tomador_object.formated_birthdate + `0${month}/${year}`;
						}else{
							this.tomador_object.formated_birthdate = this.tomador_object.formated_birthdate + `${month}/${year}`;
						}
					});
				},
				reformatDateInsured: function(i){
					this.$nextTick(() => {
						let date = this.insured_array[i].birthdate;
						let day = date.getDate();
						let month = date.getMonth() + 1;
						let year = date.getFullYear();

						if(day < 10){
							this.insured_array[i].formated_birthdate = `0${day}/`
						}else{
							this.insured_array[i].formated_birthdate = `${day}/`
						}
						if(month < 10){
							this.insured_array[i].formated_birthdate = this.insured_array[i].formated_birthdate + `0${month}/${year}`;
						}else{
							this.insured_array[i].formated_birthdate = this.insured_array[i].formated_birthdate + `${month}/${year}`;
						}
					});
				},
				recoverParentius: function(){
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverParentius&lang='+lang_code;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{ data = JSON.parse(request.response); }
						catch (e)
							{ responseQuality = false; }
						if (responseQuality) {
							this.parentius_list = data;
						}
					}
					request.send();
				},
				calculateInsuredIndex: function(index){
					return index + 2;
				},
				selectChange: function(event, idx){
					if(this.insured_array[idx].parentiu != "00"){
						this.insured_array[idx].selectPlaceholder = false;
					}
				},
				addNewFamiliar: function(event){
					event.preventDefault();
					if(this.insured_array.length<15){
						this.insured_array.push({
							birthdate: "",
							formated_birthdate: "",
							parentiu: "00",
							selectPlaceholder: true,
							birthday_input_error: false,
							parentius_input_error: false
						});
						this.selected_people_number = this.selected_people_number + 1;
					}
				},
				deleteSelectedFamiliar: function(event, idx){
					event.preventDefault();
					this.insured_array.splice(idx, 1);
					this.selected_people_number = this.selected_people_number - 1;
				},
				generateInsuranceKey: function(exportArr){
					let app = this;
					app.loading = true;

					let persones = app.selected_people_number + 1;
					let data_input = {
						codiPostal: app.tomador_object.zipcode,
						numPersones: persones.toString(),
						data_naix: exportArr.birthdates,
						parentiu: exportArr.parentius,
						producte: app.productCode
					}

					//CURL petition

					app.changeAnnotation();

					let request = new XMLHttpRequest();
					//let url = '/wp-content/themes/mgc/curl_petition.php?petition=generateTariff&lang='+lang_code+"&dataInput="+JSON.stringify(data_input);
					let url = "/wp-content/themes/mgc/curl_petition.php?petition=generateTariff&lang="+lang_code+"&codiPostal="+data_input.codiPostal +"&numPersones="+data_input.numPersones+"&data_naix="+data_input.data_naix+"&parentiu="+data_input.parentiu+"&producte="+data_input.producte;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{ data = JSON.parse(request.response); }
						catch (e)
							{ responseQuality = false }
						if (responseQuality) {
							if (data.resultat) {
								app.loadingComplete = true;
								sessionStorage.setItem('tariff_results', JSON.stringify(data.resultat));
								sessionStorage.setItem('insured_list', JSON.stringify(app.insured_array));
								sessionStorage.setItem('tarificador_num_people', app.selected_people_number + 1);
								sessionStorage.setItem('tarificador_zipcode', app.tomador_object.zipcode);
								sessionStorage.setItem('tarificador_phone', app.tomador_object.phone_number);
								window.location = app.output_link;
							}else{
								if(data.status=="204"){
									app.loadingComplete = true;
									app.loadingError = true;
								}
							}
						}
					}
					request.send();
				},
				changeAnnotation: function(){
					let app = this;
					setInterval(function(){
						if(app.loadingAnnotation < 3){
							app.loadingAnnotation = app.loadingAnnotation + 1;
						}else{
							app.loadingAnnotation = 0;
						}

					}, 5000);
				},
				checkZipcode: function(zipcode){
					let result = false;
					zipcode = zipcode.toString().toUpperCase();
					let first_chars = zipcode.substring(0, 2);
					let last_chars = zipcode.substring(2);
					let checkAgainst = [
						{CODI_PROVINCIA: "01", PROVINCIA: "Alava"},
						{CODI_PROVINCIA: "02", PROVINCIA: "Albacete"},
						{CODI_PROVINCIA: "03", PROVINCIA: "Alicante"},
						{CODI_PROVINCIA: "04", PROVINCIA: "Almeria"},
						{CODI_PROVINCIA: "AD", PROVINCIA: "Andorra"},
						{CODI_PROVINCIA: "05", PROVINCIA: "Avila"},
						{CODI_PROVINCIA: "06", PROVINCIA: "Badajoz"},
						{CODI_PROVINCIA: "07", PROVINCIA: "Balears"},
						{CODI_PROVINCIA: "08", PROVINCIA: "Barcelona"},
						{CODI_PROVINCIA: "09", PROVINCIA: "Burgos"},
						{CODI_PROVINCIA: "10", PROVINCIA: "Caceres"},
						{CODI_PROVINCIA: "11", PROVINCIA: "Cadiz"},
						{CODI_PROVINCIA: "12", PROVINCIA: "Castellon"},
						{CODI_PROVINCIA: "13", PROVINCIA: "Ciudad Real"},
						{CODI_PROVINCIA: "14", PROVINCIA: "Cordoba"},
						{CODI_PROVINCIA: "16", PROVINCIA: "Cuenca"},
						{CODI_PROVINCIA: "17", PROVINCIA: "Girona"},
						{CODI_PROVINCIA: "18", PROVINCIA: "Granada"},
						{CODI_PROVINCIA: "19", PROVINCIA: "Guadalajara"},
						{CODI_PROVINCIA: "20", PROVINCIA: "Guipuzcoa"},
						{CODI_PROVINCIA: "21", PROVINCIA: "Huelva"},
						{CODI_PROVINCIA: "22", PROVINCIA: "Huesca"},
						{CODI_PROVINCIA: "23", PROVINCIA: "Jaen"},
						{CODI_PROVINCIA: "15", PROVINCIA: "La Coruña"},
						{CODI_PROVINCIA: "35", PROVINCIA: "Las Palmas"},
						{CODI_PROVINCIA: "24", PROVINCIA: "Leon"},
						{CODI_PROVINCIA: "25", PROVINCIA: "Lleida"},
						{CODI_PROVINCIA: "26", PROVINCIA: "Logroño"},
						{CODI_PROVINCIA: "27", PROVINCIA: "Lugo"},
						{CODI_PROVINCIA: "28", PROVINCIA: "Madrid"},
						{CODI_PROVINCIA: "29", PROVINCIA: "Malaga"},
						{CODI_PROVINCIA: "30", PROVINCIA: "Murcia"},
						{CODI_PROVINCIA: "31", PROVINCIA: "Navarra"},
						{CODI_PROVINCIA: "32", PROVINCIA: "Orense"},
						{CODI_PROVINCIA: "33", PROVINCIA: "Oviedo"},
						{CODI_PROVINCIA: "34", PROVINCIA: "Palencia"},
						{CODI_PROVINCIA: "36", PROVINCIA: "Pontevedra"},
						{CODI_PROVINCIA: "37", PROVINCIA: "Salamanca"},
						{CODI_PROVINCIA: "39", PROVINCIA: "Santander"},
						{CODI_PROVINCIA: "40", PROVINCIA: "Segovia"},
						{CODI_PROVINCIA: "41", PROVINCIA: "Sevilla"},
						{CODI_PROVINCIA: "42", PROVINCIA: "Soria"},
						{CODI_PROVINCIA: "43", PROVINCIA: "Tarragona"},
						{CODI_PROVINCIA: "38", PROVINCIA: "Tenerife"},
						{CODI_PROVINCIA: "44", PROVINCIA: "Teruel"},
						{CODI_PROVINCIA: "45", PROVINCIA: "Toledo"},
						{CODI_PROVINCIA: "46", PROVINCIA: "Valencia"},
						{CODI_PROVINCIA: "47", PROVINCIA: "Valladolid"},
						{CODI_PROVINCIA: "48", PROVINCIA: "Vizcaya"},
						{CODI_PROVINCIA: "49", PROVINCIA: "Zamora"},
						{CODI_PROVINCIA: "50", PROVINCIA: "Zaragoza"}
					];
					if (zipcode.length === 5 && checkAgainst.find(item=>item.CODI_PROVINCIA === first_chars) !== undefined && /^\d+$/.test(last_chars)) {
						result = true;
					}
					return result;
				}
			}
		});
	}
});

$(function(){
	if($('.page-tus-precios-tarificador').length){
		var price_display_page_app = new Vue({
			el: '.page-tus-precios-tarificador',
			data: {
				typeTrigger: '',
				returnLinkFlag: false,
				completed: false,
				email: "",
				dataProtectionInput: false,
				email_error: false,
				dataProtect_error: false,
				pageLoaded: false,
				data: '',
				codi: '',
				id: '',
				title: "",
				subtitle: "",
				link_mail: "",
				name_pkg_mail: "",
				description_mail: "",
				coverage: [],
				num_people: 0,

				price_selector: 2,

				total_import_with_copayment: 0.0,
				total_import_without_copayment: 0.0,
				discount_import_with_copayment: 0.0,
				discount_import_without_copayment: 0.0,

				tooltipOpen: false,

				price_units: "",
				price_cents: "",
				email_sent: false,



				global_modality_chosen: 1,		//0-> 150.000 / 1-> 300.000

				price_global_0_total_with_copayment: 0.0,
				price_global_0_total_without_copayment: 0.0,
				price_global_0_discount_with_copayment: 0.0,
				price_global_0_discount_without_copayment: 0.0,

				price_global_1_total_with_copayment: 0.0,
				price_global_1_total_without_copayment: 0.0,
				price_global_1_discount_with_copayment: 0.0,
				price_global_1_discount_without_copayment: 0.0,

				price_global_0_units: "",
				price_global_0_cents: "",

				price_global_1_units: "",
				price_global_1_cents: ""


			},
			mounted(){
				this.typeTrigger = sessionStorage.getItem('insurance_type');
				if(this.typeTrigger!="one"){
					this.returnLinkFlag = true;
				}
				this.num_people = sessionStorage.getItem('tarificador_num_people');
				this.data = JSON.parse(sessionStorage.getItem('tariff_results'));
				if (this.typeTrigger!="global") {
					this.codi = this.data['CODI'];
					this.id = this.data['ID_TARIFA'];
					this.title = this.data['INFORMACIO']['TITOL'];
					this.subtitle = this.data['INFORMACIO']['SUBTITOL'];
					this.link_mail = this.data['INFORMACIO']['LINK_MAIL'];
					this.name_pkg_mail = this.data['INFORMACIO']['NOM_PAQUET_MAIL'];
					this.description_mail = this.data['INFORMACIO']['DESCRIPCIO_MAIL'];
					this.coverage = this.data['INFORMACIO']['COBERTURES'];

					this.total_import_with_copayment = this.data["IMPORT_TOTAL_AMB_COPAGAMENT"];
					this.total_import_without_copayment = this.data["IMPORT_TOTAL_SENSE_COPAGAMENT"];
					this.discount_import_with_copayment = this.data["IMPORT_DESCOMPTE_AMB_COPAGAMENT"];
					this.discount_import_without_copayment = this.data["IMPORT_DESCOMPTE_SENSE_COPAGAMENT"];

					/* console.log("IMPORT_TOTAL_AMB_COPAGAMENT: " +this.total_import_with_copayment);
					console.log("IMPORT_TOTAL_SENSE_COPAGAMENT: " +this.total_import_without_copayment);
					console.log("IMPORT_DESCOMPTE_AMB_COPAGAMENT: " +this.discount_import_with_copayment);
					console.log("IMPORT_DESCOMPTE_SENSE_COPAGAMENT: " +this.discount_import_without_copayment); */

					if(window.price_selector){
						this.price_selector = window.price_selector;
					}
					switch (this.price_selector) {
						case 0:
							this.displayPrice(this.total_import_with_copayment);
							break;
						case 1:
							this.displayPrice(this.total_import_without_copayment);
							break;
						case 2:
							this.displayPrice(this.discount_import_with_copayment);
							break;
						case 3:
							this.displayPrice(this.discount_import_without_copayment);
							break;
						default:
							break;
					}
				}else{
					this.title = this.data[0]['INFORMACIO']['TITOL'];
					this.subtitle = this.data[0]['INFORMACIO']['SUBTITOL'];
					this.link_mail = this.data[0]['INFORMACIO']['LINK_MAIL'];
					this.name_pkg_mail = this.data[0]['INFORMACIO']['NOM_PAQUET_MAIL'];
					this.description_mail = this.data[0]['INFORMACIO']['DESCRIPCIO_MAIL'];
					this.coverage = this.data[0]['INFORMACIO']['COBERTURES'];

					this.price_global_0_total_with_copayment = this.data[0]["IMPORT_TOTAL_AMB_COPAGAMENT"];
					this.price_global_0_total_without_copayment = this.data[0]["IMPORT_TOTAL_SENSE_COPAGAMENT"];
					this.price_global_0_discount_with_copayment = this.data[0]["IMPORT_DESCOMPTE_AMB_COPAGAMENT"];
					this.price_global_0_discount_without_copayment = this.data[0]["IMPORT_DESCOMPTE_SENSE_COPAGAMENT"];

					this.price_global_1_total_with_copayment = this.data[1]["IMPORT_TOTAL_AMB_COPAGAMENT"];
					this.price_global_1_total_without_copayment = this.data[1]["IMPORT_TOTAL_SENSE_COPAGAMENT"];
					this.price_global_1_discount_with_copayment = this.data[1]["IMPORT_DESCOMPTE_AMB_COPAGAMENT"];
					this.price_global_1_discount_without_copayment = this.data[1]["IMPORT_DESCOMPTE_SENSE_COPAGAMENT"];

					let price_export_0;
					let price_export_1;
					if(window.price_selector){
						this.price_selector = window.price_selector;
					}


					switch (this.price_selector) {
						case 0:
							price_export_0 = this.calculateGlobalPrice(this.price_global_0_total_with_copayment);
							price_export_1 = this.calculateGlobalPrice(this.price_global_1_total_with_copayment);
							break;
						case 1:
							price_export_0 = this.calculateGlobalPrice(this.price_global_0_total_without_copayment);
							price_export_1 = this.calculateGlobalPrice(this.price_global_1_total_without_copayment);
							break;
						case 2:
							price_export_0 = this.calculateGlobalPrice(this.price_global_0_discount_with_copayment);
							price_export_1 = this.calculateGlobalPrice(this.price_global_1_discount_with_copayment);
							break;
						case 3:
							price_export_0 = this.calculateGlobalPrice(this.price_global_0_discount_without_copayment);
							price_export_1 = this.calculateGlobalPrice(this.price_global_1_discount_without_copayment);
							break;
						default:
							break;
					}
					this.price_global_0_units = price_export_0.units;
					this.price_global_0_cents = price_export_0.cents;
					this.price_global_1_units = price_export_1.units;
					this.price_global_1_cents = price_export_1.cents;
				}

				this.pageLoaded = true;
			},
			updated(){},
			methods: {
				displayPrice: function(price){
					this.price_units = Math.floor(price);
					let cents = price % 1;
					cents = cents.toFixed(2).substring(2);
					this.price_cents = "," + cents +"€";
				},
				calculateGlobalPrice: function(price){
					let units = Math.floor(price);
					let cents = price % 1;
					cents = cents.toFixed(2).substring(2);

					return {"units": units, "cents": cents};
				},
				triggerPopUp: function(event){
					event.preventDefault();
					event.stopPropagation();
					if (this.tooltipOpen) {
						this.tooltipOpen = false;
					}else{
						this.tooltipOpen = true;
					}

				},
				closePopUp: function(event){
					event.preventDefault();
					event.stopPropagation();
					this.tooltipOpen = false;
				},
				sendEmail: function(event){
					event.preventDefault();
					let app = this;
					app.email_error = false;
					app.dataProtect_error = false;
					let re = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-]+$");
					if(app.email=="" || !re.test(app.email)){app.email_error=true}
					if(!app.dataProtectionInput){app.dataProtect_error=true}
					if(!app.email_error && !app.dataProtect_error){
						app.email_sent = true;
						let request = new XMLHttpRequest();
						let url = "";
						if (this.typeTrigger!="global") {
							url = "/wp-content/themes/mgc/curl_petition.php?petition=sendEmail&lang="+lang_code+"&codiTarifaParticular=" + app.id + "&telefonParticular=" + sessionStorage.getItem('tarificador_phone') + "&emailParticular=" + app.email + "&cpOportunitat=" + sessionStorage.getItem('tarificador_zipcode');
						}else{
							url = "/wp-content/themes/mgc/curl_petition.php?petition=sendEmail&lang="+lang_code+"&codiTarifaParticular=" + app.data[app.global_modality_chosen]['ID_TARIFA'] + "&telefonParticular=" + sessionStorage.getItem('tarificador_phone') + "&emailParticular=" + app.email + "&cpOportunitat=" + sessionStorage.getItem('tarificador_zipcode');
						}

						let responseQuality = true;
						request.open('GET', url);
						request.onload = () => {
							let data;
							try
								{ data = JSON.parse(request.response); }
							catch (e)
								{ responseQuality = false }
							if (responseQuality && data.status===200) {
								app.completed = true;
							}
						}
						request.send();
					}else{
						console.log('validation error');
					}
				}
			}
		});
	}
});

$(function(){
	if($('.page-contratar-seguro').length){
		var contratar_seguro_page_app = new Vue({
			el: '.page-contratar-seguro',
			data: {
				loading: true,
				loadError: false,

				fillComplete: false, //default false
				validationComplete: false, //default false
				confirmLegalConditions: false,

				modalContractDataOpen: false,

				modalLoad: true,
				modalLoadError: false,

				insurance_modality_chosen: 0,
				insurance_price_with_copayment: {
					total: 0,
					units: 0,
					cents: 0
				},
				insurance_price_without_copayment: {
					total: 0,
					units: 0,
					cents: 0
				},

				modalityOpen: true, //default true
				modalityComplete: false, //default false
				contractDataOpen: false, //default false
				contractDataComplete: false, //default false
				bankDetailsOpen: false, //default false

				starter_data: [],
				insuredArr: [],
				insured_state_array: [],
				professions_list: [],
				parentius_list: [],
				idDocType_list: [],
				populations_list: [],
				unique_populations: [],
				nationalities_list: [],
				languages_list:[],
				insurers_list: [],

				product_name: "",

				insurer_selected: "00",

				city_options: [],
				cityDropdownState: false,
				shared_lang: true,
				shared_nationality: true,
				changedInsuranceCompany: 0,
				validationCode: new Array(5),
				validationCode_text: "",
				email_validation_error: false,
				iban: {
					final: "",
					final_dashed: "",
					section1: "",
					section2: "",
					section3: "",
					section4: "",
					section5: "",
					iban_valid: false,
					iban_1_valid: false,
					iban_1_error: false,
					iban_1_success: false,
					iban_2_valid: false,
					iban_2_error: false,
					iban_2_success: false,
					iban_3_valid: false,
					iban_3_error: false,
					iban_3_success: false,
					iban_4_valid: false,
					iban_4_error: false,
					iban_4_success: false,
					iban_5_valid: false,
					iban_5_error: false,
					iban_5_success: false
				},
				ibanTomador: true,
				ibanHolderData:
				{
					name: "",
					first_surname: "",
					second_surname: "",
					zipcode: "",
					city: "",
					street: "",

					validation: {
						name_valid: false,
						first_surname_valid: false,
						second_surname_valid: true,
						zipcode_valid: false,
						city_valid: false,
						street_valid: false
					},

					info_valid: false,

					name_error: false,
					name_success: false,
					first_surname_error: false,
					first_surname_success: false,
					second_surname_error: false,
					second_surname_success: false,
					zipcode_error: false,
					zipcode_success: false,
					city_error: false,
					city_success: false,
					street_error: false,
					street_success: false
				},
				hidden_iban: "0000",
				contract_start_date: "",
				data_input: {
					idTarifa: "",
					codiPostal: "",
					phone: "",
					email: "",
					webData: "",
					contactClient: ""

				},
				idTarifa: "",
				clientContact: "",
				comercial: "",
				colectiu: "",
				periodicitat: "",
				oportunidad: "",
				cpOportunidad: "",
				coverage: []
			},
			mounted(){
				console.log('component did mount');
				let app = this;
				app.recoverProfessions();
				app.recoverIdDocType();
				app.recoverPopulations();
				app.recoverNationalities();
				app.recoverLanguages();
				app.recoverInsurers();
				app.recoverParentius();
				app.$nextTick(function(){
					window.addEventListener('click', function(e){
						app.cityDropdownState = false;
					})
				})

			},
			methods:{
				loadData: function(){

					//Ejemplo URL: https://www.mgc.es/asesoramiento-presupuesto?dades=6HYOWzsqDBeMUmw0jMSUMTBYtmJaf56wIzHSaOtde7FWwaRZpixSe9v5iXoMTaVTd7NjXPXd95khjNzdNytqtA
					let url = window.location.href;
					//url = "http://mgc-dev/contratar-seguro?dades=6HYOWzsqDBeMUmw0jMSUMTBYtmJaf56wIzHSaOtde7FWwaRZpixSe9v5iXoMTaVTd7NjXPXd95khjNzdNytqtA"
					var params = {};
					if (url.includes('?')) {
						var param_array = url.split('?')[1].split('&');
						for(var i in param_array){
							let x = param_array[i].split('=');
							params[x[0]] = x[1];
						}
					}

					if (params.dades){
						this.data_input.webData = params.dades;
					}else{
						let data_storage = JSON.parse(sessionStorage.getItem('tariff_results'));
						if(data_storage){
							this.idTarifa = data_storage['ID_TARIFA'];
							this.data_input.idTarifa = data_storage['ID_TARIFA'];
							this.cpOportunidad = sessionStorage.getItem('tarificador_zipcode');
							this.data_input.codiPostal = sessionStorage.getItem('tarificador_zipcode');
							this.data_input.phone = sessionStorage.getItem('tarificador_phone');
						}else{
							this.loadError=true;
							return false;
						}
					}
					this.getBudgetData(this.data_input);
				},
				filterStarterData: function(){
					let app = this;
					if(app.starter_data){
						let insured_starter = app.starter_data.infoPressupost.ASSEGURATS;
						app.contract_start_date = app.starter_data.infoPressupost.DATA_EFECTE;
						app.idTarifa = app.starter_data.infoPressupost.PAQUETS.ID_TARIFA;
						app.clientContact = app.starter_data.oportunitat.CLIENT_CONTACTE;
						app.coverage = [];
						app.comercial = app.starter_data.infoPressupost.COMERCIAL;
						app.colectiu = app.starter_data.infoPressupost.COLECTIU;
						app.periodicitat = app.starter_data.infoPressupost.PERIODICITAT;
						app.oportunidad = app.starter_data.oportunitat.OPORTUNITAT;

						app.product_name = app.starter_data.infoPressupost.INFORMACIO_PRODUCTE.TITOL;
						if(app.cpOportunidad == ""){
							app.cpOportunidad = app.starter_data.oportunitat.CODI_POSTAL;
						}
						for (let index = 0; index < app.starter_data.infoPressupost.INFORMACIO_PRODUCTE.COBERTURES.length; index++) {
							app.coverage.push(app.starter_data.infoPressupost.INFORMACIO_PRODUCTE.COBERTURES[index]);
						}
						app.insurance_price_with_copayment = {
							total: app.starter_data.infoPressupost.PAQUETS.MENSUAL_TOTAL,
							units: Math.floor(app.starter_data.infoPressupost.PAQUETS.MENSUAL_TOTAL).toString(),
							cents: (app.starter_data.infoPressupost.PAQUETS.MENSUAL_TOTAL % 1).toFixed(2).substring(2)
						}
						app.insurance_price_without_copayment = {
							total: app.starter_data.infoPressupost.PAQUETS.MENSUAL_TOTAL_SENSE_COPAG,
							units: Math.floor(app.starter_data.infoPressupost.PAQUETS.MENSUAL_TOTAL_SENSE_COPAG).toString(),
							cents: (app.starter_data.infoPressupost.PAQUETS.MENSUAL_TOTAL_SENSE_COPAG % 1).toFixed(2).substring(2)
						}
						for (let i = 0; i < insured_starter.length; i++) {
							let aux_birth_day = parseInt(insured_starter[i].DATANAIX.split("/")[0]);
							let aux_birth_month = parseInt(insured_starter[i].DATANAIX.split("/")[1])-1;
							let aux_birth_year = parseInt(insured_starter[i].DATANAIX.split("/")[2]);
							let parentiu_title = "";
							if(insured_starter[i].PARENTIU == "01"){
								if(lang_code == "es"){
									parentiu_title = "Tomador";
								}else if(lang_code == "ca"){
									parentiu_title = "Prenedor";
								}
							}else{
								parentiu_title = app.parentius_list.find(parentiu => parentiu.codi === insured_starter[i].PARENTIU).descripcio;
							}
							let insured = {}
							insured.relation =  {
								code: insured_starter[i].PARENTIU,
								text: parentiu_title
							}
							insured.personal ={
								name: "",
								surnames: "",
								first_surname: "",
								second_surname: "",
								birthdate: new Date(aux_birth_year, aux_birth_month, aux_birth_day),
								birthdate_string: insured_starter[i].DATANAIX,
								birthdate_num: insured_starter[i].DATANAIX.split("/")[2]+"-"+insured_starter[i].DATANAIX.split("/")[1]+"-"+insured_starter[i].DATANAIX.split("/")[0],
								sex: "00",
								idDocType: "TIPUSDOCIDNIF",
								idDocNum: "",
								profession: "00",
								autonom: "none",
								nationality:"00",
								language: "00"
							};
							if (i==0){
								insured.contact = {
									email: app.starter_data.oportunitat.EMAIL,
									phone: app.starter_data.oportunitat.TEL_MOBIL
								}
							}else{
								insured.contact = {
									email: "",
									phone: ""
								}
							}
							insured.address ={
								zipcode: "",
								province: "",
								city: "",
								street: "",
							}
							insured.minor = app.checkIfMinor(new Date(aux_birth_year, aux_birth_month, aux_birth_day));
							insured.price_with_copayment = (parseFloat(app.starter_data.infoPressupost.PAQUETS.TARIFA_GRUP[i]["TOTAL TARIFA FINAL"].replace(',', '.')) / 12).toFixed(2).toString().replace('.', ',');
							insured.price_without_copayment = (parseFloat(app.starter_data.infoPressupost.PAQUETS.TARIFA_GRUP_SENSE_COPAG[i]["TOTAL TARIFA FINAL"].replace(',', '.')) / 12).toFixed(2).toString().replace('.', ',');
							app.insuredArr.push(insured);
							app.insured_state_array.push({
								open: false,
								completed: false,
								valid: false,
								input_state: {
									name_error: false,
									name_success: false,
									surnames_error: false,
									surnames_success: false,
									first_surname_error: false,
									first_surname_success: false,
									second_surname_error: false,
									second_surname_success: false,
									idDocNum_error: false,
									idDocNum_success: false,
									email_error: false,
									email_success: false,
									phone_error: false,
									phone_success: false,
									sex_success: false,
									nation_success: false,
									lang_success: false,
									profession_success: false,
									autonom_success: false
								},
								input_validation: {
									name_valid: false,
									//surnames_valid: false,
									first_surname_valid: false,
									sex_validation: false,
									nation_validation: false,
									lang_validation: false,
									idDocNum_valid: true,
								}
							})
							if(!app.insuredArr[i].minor){
								app.insured_state_array[i].input_validation.idDocNum_valid = false;
								//app.insured_state_array[i].input_validation.autonom_validation = false;
								//app.insured_state_array[i].input_validation.profession_validation = false;
							}
							if(i==0){
								app.insured_state_array[i].input_validation.email_valid = false;
								app.insured_state_array[i].input_validation.phone_valid = false;
								app.insured_state_array[i].input_validation.city_valid = false;
								app.insured_state_array[i].input_state.city_error = false;
								app.insured_state_array[i].input_state.city_success = false;
								app.insured_state_array[i].input_validation.city_valid = false;
								app.insured_state_array[i].input_state.city_error = false;
								app.insured_state_array[i].input_state.city_success = false;
								app.insured_state_array[i].input_validation.street_valid = false;
								app.insured_state_array[i].input_state.street_error = false;
								app.insured_state_array[i].input_state.street_success = false;
								app.insured_state_array[i].input_validation.zipcode_valid = false;
								app.insured_state_array[i].input_state.zipcode_error = false;
								app.insured_state_array[i].input_state.zipcode_success = false;
								if(app.starter_data.oportunitat.EMAIL != ""){app.setMail(app.insuredArr[0].contact.email, 0);}
								if(app.starter_data.oportunitat.TEL_MOBIL != ""){app.setPhone(app.insuredArr[0].contact.phone, 0);}
							}
						}
						app.insured_state_array[0].open = true;
					}
				},
				checkValidation: function(){
					for (let index = 0; index < this.insured_state_array.length; index++) {
						if(Object.values(this.insured_state_array[index].input_validation).filter((v) => (v === false)).length === 0){
							this.insured_state_array[index].valid = true;
						}else{
							this.insured_state_array[index].valid = false;
						}
					}
				},
				setMail: function(value, insuredId){
					let re = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-]+$");
					let isUnique = true;
					for (let index = 0; index < this.insuredArr.length; index++) {
						if(index!=insuredId){
							if(this.insuredArr[index].contact.email == value){
								isUnique = false;
							}
						}
					}
					if(insuredId > 0 && value == ""){
						this.insured_state_array[insuredId].input_validation.email_valid = true;
						this.insured_state_array[insuredId].input_state.email_error = false;
						this.insured_state_array[insuredId].input_state.email_success = false;
					}else{
						if(re.test(value) && isUnique){
							this.insured_state_array[insuredId].input_validation.email_valid = true;
							this.insured_state_array[insuredId].input_state.email_error = false;
							this.insured_state_array[insuredId].input_state.email_success = true;
						}else{
							this.insured_state_array[insuredId].input_validation.email_valid = false;
							this.insured_state_array[insuredId].input_state.email_success = false;
							this.insured_state_array[insuredId].input_state.email_error = true;
						}
					}
					this.checkValidation();
				},
				setPhone: function(value, insuredId){
					let re = new RegExp("^[0-9]{9}$");
					if(insuredId > 0 && value == ""){
						this.insured_state_array[insuredId].input_validation.phone_valid = true;
						this.insured_state_array[insuredId].input_state.phone_error = false;
						this.insured_state_array[insuredId].input_state.phone_success = false;
					}else{
						if(re.test(value)){
							this.insured_state_array[insuredId].input_validation.phone_valid = true;
							this.insured_state_array[insuredId].input_state.phone_error = false;
							this.insured_state_array[insuredId].input_state.phone_success = true;
						}else{
							this.insured_state_array[insuredId].input_validation.phone_valid = false;
							this.insured_state_array[insuredId].input_state.phone_success = false;
							this.insured_state_array[insuredId].input_state.phone_error = true;
						}
					}
					this.checkValidation();
				},
				setName: function(value, insuredId){
					this.insuredArr[insuredId].personal.name = value;
					let re = new RegExp("^([a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value)){
						this.insured_state_array[insuredId].input_validation.name_valid = true;
						this.insured_state_array[insuredId].input_state.name_error = false;
						this.insured_state_array[insuredId].input_state.name_success = true;
					}else{
						this.insured_state_array[insuredId].input_validation.name_valid = false;
						this.insured_state_array[insuredId].input_state.name_success = false;
						this.insured_state_array[insuredId].input_state.name_error = true;
					}
					this.checkValidation();
				},
				setFirstSurname: function(value, insuredId){
					this.insuredArr[insuredId].personal.first_surname = value;
					let re = new RegExp("^([a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value)){
						this.insured_state_array[insuredId].input_validation.first_surname_valid = true;
						this.insured_state_array[insuredId].input_state.first_surname_error = false;
						this.insured_state_array[insuredId].input_state.first_surname_success = true;
					}else{
						this.insured_state_array[insuredId].input_validation.first_surname_valid = false;
						this.insured_state_array[insuredId].input_state.first_surname_success = false;
						this.insured_state_array[insuredId].input_state.first_surname_error = true;
					}
					this.checkValidation();
				},
				setSecondSurname: function(value, insuredId){
					this.insuredArr[insuredId].personal.second_surname = value;
					let re = new RegExp("^([a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value) || value==""){
						this.insured_state_array[insuredId].input_validation.second_surname_valid = true;
						this.insured_state_array[insuredId].input_state.second_surname_error = false;
						this.insured_state_array[insuredId].input_state.second_surname_success = false;
						if(value!=""){
							this.insured_state_array[insuredId].input_state.second_surname_success = true;
						}
					}else{
						this.insured_state_array[insuredId].input_validation.second_surname_valid = false;
						this.insured_state_array[insuredId].input_state.second_surname_success = false;
						this.insured_state_array[insuredId].input_state.second_surname_error = true;
					}
					this.checkValidation();
				},
				setDocument: function(value, insuredId){
					value = value.toString().toUpperCase();
					this.insuredArr[insuredId].personal.IdDocNum = value;
					let re;
					switch (this.insuredArr[insuredId].personal.idDocType){
						case "TIPUSDOCIDNIF":
							re = new RegExp("^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$");
							break;
						case "TIPUSDOCIDCIF":
							re = new RegExp("^([ABCDEFGHJKLMNPQRSUVW])([0-9]{7})([0-9A-J])$");
							break;
						case "TIPUSDOCIDPSP":
							re = new RegExp("^[A-Z]{3}[0-9]{6}[A-Z]?$");
							break;
						case "TIPUSDOCIDPEX":
							re = new RegExp("^[0-9A-Z]{9}$");
							break;
						case "TIPUSDOCIDNIE":
							re = new RegExp("^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$");
							break;
						default:
							console.log("ERROR");
					}
					let isUnique = true;
					for (let index = 0; index < this.insuredArr.length; index++) {
						if(index!=insuredId){
							if(this.insuredArr[index].personal.idDocNum.toUpperCase() == value){
								isUnique = false;
							}
						}
					}
					if((re.test(value) && isUnique) || (value == "" && this.insuredArr[insuredId].minor)){
						if(value == "" && this.insuredArr[insuredId].minor){
							this.insured_state_array[insuredId].input_validation.idDocNum_valid = true;
							this.insured_state_array[insuredId].input_state.idDocNum_error = false;
							this.insured_state_array[insuredId].input_state.idDocNum_success = false;
						}else{
							if(this.insuredArr[insuredId].personal.idDocType == "TIPUSDOCIDNIF" || this.insuredArr[insuredId].personal.idDocType == "TIPUSDOCIDNIE"){
								let validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
								let nie = value
									.replace(/^[X]/, '0')
									.replace(/^[Y]/, '1')
									.replace(/^[Z]/, '2');
								let letter = value.substr(-1);
								let charIndex = parseInt(nie.substr(0, 8)) % 23;
								if (validChars.charAt(charIndex) === letter) {
									this.insured_state_array[insuredId].input_validation.idDocNum_valid = true;
									this.insured_state_array[insuredId].input_state.idDocNum_error = false;
									this.insured_state_array[insuredId].input_state.idDocNum_success = false;
									if(value!=""){
										this.insured_state_array[insuredId].input_state.idDocNum_success = true;
									}
								}else{
									this.insured_state_array[insuredId].input_validation.idDocNum_valid = false;
									this.insured_state_array[insuredId].input_state.idDocNum_success = false;
									this.insured_state_array[insuredId].input_state.idDocNum_error = true;
								}
							}else if(this.insuredArr[insuredId].personal.idDocType == "TIPUSDOCIDCIF"){
								if(value==""){
									if(this.insuredArr[insuredId].minor){
										this.insured_state_array[insuredId].input_validation.idDocNum_valid = true;
										this.insured_state_array[insuredId].input_state.idDocNum_error = false;
										this.insured_state_array[insuredId].input_state.idDocNum_success = false;
									}else{
										this.insured_state_array[insuredId].input_validation.idDocNum_valid = false;
										this.insured_state_array[insuredId].input_state.idDocNum_error = true;
										this.insured_state_array[insuredId].input_state.idDocNum_success = false;
									}
								}else if(this.isValidCif(value)){
									this.insured_state_array[insuredId].input_validation.idDocNum_valid = true;
									this.insured_state_array[insuredId].input_state.idDocNum_error = false;
									this.insured_state_array[insuredId].input_state.idDocNum_success = true;
								}else{
									this.insured_state_array[insuredId].input_validation.idDocNum_valid = false;
									this.insured_state_array[insuredId].input_state.idDocNum_success = false;
									this.insured_state_array[insuredId].input_state.idDocNum_error = true;
								}
							}else{
								this.insured_state_array[insuredId].input_validation.idDocNum_valid = true;
								this.insured_state_array[insuredId].input_state.idDocNum_error = false;
								this.insured_state_array[insuredId].input_state.idDocNum_success = false;
								if(value!=""){
									this.insured_state_array[insuredId].input_state.idDocNum_success = true;
								}
							}
						}

					}else{
						this.insured_state_array[insuredId].input_validation.idDocNum_valid = false;
						this.insured_state_array[insuredId].input_state.idDocNum_success = false;
						this.insured_state_array[insuredId].input_state.idDocNum_error = true;
					}
					this.checkValidation();
				},
				setZipcode: function(value, insuredId){
					this.insuredArr[insuredId].address.zipcode = value;
					let re = new RegExp("^([0-9]{5})$");
					if(re.test(value) && value == this.cpOportunidad){
						this.insured_state_array[insuredId].input_validation.zipcode_valid = true;
						this.insured_state_array[insuredId].input_state.zipcode_error = false;
						this.insured_state_array[insuredId].input_state.zipcode_success = true;
					}else{
						this.insured_state_array[insuredId].input_validation.zipcode_valid = false;
						this.insured_state_array[insuredId].input_state.zipcode_success = false;
						this.insured_state_array[insuredId].input_state.zipcode_error = true;
					}
					this.setCity(this.insuredArr[insuredId].address.city, 0);
					this.checkValidation();
				},
				setCity: function(value, insuredId){
					if(value.length > 2){
						this.toggleCityDropdown(true);
					}else{
						this.toggleCityDropdown(false);
					}
					this.insuredArr[insuredId].address.city = value.capitalize();
					let aux_cities_reg = this.unique_populations.filter(city => city.regular == (value.capitalize()));
					let aux_cities_norm = this.unique_populations.filter(city => city.normalized.includes(this.normalizeString(value.capitalize())));
					this.city_options = [];
					 if(aux_cities_reg.length > 0){
						for (let i = 0; i < aux_cities_reg.length; i++) {
							this.city_options.push(aux_cities_reg[i].regular);
						}
					}else{
						for (let i = 0; i < aux_cities_norm.length; i++) {
							this.city_options.push(aux_cities_norm[i].regular);
						}
					}

					let cityExistsAndUnique = false;
					let zipcodeCoincides = false;
					let zipcodeValidation;
					if((this.unique_populations.filter(city => city.regular === value)).length == 1){
						cityExistsAndUnique = true;
						zipcodeValidation = this.populations_list.filter(cityZip => cityZip.nom == value);
						for (let i = 0; i < zipcodeValidation.length; i++) {
							const zip = zipcodeValidation[i];
							if((zip.codi == this.insuredArr[insuredId].address.zipcode.toString())){
								zipcodeCoincides = true;
								break;
							}else{
								zipcodeCoincides = false;
							}
						}
					}else{
						cityExistsAndUnique = false;
					}
					let re = new RegExp("^([0-9a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value) && cityExistsAndUnique && zipcodeCoincides){
						this.insured_state_array[insuredId].input_validation.city_valid = true;
						this.insured_state_array[insuredId].input_state.city_error = false;
						this.insured_state_array[insuredId].input_state.city_success = true;
					}else{
						this.insured_state_array[insuredId].input_validation.city_valid = false;
						this.insured_state_array[insuredId].input_state.city_success = false;
						this.insured_state_array[insuredId].input_state.city_error = true;
					}
					this.checkValidation();
				},
				clickCity: function(event){
					event.stopPropagation();
				},
				toggleCityDropdown: function(status, event){
					if(event){
						event.stopPropagation();
					}
					this.cityDropdownState = status;
				},
				selectCity: function(event, city_index){
					event.stopPropagation();
					this.setCity(this.city_options[city_index], 0);
					this.cityDropdownState = false;
				},
				normalizeString: function (inStr) {
					inStr = inStr.toLowerCase();
					return inStr.replace(
						/([àáâãäå])|([çčć])|([èéêë])|([ìíîï])|([ñ])|([òóôõöø])|([ß])|([ùúûü])|([ÿ])|([æ])/g,
						function (str, a, c, e, i, n, o, s, u, y, ae) {
							if (a) return 'a';
							if (c) return 'c';
							if (e) return 'e';
							if (i) return 'i';
							if (n) return 'n';
							if (o) return 'o';
							if (s) return 's';
							if (u) return 'u';
							if (y) return 'y';
							if (ae) return 'ae';
						}
					);
				},
				setStreet: function(value, insuredId){
					if(value.length > 5){
						this.insured_state_array[insuredId].input_validation.street_valid = true;
						this.insured_state_array[insuredId].input_state.street_error = false;
						this.insured_state_array[insuredId].input_state.street_success = true;
					}else{
						this.insured_state_array[insuredId].input_validation.street_valid = false;
						this.insured_state_array[insuredId].input_state.street_success = false;
						this.insured_state_array[insuredId].input_state.street_error = true;
					}
					this.checkValidation();
				},
				nationSelect: function(event, index){
					if(this.shared_nationality && index == 0){
						for (let it = 0; it < this.insuredArr.length; it++) {
							this.insuredArr[it].personal.nationality = event.target.value;
							this.insured_state_array[it].input_validation.nation_validation = true;
							this.insured_state_array[it].input_state.nation_success = true;
						}
					}else{
						this.insuredArr[index].personal.nationality = event.target.value;
						this.insured_state_array[index].input_validation.nation_validation = true;
						this.insured_state_array[index].input_state.nation_success = true;
					}
					this.checkValidation();
				},
				langSelect: function(event, index){
					if(this.shared_lang && index == 0){
						for (let it = 0; it < this.insuredArr.length; it++) {
							this.insuredArr[it].personal.language = event.target.value;
							this.insured_state_array[it].input_validation.lang_validation = true;
							this.insured_state_array[it].input_state.lang_success = true;
						}
					}else{
						this.insuredArr[index].personal.language = event.target.value;
						this.insured_state_array[index].input_validation.lang_validation = true;
						this.insured_state_array[index].input_state.lang_success = true;
					}
					this.checkValidation();
				},
				selectChange: function(event, insuredId, select){
					if (select == "idDocType"){
						this.setDocument(this.insuredArr[insuredId].personal.idDocNum, insuredId)
					}
					if (select == "sex"){
						this.insured_state_array[insuredId].input_validation.sex_validation = true;
						this.insured_state_array[insuredId].input_state.sex_success = true;
					}

					/* if (select == "autonom"){
						this.insuredArr[insuredId].personal.autonom = event.target.value;
						this.insured_state_array[insuredId].input_validation.autonom_validation = true;
						this.insured_state_array[insuredId].input_state.autonom_success = true;
					}
					if (select == "profession"){
						this.insuredArr[insuredId].personal.profession = event.target.value;
						this.insured_state_array[insuredId].input_validation.profession_validation = true;
						this.insured_state_array[insuredId].input_state.profession_success = true;
					} */
					this.checkValidation();
				},
				changeActiveInsurer: function(){
					let app = this;
					if(app.changedInsuranceCompany==0){
						app.insurer_selected = "00"
					}
				},
				isValidCif: function(cif) {
					if (!cif || cif.length !== 9) {
						return false;
					}
					let letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
					let digits = cif.substr(1, cif.length - 2);
					let letter = cif.substr(0, 1);
					let control = cif.substr(cif.length - 1);
					let sum = 0;
					let i;
					let digit;
					if (!letter.match(/[A-Z]/)) {
						return false;
					}
					for (i = 0; i < digits.length; ++i) {
						digit = parseInt(digits[i]);
						if (isNaN(digit)) {
							return false;
						}
						if (i % 2 === 0) {
							digit *= 2;
							if (digit > 9) {
								digit = parseInt(digit / 10) + (digit % 10);
							}
							sum += digit;
						} else {
							sum += digit;
						}
					}
					sum %= 10;
					if (sum !== 0) {
						digit = 10 - sum;
					} else {
						digit = sum;
					}
					if (letter.match(/[ABEH]/)) {
						return String(digit) === control;
					}
					if (letter.match(/[NPQRSW]/)) {
						return letters[digit] === control;
					}
					return String(digit) === control || letters[digit] === control;
				},
				checkIfMinor: function(bd) {
					let today = new Date();
					let yearsDiff =  today.getFullYear() - bd.getFullYear();
					let isMinor = false;
					if(yearsDiff < 18){
						isMinor = true;
					}
					return isMinor;
				},
				focusComplexInput: function(event, section){
					if(section != 0 && event.target.value == ""){
						for (let index = 1; index < section + 1; index++) {
							let children = event.target.parentNode.children;
							if (children[index].value == ""){
								let maxLength = parseInt(children[index - 1].attributes["maxlength"].value, 10);
								let myLength = children[index - 1].value.length;
								if (myLength >= maxLength){
									children[index].focus();
								}else{
									children[index - 1].focus();
								}
								break;
							}
						}
					}
				},
				pasteComplexInput: function(event, input){
					let app = this;
					let paste = (event.clipboardData || window.clipboardData).getData('text');
					let wrapper = event.target.closest('.input-wrapper');
					let inputArr = wrapper.querySelectorAll('input');
					if(input == "iban"){
						for (let index = 0; index < inputArr.length; index++) {
							switch (index){
								case(0):
									inputArr[index].value = paste.substring(0, 4);
									app.checkIban(paste.substring(0, 4), index, true);
									break;
								case(1):
									inputArr[index].value = paste.substring(4, 8);
									app.checkIban(paste.substring(4, 8), index, true);
									break;
								case(2):
									inputArr[index].value = paste.substring(8, 12);
									app.checkIban(paste.substring(8, 12), index, true);
									break;
								case(3):
									inputArr[index].value = paste.substring(12, 14);
									app.checkIban(paste.substring(12, 14), index, true);
									break;
								case(4):
									inputArr[index].value = paste.substring(14);
									app.checkIban(paste.substring(14), index, true);
									break;
							}
						}
					}
					if(input == "emailVerification"){
						for (let index = 0; index < inputArr.length; index++) {
							inputArr[index].value = paste.charAt(index);
							app.validationCode[index] = paste.charAt(index);
						}
						app.validationCode_text = paste.substring(0,5)
					}
				},
				checkIban: function(value, section, paste){
					let re;
					let aux_value;
					if(paste){
						aux_value = value;
					}else{
						aux_value = value.toString().toUpperCase();
					}
					switch (section){
						case 0:
							this.iban.section1 = aux_value;
							re = new RegExp("^[ES]{2}[0-9]{2}$");
							if(re.test(this.iban.section1)){
								this.iban.iban_1_valid = true;
								this.iban.iban_1_success = true;
								this.iban.iban_1_error = false;
							}else{
								this.iban.iban_1_valid = false;
								this.iban.iban_1_success = false;
								this.iban.iban_1_error = true;
							}
							break;
						case 1:
							this.iban.section2 = aux_value;
							re = new RegExp("^[0-9]{4}$");
							if(re.test(this.iban.section2)){
								this.iban.iban_2_valid = true;
								this.iban.iban_2_success = true;
								this.iban.iban_2_error = false;
							}else{
								this.iban.iban_2_valid = false;
								this.iban.iban_2_success = false;
								this.iban.iban_2_error = true;
							}
							break;
						case 2:
							this.iban.section3 = aux_value;
							re = new RegExp("^[0-9]{4}?$");
							if(re.test(this.iban.section3)){
								this.iban.iban_3_valid = true;
								this.iban.iban_3_success = true;
								this.iban.iban_3_error = false;
							}else{
								this.iban.iban_3_valid = false;
								this.iban.iban_3_success = false;
								this.iban.iban_3_error = true;
							}
							break;
						case 3:
							this.iban.section4 = aux_value;
							re = new RegExp("^[0-9]{2}$");
							if(re.test(this.iban.section4)){
								this.iban.iban_4_valid = true;
								this.iban.iban_4_success = true;
								this.iban.iban_4_error = false;
							}else{
								this.iban.iban_4_valid = false;
								this.iban.iban_4_success = false;
								this.iban.iban_4_error = true;
							}
							break;
						case 4:
							this.iban.section5 = aux_value;
							re = new RegExp("^[0-9]{10}$");
							if(re.test(this.iban.section5)){
								this.iban.iban_5_valid = true;
								this.iban.iban_5_success = true;
								this.iban.iban_5_error = false;
							}else{
								this.iban.iban_5_valid = false;
								this.iban.iban_5_success = false;
								this.iban.iban_5_error = true;
							}
							break;
						default:
							console.log("ERROR");
					}

					this.iban.final = this.iban.section1 + this.iban.section2 + this.iban.section3 + this.iban.section4 + this.iban.section5;
					if(this.iban.iban_1_valid && this.iban.iban_2_valid && this.iban.iban_3_valid && this.iban.iban_4_valid && this.iban.iban_5_valid){

						if (this.fn_ValidateIBAN(this.iban.final)){
							this.iban.iban_valid = true;

							this.iban.iban_1_success = true;
							this.iban.iban_1_error = false;

							this.iban.iban_2_success = true;
							this.iban.iban_2_error = false;

							this.iban.iban_3_success = true;
							this.iban.iban_3_error = false;

							this.iban.iban_4_success = true;
							this.iban.iban_4_error = false;

							this.iban.iban_5_success = true;
							this.iban.iban_5_error = false;
						}else{
							this.iban.iban_valid = false;

							this.iban.iban_1_success = false;
							this.iban.iban_1_error = true;

							this.iban.iban_2_success = false;
							this.iban.iban_2_error = true;

							this.iban.iban_3_success = false;
							this.iban.iban_3_error = true;

							this.iban.iban_4_success = false;
							this.iban.iban_4_error = true;

							this.iban.iban_5_success = false;
							this.iban.iban_5_error = true;
						}
					}else{
						this.iban.iban_valid = false;
					}
					this.iban.final_dashed = this.iban.section1 + "-" + this.iban.section2 + "-" + this.iban.section3 + "-" + this.iban.section4 + "-" + this.iban.section5;
					this.iban.final = this.iban.section1 + this.iban.section2 + this.iban.section3 + this.iban.section4 + this.iban.section5;
				},
				fn_ValidateIBAN: function(IBAN){
					IBAN = IBAN.toUpperCase();
					IBAN = IBAN.trim();
					IBAN = IBAN.replace(/\s/g, "");
					let letra1,letra2,num1,num2;
					let isbanaux;
					if (IBAN.length != 24) {
						return false;
					}
					letra1 = IBAN.substring(0, 1);
					letra2 = IBAN.substring(1, 2);
					num1 = this.getnumIBAN(letra1);
					num2 = this.getnumIBAN(letra2);
					isbanaux = String(num1) + String(num2) + IBAN.substring(2);
					isbanaux = isbanaux.substring(6) + isbanaux.substring(0,6);
					let resto = this.modulo97(isbanaux);
					if (resto == 1){
						return true;
					}else{
						return false;
					}
				},
				modulo97: function(iban) {
					let parts = Math.ceil(iban.length/7);
					let remainer = "";
					for (var i = 1; i <= parts; i++) {
						remainer = String(parseFloat(remainer+iban.substr((i-1)*7, 7))%97);
					}
					return remainer;
				},
				getnumIBAN: function(letra) {
					let ls_letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
					return ls_letras.search(letra) + 10;
				},
				ibanActivate: function(event){
					let target = event.target;
					let maxLength = parseInt(target.attributes["maxlength"].value, 10);
					let myLength = target.value.length;
					if (myLength >= maxLength) {
						let next = target;
						while (next = next.nextElementSibling) {
							if (next == null)
								break;
							if (next.tagName.toLowerCase() === "input") {
								next.focus();
								break;
							}
						}
					}
					// Move to previous field if empty (user pressed backspace)
					else if (myLength === 0) {
						let previous = target;
						while (previous = previous.previousElementSibling) {
							if (previous == null)
								break;
							if (previous.tagName.toLowerCase() === "input") {
								previous.focus();
								break;
							}
						}
					}
				},
				completeFormItem: function(event, id){
					event.preventDefault();
					event.stopPropagation();
					this.insured_state_array[id].open = false;
					this.insured_state_array[id].complete = true;
					if(this.insured_state_array[id+1]){
						this.insured_state_array[id+1].open = true;
						let nextEl = event.target.closest('.form-section-body').querySelectorAll('.insured-form-item')[id+1];
						let yOffset = -100;
						let y = nextEl.getBoundingClientRect().top + yOffset;
						window.scrollTo({top: y, behavior: 'smooth'});

					}else{
						this.contractDataOpen = false;
						this.contractDataComplete = true;
						this.bankDetailsOpen = true;
						let nextEl = document.querySelector('.bankDetails');
						let yOffset = -100;
						let y = nextEl.getBoundingClientRect().top + yOffset;
						//window.scrollTo({top: nextEl.getBoundingClientRect().top + yOffset, behavior: 'smooth'});
					}
				},
				recoverProfessions: function(){
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverProfessions&lang='+lang_code;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{ data = JSON.parse(request.response);}
						catch (e)
							{ responseQuality = false; }
						if (responseQuality) {
							this.professions_list = data;
						}
					}
					request.send();
				},
				recoverParentius: function(){
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverParentius&lang='+lang_code;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{
								data = JSON.parse(request.response);
							}
						catch (e)
							{
								responseQuality = false;
							}
						if (responseQuality) {
							this.parentius_list = data;
							this.loadData();
						}
					}
					request.send();
				},
				recoverIdDocType: function(){
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverDocType';
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{ data = JSON.parse(request.response);}
						catch (e)
							{ responseQuality = false; }
						if (responseQuality) {
							this.idDocType_list = data;
						}
					}
					request.send();
				},
				recoverPopulations: function(){
					let zipcode = "";
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverPopulations&zipcode=' + zipcode;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{ data = JSON.parse(request.response);}
						catch (e)
							{ responseQuality = false; }
						if (responseQuality) {
							this.populations_list = data;
							this.filterPopulations(this.populations_list);
						}
					}
					request.send();
				},
				filterPopulations: function(arr){
					arr.forEach((c) => {
						if (this.unique_populations.filter(up => up.regular == (c.nom)).length == 0) {
							let cityObject = {regular: c.nom, normalized: this.normalizeString(c.nom)}
							this.unique_populations.push(cityObject);
						}
					});
				},
				recoverNationalities: function(){
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverNacionalitats&lang='+lang_code;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{ data = JSON.parse(request.response);}
						catch (e)
							{ responseQuality = false;}
						if (responseQuality) {
							this.nationalities_list = data;
						}
					}
					request.send();
				},
				recoverLanguages: function(){
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverLanguages';
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{ data = JSON.parse(request.response);}
						catch (e)
							{ responseQuality = false; }
						if (responseQuality) {
							this.languages_list = data;
						}
					}
					request.send();
				},
				recoverInsurers: function(){
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverInsurers';
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{ data = JSON.parse(request.response);}
						catch (e)
							{ responseQuality = false; }
						if (responseQuality) {
							this.insurers_list = data;
						}
					}
					request.send();
				},
				completeModality: function(event){
					event.preventDefault();
					event.stopPropagation();
					this.modalityOpen = false;
					this.modalityComplete = true;
					this.contractDataOpen = true;
					let nextEl = document.querySelector('.contractData');
					let yOffset = -100;
					let y = nextEl.getBoundingClientRect().top + yOffset;
					window.scrollTo({top: y, behavior: 'smooth'});

				},
				editModality: function(event){

					event.preventDefault();
					event.stopPropagation();
					this.modalityComplete = false;
					this.modalityOpen = true;
					this.contractDataOpen = false;
				},
				completeContract: function(event){
					event.preventDefault();
					event.stopPropagation();
					this.contractDataOpen = false;
					this.contractDataComplete = true;
					this.bankDetailsOpen = true;
				},
				editContract: function(event, index){
					event.preventDefault();
					event.stopPropagation();
					this.contractDataOpen = true;
					this.contractDataComplete = false;
					this.insured_state_array[index].open = true;
					this.insured_state_array[index].complete = false;

					for (let i = index + 1; i < this.insured_state_array.length; i++) {
						this.insured_state_array[i].open = false;
						this.insured_state_array[i].complete = false;
					}


					this.bankDetailsOpen = false;

				},
				fillingCompleted: function(event){
					console.log('trigger completed')
					let app = this;
					let email = app.insuredArr[0].contact.email;
					let preferedLang = app.insuredArr[0].personal.language;
					let request = new XMLHttpRequest();
					let url = "/wp-content/themes/mgc/curl_petition.php?petition=generateValidationKey"
						+"&lang="+preferedLang
						+"&email="+email;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						//console.log(request)
						try{
							data = JSON.parse(request.response);
						}catch (e){
							responseQuality = false;
						}
						//console.log(data);
						if (responseQuality) {
							//console.log(data);
							if(data.status=="200"){
								this.fillComplete = true;
								this.hidden_iban = this.iban.final.slice(-4);
								let yOffset = (document.querySelector('.bloque-titulo').clientHeight);
								window.scrollTo({top: yOffset, behavior: 'smooth'});
							}else{
								console.log('ERROR');
							}
						}else{
							console.log('ERROR')
							return false;
						}
					}
					request.send();
				},
				sendValidationMailAgain: function(event){
					event.preventDefault();
					event.stopPropagation();
					let app = this;
					let email = app.insuredArr[0].contact.email;
					let preferedLang = app.insuredArr[0].personal.language;
					let request = new XMLHttpRequest();
					let url = "/wp-content/themes/mgc/curl_petition.php?petition=generateValidationKey"
						+"&lang="+preferedLang
						+"&email="+email;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try{
							data = JSON.parse(request.response);
						}catch (e){
							responseQuality = false;
						}
						if (responseQuality) {
							if(data.status=="200"){
								console.log('Validation code sent');
							}else{
								console.log('ERROR');
							}
						}else{
							console.log('ERROR')
							return false;
						}
					}
					request.send();
				},
				validateEmail: function(event){
					let app = this;
					let email = app.insuredArr[0].contact.email;
					let code = app.validationCode_text;
					let request = new XMLHttpRequest();
					let url = "/wp-content/themes/mgc/curl_petition.php?petition=checkValidationKey"
						+"&code="+code
						+"&email="+email;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try{
							data = JSON.parse(request.response);
						}catch (e){
							responseQuality = false;
						}
						if (responseQuality) {
							if(data.status=="200"){
								this.validationComplete = true;
								let yOffset = (document.querySelector('.bloque-titulo').clientHeight);
								window.scrollTo({top: yOffset, behavior: 'smooth'});
								setTimeout(function(){
									if($('#confirmationModal')){
										$('footer').append($('#confirmationModal'));
										$('#confirmationModal').on('hide.bs.modal', function(e) {
											window.location = window.home_link;
										});
									}
								}, 100);
								this.informCompleteForm();
							}else{
								app.email_validation_error = true;
							}
						}else{
							console.log('ERROR')
							return false;
						}
					}
					request.send();
				},
				inputValidation: function(value, charPosition){
					this.validationCode[charPosition] = value;
					this.validationCode_text = this.validationCode.join('').toString();
				},
				validationActivate: function(event){
					let target = event.target;
					let maxLength = parseInt(target.attributes["maxlength"].value, 10);
					let myLength = target.value.length;
					if (myLength >= maxLength) {
						let next = target;
						while (next = next.nextElementSibling) {
							if (next == null)
								break;
							if (next.tagName.toLowerCase() === "input") {
								next.focus();
								break;
							}
						}
					}
					// Move to previous field if empty (user pressed backspace)
					else if (myLength === 0) {
						let previous = target;
						while (previous = previous.previousElementSibling) {
							if (previous == null)
								break;
							if (previous.tagName.toLowerCase() === "input") {
								previous.focus();
								break;
							}
						}
					}
				},
				contractInsurance: function(event){
					event.preventDefault();
					event.stopPropagation();
					this.sendAfiliation();
					$("#confirmationModal").modal('show');
				},
				toggleModalContractDataOpen: function(){
					this.modalContractDataOpen = !this.modalContractDataOpen;
				},
				informCompleteForm: function(){
					let app = this;
					let request = new XMLHttpRequest();
					let url = "/wp-content/themes/mgc/curl_petition.php?petition=checkFormComplete"
						+"&clientContact="+app.clientContact
						+"&numOportunity="+app.oportunidad;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try{
							data = JSON.parse(request.response);
						}catch (e){
							responseQuality = false;
						}
						if (!responseQuality) {
							console.log('ERROR');
						}
					}
					request.send();
				},
				downloadDocument(){
					let app = this;
					let a;
					let request = new XMLHttpRequest();
					let url = "/wp-content/themes/mgc/curl_petition.php?petition=generateAfiliationPDF"
						+"&lang="+lang_code
						+"&identificadorTarifa="+app.idTarifa;
					request.open('GET', url);
					request.onload = () => {
						let data;
						data = request.response;
						a = document.createElement("a");
						let pdf_name = "afiliacio_" + app.idTarifa + ".pdf";
						let data_url = "/wp-content/themes/mgc" + data.substring(1);
						a.href = data_url;
						a.setAttribute("download", pdf_name);
						a.click();
						setTimeout(()=>{
							let del_request = new XMLHttpRequest();
							let del_url = "/wp-content/themes/mgc/curl_petition.php?petition=deleteAfiliationPDF"+"&doc="+data;
							del_request.open('GET', del_url);
							del_request.onload = () => {

							}
							del_request.send();
						}, 3000);
					}
				request.send();
				},
				getBudgetData: function(data_input){
					let app = this;
					let request = new XMLHttpRequest();
					let url = "/wp-content/themes/mgc/curl_petition.php?petition=getWebBudgetData"
						+"&lang="+lang_code
						+"&idTarifa="+data_input.idTarifa
						+"&codiPostal="+data_input.codiPostal
						+"&phone="+data_input.phone
						+"&email="+data_input.email
						+"&webData="+data_input.webData
						+"&contactClient="+data_input.contactClient;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try{
							data = JSON.parse(request.response);
						}catch (e){
							responseQuality = false;
						}
						if (responseQuality) {
							if (data.resultat && data.status == "200") {
								app.starter_data = data.resultat;
								app.filterStarterData();
								app.loading = false;
							}else{
								if(data.status=="204"){
									app.loadError = true;
								}
							}
						}else{
							//console.log(request.response);
							console.log('ERROR');
							app.loadError = true;
						}
					}
					request.send();
				},
				sendAfiliation: function(){

					let app = this;
					//let comercial = app.comercial;
					let comercial = "";
					let identificadorTarifa = app.idTarifa;
					let iban = app.iban.final_dashed;
					let prenedorName;
					let prenedorPriCognom;
					let prenedorSegCognom;
					let prenedorAdreca;
					let prenedorCodiPostal;
					let prenedorNomPoble;
					if(app.ibanTomador){
						prenedorName = app.insuredArr[0].personal.name;
						prenedorPriCognom = app.insuredArr[0].personal.first_surname;
						prenedorSegCognom = app.insuredArr[0].personal.second_surname;
						prenedorAdreca = app.insuredArr[0].address.street.replaceAll(",","_");
						prenedorCodiPostal = app.insuredArr[0].address.zipcode;
						prenedorNomPoble = app.insuredArr[0].address.city;
					}else{
						prenedorName = app.ibanHolderData.name;
						prenedorPriCognom = app.ibanHolderData.first_surname;
						prenedorSegCognom = app.ibanHolderData.second_surname;
						prenedorAdreca = app.ibanHolderData.street.replaceAll(",","_");
						prenedorCodiPostal = app.ibanHolderData.zipcode;
						prenedorNomPoble = app.ibanHolderData.city;
					}
					let prenedorFreqCobrament = app.periodicitat;



					let names = [];
					let surnames = [];
					let second_surnames = [];
					let sexes = [];
					let birthdays = [];
					let relations = [];
					let professions = [];
					let nationalities = [];
					let nif = [];
					let docType = [];
					let address = [];
					let zipcodes = [];
					let cities = [];
					let emails = [];
					let phones = [];
					let mobilePhones = [];
					let autonoms = [];
					let languages = [];
					let companies = [];

					for (let i = 0; i < app.insuredArr.length; i++) {
						names.push(app.insuredArr[i].personal.name);
						surnames.push(app.insuredArr[i].personal.first_surname);
						second_surnames.push(app.insuredArr[i].personal.second_surname);
						sexes.push(app.insuredArr[i].personal.sex);
						birthdays.push(app.insuredArr[i].personal.birthdate_string);
						relations.push(app.insuredArr[i].relation.code);

						if(app.insuredArr[i].personal.profession != "00"){
							let profession = app.professions_list.filter(prof => prof.codi == app.insuredArr[i].personal.profession)
							professions.push(profession[0].descripcio.replaceAll(",","_"))
						}else{
							professions.push("");
						}
						nationalities.push(app.insuredArr[i].personal.nationality)
						nif.push(app.insuredArr[i].personal.idDocNum);
						docType.push(app.insuredArr[i].personal.idDocType);
						address.push(app.insuredArr[0].address.street.replaceAll(",","_"));
						zipcodes.push(app.insuredArr[0].address.zipcode);
						cities.push(app.insuredArr[0].address.city);
						if(app.insuredArr[i].contact){
							emails.push(app.insuredArr[i].contact.email);
						}else{
							emails.push("");
						}
						if(app.insuredArr[i].contact){
							if(app.insuredArr[i].contact.phone){
								if(app.insuredArr[i].contact.phone.substring(0) == 9){
									phones.push(app.insuredArr[i].contact.phone);
									mobilePhones.push("");
								}else{
									phones.push("");
									mobilePhones.push(app.insuredArr[i].contact.phone);
								}
							}else{
								if(app.insuredArr[0].contact.phone.substring(0) == 9){
									phones.push(app.insuredArr[0].contact.phone);
									mobilePhones.push("");
								}else{
									phones.push("");
									mobilePhones.push(app.insuredArr[0].contact.phone);
								}
							}
						}
						if (app.insuredArr[i].personal.autonom == "none") {
							autonoms.push("");
						}else{
							autonoms.push(app.insuredArr[i].personal.autonom);
						}
						if (app.insuredArr[i].personal.language != "00") {
							languages.push(app.insuredArr[i].personal.language);
						}else{
							languages.push(lang_code.toUpperCase());
						}
						if(app.insurer_selected == "00"){
							companies.push("");
						}else{
							companies.push(app.insurer_selected);
						}


					}

					//let user = app.comercial;
					let user = "";
					let clientContact = app.clientContact;
					let oportunityNumber = app.oportunidad;
					let globalCollective = app.colectiu;
					let mutua = "";
					let mutuaName = "";
					let timetableQM = "I";
					let observationsQM = "";
					let copayment = this.insurance_modality_chosen;


				let url = "/wp-content/themes/mgc/curl_petition.php?petition=particularAffiliation"+
					"&comercial=" + comercial +
					"&identificadorTarifa=" + identificadorTarifa +
					"&iban=" + iban +
					"&prenedorName=" + prenedorName +
					"&prenedorPriCognom=" + prenedorPriCognom +
					"&prenedorSegCognom=" + prenedorSegCognom +
					"&prenedorAdreca=" + prenedorAdreca +
					"&prenedorCodiPostal=" + prenedorCodiPostal +
					"&prenedorNomPoble=" + prenedorNomPoble +
					"&prenedorFreqCobrament=" + prenedorFreqCobrament +


					"&da_nom=" + names +
					"&da_priCognom=" + surnames +
					"&da_segCognom=" + second_surnames +
					"&da_sexe=" + sexes +
					"&da_data_naix=" + birthdays +
					"&da_parentiu=" + relations +
					"&da_professio=" + professions +
					"&da_nacionalitat=" + nationalities +
					"&da_nif=" + nif +
					"&da_tipusNif=" + docType +
					"&da_adreca=" + address +
					"&da_codiPostal=" + zipcodes +
					"&da_nomPoble=" + cities +
					"&da_email=" + emails +
					"&da_telefon=" + phones +
					"&da_telefonMobil=" + mobilePhones +
					"&da_autonom=" + autonoms +
					"&da_idioma=" + languages +
					"&da_companyia=" + companies +
					"&da_usuariGestio=" + user +
					"&da_clientContacte=" + clientContact +
					"&da_numOportunitat=" + oportunityNumber +
					"&da_colectiuGlobal=" + globalCollective +
					"&da_mutua=" + mutua +
					"&da_nomMutua=" + mutuaName +
					"&horariQM=" + timetableQM +
					"&observacionsQM=" + observationsQM +
					"&copagament=" + copayment;




					let request = new XMLHttpRequest();
					//let url = "/wp-content/themes/mgc/curl_petition.php?petition=afiliate";
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{ data = JSON.parse(request.response); }
						catch (e)
							{ responseQuality = false }
						if (responseQuality) {
							if (data.status == "200") {
								app.modalLoad = false;
							}else{
								app.modalLoadError = true;
							}
						}else{
							console.log('ERROR');
							app.modalLoadError = true;
						}
					}
					request.send();
				},



				setNameIban: function(value, insuredId){
					this.ibanHolderData.name = value;
					let re = new RegExp("^([a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value)){
						this.ibanHolderData.validation.name_valid = true;
						this.ibanHolderData.name_error = false;
						this.ibanHolderData.name_success = true;
					}else{
						this.ibanHolderData.validation.name_valid = false;
						this.ibanHolderData.name_success = false;
						this.ibanHolderData.name_error = true;
					}
					this.checkIbanDataValidation();
				},
				setFirstSurnameIban: function(value, insuredId){
					this.ibanHolderData.first_surname = value;
					let re = new RegExp("^([a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value)){
						this.ibanHolderData.validation.first_surname_valid = true;
						this.ibanHolderData.first_surname_error = false;
						this.ibanHolderData.first_surname_success = true;
					}else{
						this.ibanHolderData.validation.first_surname_valid = false;
						this.ibanHolderData.first_surname_success = false;
						this.ibanHolderData.first_surname_error = true;
					}
					this.checkIbanDataValidation();
				},
				setSecondSurnameIban: function(value, insuredId){
					this.ibanHolderData.second_surname = value;
					let re = new RegExp("^([a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value) || value==""){
						this.ibanHolderData.validation.second_surname_valid = true;
						this.ibanHolderData.second_surname_error = false;
						this.ibanHolderData.second_surname_success = false;
						if(value!=""){
							this.ibanHolderData.second_surname_success = true;
						}
					}else{
						this.ibanHolderData.validation.second_surname_valid = false;
						this.ibanHolderData.second_surname_success = false;
						this.ibanHolderData.second_surname_error = true;
					}
					this.checkIbanDataValidation();
				},
				setStreetIban: function(value, insuredId){
					if(value.length > 5){
						this.ibanHolderData.validation.street_valid = true;
						this.ibanHolderData.street_error = false;
						this.ibanHolderData.street_success = true;
					}else{
						this.ibanHolderData.validation.street_valid = false;
						this.ibanHolderData.street_success = false;
						this.ibanHolderData.street_error = true;
					}
					this.checkIbanDataValidation();
				},
				setZipcodeIban: function(value, insuredId){
					this.ibanHolderData.zipcode = value;
					let re = new RegExp("^([0-9]{5})$");
					//if(re.test(value) && value == this.cpOportunidad){
					if(re.test(value)){
						this.ibanHolderData.validation.zipcode_valid = true;
						this.ibanHolderData.zipcode_error = false;
						this.ibanHolderData.zipcode_success = true;
					}else{
						this.ibanHolderData.validation.zipcode_valid = false;
						this.ibanHolderData.zipcode_success = false;
						this.ibanHolderData.zipcode_error = true;
					}
					this.setCityIban(this.ibanHolderData.city, 0);
					this.checkIbanDataValidation();
				},
				setCityIban: function(value){
					if(value.length > 2){
						this.toggleCityDropdown(true);
					}else{
						this.toggleCityDropdown(false);
					}
					this.ibanHolderData.city = value.capitalize();
					let aux_cities_reg = this.unique_populations.filter(city => city.regular == (value.capitalize()));
					let aux_cities_norm = this.unique_populations.filter(city => city.normalized.includes(this.normalizeString(value.capitalize())));
					this.city_options = [];
					 if(aux_cities_reg.length > 0){
						for (let i = 0; i < aux_cities_reg.length; i++) {
							this.city_options.push(aux_cities_reg[i].regular);
						}
					}else{
						for (let i = 0; i < aux_cities_norm.length; i++) {
							this.city_options.push(aux_cities_norm[i].regular);
						}
					}

					let cityExistsAndUnique = false;
					let zipcodeCoincides = false;
					let zipcodeValidation;
					if((this.unique_populations.filter(city => city.regular === value)).length == 1){
						cityExistsAndUnique = true;
						zipcodeValidation = this.populations_list.filter(cityZip => cityZip.nom == value);
						for (let i = 0; i < zipcodeValidation.length; i++) {
							const zip = zipcodeValidation[i];
							if((zip.codi == this.ibanHolderData.zipcode.toString())){
								zipcodeCoincides = true;
								break;
							}else{
								zipcodeCoincides = false;
							}
						}
					}else{
						cityExistsAndUnique = false;
					}
					let re = new RegExp("^([0-9a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value) && cityExistsAndUnique && zipcodeCoincides){
						this.ibanHolderData.validation.city_valid = true;
						this.ibanHolderData.city_error = false;
						this.ibanHolderData.city_success = true;
					}else{
						this.ibanHolderData.validation.city_valid = false;
						this.ibanHolderData.city_success = false;
						this.ibanHolderData.city_error = true;
					}
					this.checkIbanDataValidation();
				},
				selectCityIban: function(event, city_index){
					event.stopPropagation();
					this.setCityIban(this.city_options[city_index]);
					this.cityDropdownState = false;
				},
				checkIbanDataValidation: function(){
					if(Object.values(this.ibanHolderData.validation).filter((v) => (v === false)).length === 0){
						this.ibanHolderData.info_valid = true;
					}else{
						this.ibanHolderData.info_valid = false;
					}
				}
			}
		});
	}
});


//Baja baremada
$(function(){
	if($('.tarificador-module-baremado').length){
		var tariff_bar_app = new Vue({
			el: '.tarificador-module-baremado',
			data: {
				tarif_profession: "",
				tarif_profession_code: "0",
				tarif_profession_group: "0",
				tarif_profession_selfemployed: true,
				tarif_zipcode: "",
				tarif_phone: "",
				tarif_birthdate: "",
				output_date: "",
				selectPlaceholder: true,
				tarif_profession_error: false,
				tarif_profession_selfemployed_error: false,
				tarif_zipcode_error: false,
				tarif_zipcode_empty: false,
				tarif_phone_error: false,
				tarif_birthdate_error: false,
				tarif_birthdate_error_alt: false,
				people_select_options: [],
				profession_list: [],
				disabledDates: {
					from: new Date
				},
				dateToOpen: new Date,
				es: es,
				ca: ca

			},
			components: {
				Datepicker
			},
			mounted(){
				console.log('Component did mount');
				//add profession items to list
				this.disabledDates = {
					from: this.calculateLastDate()
				}
				this.dateToOpen = this.calculateLastDate()
				this.recoverProfessions();
				if(sessionStorage.getItem('insured_list')){
					sessionStorage.removeItem('insured_list')
				}
			},
			updated(){

			},
			methods:{
				calculateLastDate: function(){
					let date = new Date();
					//console.log(date)
					date.setFullYear(date.getFullYear() - 18);
					//console.log(date)
					return date
				},
				recoverProfessions: function(){
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverProfessionsBarem&lang='+lang_code;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{
								data = JSON.parse(request.response);
							}
						catch (e)
							{ responseQuality = false; }
						if (responseQuality) {
							this.profession_list = data;
						}
					}
					request.send();
				},
				inputValidationProfession: function(event){
					let app = this;
					app.tarif_profession = app.tarif_profession.toUpperCase();
					let selected_prof = app.profession_list.filter(profession => profession.TEXTE == app.tarif_profession)[0];
					if (selected_prof != undefined) {
						app.tarif_profession_code = selected_prof.CODI;
						app.tarif_profession_group = selected_prof.GRUP;
					}else{
						app.tarif_profession_code = "0";
						app.tarif_profession_group = "0";
					}
				},
				updateValidationProfession: function(event){
					let app = this;
					let selected_prof = this.profession_list.filter(profession => profession.TEXTE == this.tarif_profession)[0];
					if (selected_prof != undefined) {
						this.tarif_profession_code = selected_prof.CODI;
						this.tarif_profession_group = selected_prof.GRUP;
					}else{
						this.tarif_profession_code = "0";
						this.tarif_profession_group = "0";
					}
				},
				executeTooltipNotice: function(event){
					event.preventDefault();
					let app = this;
					app.tarif_profession_selfemployed_error = true;
					setTimeout(()=>{
						app.tarif_profession_selfemployed_error = false;
					}, 3000);
				},
				rateCalculationBaremada: function(event){
					//console.log(this.tarif_birthdate)
					//console.log(new Date())
					//console.log(this.getAge(this.tarif_birthdate))
					if (this.tarif_profession_code != "0" && this.tarif_zipcode!="" && this.checkZipcode(this.tarif_zipcode) && this.tarif_phone!="" && this.tarif_birthdate!="" && this.getAge(this.tarif_birthdate) >= 18 && this.tarif_profession_selfemployed ){
						sessionStorage.setItem('tarificador_profession', this.tarif_profession);
						sessionStorage.setItem('tarificador_profession_code', this.tarif_profession_code);
						sessionStorage.setItem('tarificador_profession_grup', this.tarif_profession_group);
						if (this.tarif_profession_selfemployed) {
							sessionStorage.setItem('tarificador_profession_autonomo', "1");
						}
						sessionStorage.setItem('tarificador_zipcode', this.tarif_zipcode);
						sessionStorage.setItem('tarificador_phone', this.tarif_phone);
						sessionStorage.setItem('tarificador_birthdate', this.tarif_birthdate);
					}else{
						event.preventDefault();

						this.tarif_profession_error = false;
						this.tarif_zipcode_error = false;
						this.tarif_zipcode_empty = false;
						this.tarif_phone_error = false;
						this.tarif_birthdate_error = false;
						this.tarif_birthdate_error_alt = false;
						if(this.tarif_profession_code==0){this.tarif_profession_error = true}
						if(this.tarif_zipcode==""){this.tarif_zipcode_empty = true}
						if(this.checkZipcode(this.tarif_zipcode)==false) {this.tarif_zipcode_error = true}
						if(this.tarif_phone==0){this.tarif_phone_error = true}
						if(this.tarif_birthdate==0){this.tarif_birthdate_error = true}
						if (this.getAge(this.tarif_birthdate) != NaN && this.getAge(this.tarif_birthdate) < 18) {
							this.tarif_birthdate_error = true;
							this.tarif_birthdate_error_alt = true
						}
					}

				},
				getAge: function(dateString) {
					var today = new Date();
					var birthDate = new Date(dateString);
					var age = today.getFullYear() - birthDate.getFullYear();
					var m = today.getMonth() - birthDate.getMonth();
					if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
						age--;
					}
					return age;
				},
				fechaSeleccionada: function(){
					this.$nextTick(() => {
						let date = this.tarif_birthdate;
						let day = date.getDate();
						let month = date.getMonth() + 1;
						let year = date.getFullYear();

						if(month < 10){
							this.output_date = `${day}/0${month}/${year}`;
						}else{
							this.output_date =`${day}/${month}/${year}`;
						}
					});
				},
				selectChange: function(event){
					if(this.tarificador_people_number != 0){
						this.selectPlaceholder = false;
					}
				},
				checkZipcode: function(zipcode){
					let result = false;
					zipcode = zipcode.toString().toUpperCase();
					let first_chars = zipcode.substring(0, 2);
					let last_chars = zipcode.substring(2);
					let checkAgainst = [
						{CODI_PROVINCIA: "01", PROVINCIA: "Alava"},
						{CODI_PROVINCIA: "02", PROVINCIA: "Albacete"},
						{CODI_PROVINCIA: "03", PROVINCIA: "Alicante"},
						{CODI_PROVINCIA: "04", PROVINCIA: "Almeria"},
						{CODI_PROVINCIA: "AD", PROVINCIA: "Andorra"},
						{CODI_PROVINCIA: "05", PROVINCIA: "Avila"},
						{CODI_PROVINCIA: "06", PROVINCIA: "Badajoz"},
						{CODI_PROVINCIA: "07", PROVINCIA: "Balears"},
						{CODI_PROVINCIA: "08", PROVINCIA: "Barcelona"},
						{CODI_PROVINCIA: "09", PROVINCIA: "Burgos"},
						{CODI_PROVINCIA: "10", PROVINCIA: "Caceres"},
						{CODI_PROVINCIA: "11", PROVINCIA: "Cadiz"},
						{CODI_PROVINCIA: "12", PROVINCIA: "Castellon"},
						{CODI_PROVINCIA: "13", PROVINCIA: "Ciudad Real"},
						{CODI_PROVINCIA: "14", PROVINCIA: "Cordoba"},
						{CODI_PROVINCIA: "16", PROVINCIA: "Cuenca"},
						{CODI_PROVINCIA: "17", PROVINCIA: "Girona"},
						{CODI_PROVINCIA: "18", PROVINCIA: "Granada"},
						{CODI_PROVINCIA: "19", PROVINCIA: "Guadalajara"},
						{CODI_PROVINCIA: "20", PROVINCIA: "Guipuzcoa"},
						{CODI_PROVINCIA: "21", PROVINCIA: "Huelva"},
						{CODI_PROVINCIA: "22", PROVINCIA: "Huesca"},
						{CODI_PROVINCIA: "23", PROVINCIA: "Jaen"},
						{CODI_PROVINCIA: "15", PROVINCIA: "La Coruña"},
						{CODI_PROVINCIA: "35", PROVINCIA: "Las Palmas"},
						{CODI_PROVINCIA: "24", PROVINCIA: "Leon"},
						{CODI_PROVINCIA: "25", PROVINCIA: "Lleida"},
						{CODI_PROVINCIA: "26", PROVINCIA: "Logroño"},
						{CODI_PROVINCIA: "27", PROVINCIA: "Lugo"},
						{CODI_PROVINCIA: "28", PROVINCIA: "Madrid"},
						{CODI_PROVINCIA: "29", PROVINCIA: "Malaga"},
						{CODI_PROVINCIA: "30", PROVINCIA: "Murcia"},
						{CODI_PROVINCIA: "31", PROVINCIA: "Navarra"},
						{CODI_PROVINCIA: "32", PROVINCIA: "Orense"},
						{CODI_PROVINCIA: "33", PROVINCIA: "Oviedo"},
						{CODI_PROVINCIA: "34", PROVINCIA: "Palencia"},
						{CODI_PROVINCIA: "36", PROVINCIA: "Pontevedra"},
						{CODI_PROVINCIA: "37", PROVINCIA: "Salamanca"},
						{CODI_PROVINCIA: "39", PROVINCIA: "Santander"},
						{CODI_PROVINCIA: "40", PROVINCIA: "Segovia"},
						{CODI_PROVINCIA: "41", PROVINCIA: "Sevilla"},
						{CODI_PROVINCIA: "42", PROVINCIA: "Soria"},
						{CODI_PROVINCIA: "43", PROVINCIA: "Tarragona"},
						{CODI_PROVINCIA: "38", PROVINCIA: "Tenerife"},
						{CODI_PROVINCIA: "44", PROVINCIA: "Teruel"},
						{CODI_PROVINCIA: "45", PROVINCIA: "Toledo"},
						{CODI_PROVINCIA: "46", PROVINCIA: "Valencia"},
						{CODI_PROVINCIA: "47", PROVINCIA: "Valladolid"},
						{CODI_PROVINCIA: "48", PROVINCIA: "Vizcaya"},
						{CODI_PROVINCIA: "49", PROVINCIA: "Zamora"},
						{CODI_PROVINCIA: "50", PROVINCIA: "Zaragoza"}
					];
					if(zipcode.length === 0){
						result = true;
					}else{
						if (zipcode.length === 5 && checkAgainst.find(item=>item.CODI_PROVINCIA === first_chars) !== undefined && /^\d+$/.test(last_chars)) {
							result = true;
						}
					}
					return result;
				}
			}
		});
	}
});

$(function(){
	if($('.page-calcula-baja-baremada-tarificador').length){
		var price_calculation_page_bar_app = new Vue({
			el: '.page-calcula-baja-baremada-tarificador',
			data: {
				loading: false,
				loadingComplete: false,
				loadingError: false,
				loadingAnnotation: 0,
				output_link: "",
				daily_compensation: 60,
				es: es,
				ca: ca,


				tomador_object: {
					birthdate: "",
					formated_birthdate: "",
					zipcode: sessionStorage.getItem('tarificador_zipcode'),
					phone_number: sessionStorage.getItem('tarificador_phone'),
					autonom: sessionStorage.getItem('tarificador_profession_autonomo'),
					professio: sessionStorage.getItem('tarificador_profession_code'),
					grup: sessionStorage.getItem('tarificador_profession_grup'),
					nomProfessio: sessionStorage.getItem('tarificador_profession')
				},

				s: ""

			},
			components: {
			},
			mounted(){
				this.loading = false;
				this.loadingComplete = false;
				this.tomador_object.birthdate = new Date(sessionStorage.getItem('tarificador_birthdate'));
				this.reformatDateTomador();
				this.output_link = window.output_link;

				this.s = document.createElement("style");


				let slider = document.querySelector('.page-calcula-baja-baremada-tarificador #page-baja-baremada-slider');
				let tooltip = document.querySelector('.page-calcula-baja-baremada-tarificador .slider-tooltip')
				let pos = (slider.value - slider.min)/(slider.max - slider.min);
				let thumbCorrect = 24 * (pos - 0.5) * -1,
					titlepos = Math.round( ( pos * slider.clientWidth ) + thumbCorrect );
				tooltip.style.left = titlepos+"px";
				slider.appendChild(this.s);
				this.s.textContent = `input#${slider.id}::-webkit-slider-runnable-track { background: linear-gradient(to right, #39ABBF 0%, #39ABBF ${(slider.value-slider.min)/(slider.max-slider.min)*100}%, #f7fafb ${(slider.value-slider.min)/(slider.max-slider.min)*100}%, #f7fafb 100%); }`;

			},
			updated(){

			},
			methods: {
				fullCompensationExampleCalculator: function(days){
					let price = days * this.daily_compensation;
					let price_string = price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&/');
					price_string = price_string.replace('.',',');
					price_string = price_string.replace("/",".");
					return price_string+"€";
				},
				reformatDateTomador: function(){
					this.$nextTick(() => {
						let date = this.tomador_object.birthdate;
						let day = date.getDate();
						let month = date.getMonth() + 1;
						let year = date.getFullYear();

						if(day < 10){
							this.tomador_object.formated_birthdate = `0${day}/`
						}else{
							this.tomador_object.formated_birthdate = `${day}/`
						}
						if(month < 10){
							this.tomador_object.formated_birthdate = this.tomador_object.formated_birthdate + `0${month}/${year}`;
						}else{
							this.tomador_object.formated_birthdate = this.tomador_object.formated_birthdate + `${month}/${year}`;
						}
					});
				},
				generateInsuranceKey: function(){
					let app = this;
					app.loading = true;
					let data_input = {
						codiPostal: app.tomador_object.zipcode,
						data_naix: app.tomador_object.formated_birthdate,
						autonom: app.tomador_object.autonom,
						unitats: app.daily_compensation,
						professio: app.tomador_object.professio,
						grup: app.tomador_object.grup,
						nomProfessio: app.tomador_object.nomProfessio,
						tel: app.tomador_object.phone_number,
					}

					//CURL petition

					app.changeAnnotation();

					let request = new XMLHttpRequest();
					//let url = '/wp-content/themes/mgc/curl_petition.php?petition=generateTariff&lang='+lang_code+"&dataInput="+JSON.stringify(data_input);
					let url = "/wp-content/themes/mgc/curl_petition.php?petition=tarifaParticularILT&lang="+lang_code+
					"&codiPostal="+data_input.codiPostal+
					"&data_naix="+data_input.data_naix+
					"&autonom="+data_input.autonom+
					"&unitats="+data_input.unitats+
					"&professio="+data_input.professio+
					"&grup="+data_input.grup+
					"&nomProfessio="+data_input.nomProfessio+
					"&telefon="+data_input.tel;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						//console.log(request.response)
						try
							{ data = JSON.parse(request.response); }
						catch (e)
							{ responseQuality = false }
						if (responseQuality) {
							if (data.resultat) {
								//console.log(data.resultat)
								if(data.status=="204"){
									app.loadingComplete = true;
									app.loadingError = true;
								}else{
									if (data.resultat.IMPORT_TOTAL_ANUAL == 0) {
										app.loadingComplete = true;
										app.loadingError = true;
									}else{
										//console.log('evitamos error')
										app.loadingComplete = true;
										sessionStorage.setItem('tariff_results', JSON.stringify(data.resultat));
										sessionStorage.setItem('tarificador_zipcode', app.tomador_object.zipcode);
										sessionStorage.setItem('tarificador_phone', app.tomador_object.phone_number);
										sessionStorage.setItem('tarificador_daily_compensation', app.daily_compensation);
										window.location = app.output_link;
									}
								}
							}else{
								app.loadingComplete = true;
								app.loadingError = true;
							}
						}else{
							app.loadingComplete = true;
							app.loadingError = true;
						}
					}
					request.send();
				},
				compensationChange: function(event){
					this.s.textContent = `input#${event.currentTarget.id}::-webkit-slider-runnable-track { background: linear-gradient(to right, #39ABBF 0%, #39ABBF ${(event.currentTarget.value-event.currentTarget.min)/(event.currentTarget.max-event.currentTarget.min)*100}%, #f7fafb ${(event.currentTarget.value-event.currentTarget.min)/(event.currentTarget.max-event.currentTarget.min)*100}%, #f7fafb 100%)!important; }`;
					let tooltip = document.querySelector('.page-calcula-baja-baremada-tarificador .slider-tooltip')
					let pos = (event.currentTarget.value - event.currentTarget.min)/(event.currentTarget.max - event.currentTarget.min);
					let thumbCorrect = 24 * (pos - 0.5) * -1,
						titlepos = Math.round( ( pos * event.currentTarget.clientWidth ) + thumbCorrect );
					tooltip.style.left = titlepos+"px";
				},
				changeAnnotation: function(){
					let app = this;
					setInterval(function(){
						if(app.loadingAnnotation < 3){
							app.loadingAnnotation = app.loadingAnnotation + 1;
						}else{
							app.loadingAnnotation = 0;
						}

					}, 5000);
				},
			}
		});
	}
});

$(function(){
	if($('.page-tus-precios-baja-baremada-tarificador').length){
		var price_display_page_app = new Vue({
			el: '.page-tus-precios-baja-baremada-tarificador',
			data: {
				returnLinkFlag: true,
				completed: false,
				email: "",
				dataProtectionInput: false,
				email_error: false,
				dataProtect_error: false,
				pageLoaded: false,
				data: '',
				codi: '',
				id: '',
				title: "",
				subtitle: "",
				link_mail: "",
				name_pkg_mail: "",
				description_mail: "",
				coverage: [],
				num_people: 0,

				price_selector: 2,

				tooltipOpen: false,

				price_units: "",
				price_cents: "",
				email_sent: false,

				price_yearly: 0.0,
				price_montly:0.0,

				action_link: ""

			},
			mounted(){
				/* console.log(JSON.parse(sessionStorage.getItem('tariff_results')));
				console.log(sessionStorage.getItem('tarificador_zipcode'));
				console.log(sessionStorage.getItem('tarificador_phone')); */
				this.action_link = window.action_link;
				this.loadData();
				this.pageLoaded = true;

			},
			updated(){},
			methods: {
				loadData: function(){
					let app = this;
					let data = JSON.parse(sessionStorage.getItem('tariff_results'));
					app.code = data.CODI;
					app.id = data.ID_TARIFA;
					app.title = data.INFORMACIO.TITOL;
					app.subtitle = data.INFORMACIO.SUBTITOL;
					app.coverage = data.INFORMACIO.COBERTURES;
					app.link_mail = data.INFORMACIO.LINK_MAIL;
					app.price_yearly = data.IMPORT_TOTAL_ANUAL;
					app.price_montly = data.IMPORT_TOTAL_MENSUAL;
					app.displayPrice(app.price_montly);
				},
				displayPrice: function(price){
					this.price_units = Math.floor(price);
					let cents = price % 1;
					cents = cents.toFixed(2).substring(2);
					this.price_cents = "," + cents +"€";
				},
				calculateGlobalPrice: function(price){
					let units = Math.floor(price);
					let cents = price % 1;
					cents = cents.toFixed(2).substring(2);

					return {"units": units, "cents": cents};
				},
				triggerPopUp: function(event){
					event.preventDefault();
					event.stopPropagation();
					if (this.tooltipOpen) {
						this.tooltipOpen = false;
					}else{
						this.tooltipOpen = true;
					}

				},
				closePopUp: function(event){
					event.preventDefault();
					event.stopPropagation();
					this.tooltipOpen = false;
				},
				infoRequest: function(event, modalId){
					event.preventDefault();
					//console.log('Info requested');
					$(modalId).modal('show');
				},
				goToContract: function(event){
					event.preventDefault();
					window.location = this.action_link;
					//console.log('Go to contract page');
				}
			}
		});
	}
});

$(function(){
	if($('.page-contratar-baja-baremada').length){
		var contratar_baja_baremada_page_app = new Vue({
			el: '.page-contratar-baja-baremada',
			data: {
				loading: true,
				loadError: false,

				fillComplete: false, //default false
				validationComplete: false, //default false
				confirmLegalConditions: false,

				modalContractDataOpen: false,

				modalLoad: true,
				modalLoadError: false,

				insurance_modality_chosen: 0,
				insurance_price_with_copayment: {
					total: 0,
					units: 0,
					cents: 0
				},
				insurance_price_without_copayment: {
					total: 0,
					units: 0,
					cents: 0
				},

				display_price_with_copayment: {
					total: 0,
					units: 0,
					cents: 0
				},
				display_price_without_copayment: {
					total: 0,
					units: 0,
					cents: 0
				},

				modalityOpen: true, //default true
				modalityComplete: false, //default false

				resumeOpen: true, //default true
				resumeComplete: false, //default false
				contractDataOpen: false, //default false
				contractDataComplete: false, //default false
				bankDetailsOpen: false, //default false

				starter_data: [],
				insuredArr: [],
				insured_state_array: [],
				professions_list: [],
				parentius_list: [],
				idDocType_list: [],
				populations_list: [],
				unique_populations: [],
				nationalities_list: [],
				languages_list:[],
				insurers_list: [],

				product_name: "",

				insurer_selected: "00",

				dailyCompensation: "60€",
				dailyCompensation_units: "60",
				dailyCompensation_cents: "00",

				extra_data: {},

				city_options: [],
				cityDropdownState: false,
				shared_lang: true,
				shared_nationality: true,
				changedInsuranceCompany: 0,
				validationCode: new Array(5),
				validationCode_text: "",
				email_validation_error: false,
				iban: {
					final: "",
					final_dashed: "",
					section1: "",
					section2: "",
					section3: "",
					section4: "",
					section5: "",
					iban_valid: false,
					iban_1_valid: false,
					iban_1_error: false,
					iban_1_success: false,
					iban_2_valid: false,
					iban_2_error: false,
					iban_2_success: false,
					iban_3_valid: false,
					iban_3_error: false,
					iban_3_success: false,
					iban_4_valid: false,
					iban_4_error: false,
					iban_4_success: false,
					iban_5_valid: false,
					iban_5_error: false,
					iban_5_success: false
				},
				ibanTomador: true,
				ibanHolderData:
				{
					name: "",
					first_surname: "",
					second_surname: "",
					zipcode: "",
					city: "",
					street: "",

					validation: {
						name_valid: false,
						first_surname_valid: false,
						second_surname_valid: true,
						zipcode_valid: false,
						city_valid: false,
						street_valid: false
					},

					info_valid: false,

					name_error: false,
					name_success: false,
					first_surname_error: false,
					first_surname_success: false,
					second_surname_error: false,
					second_surname_success: false,
					zipcode_error: false,
					zipcode_success: false,
					city_error: false,
					city_success: false,
					street_error: false,
					street_success: false
				},
				hidden_iban: "0000",
				contract_start_date: "",
				data_input: {
					idTarifa: "",
					codiPostal: "",
					phone: "",
					email: "",
					webData: "",
					contactClient: ""

				},
				idTarifa: "",
				clientContact: "",
				comercial: "",
				colectiu: "",
				periodicitat: 12,
				oportunidad: "",
				cpOportunidad: "",
				coverage: []
			},
			mounted(){
				console.log('component did mount');
				let app = this;
				app.recoverProfessions();
				app.recoverIdDocType();
				app.recoverPopulations();
				app.recoverNationalities();
				app.recoverLanguages();
				app.recoverInsurers();
				app.recoverParentius();
				app.$nextTick(function(){
					window.addEventListener('click', function(e){
						app.cityDropdownState = false;
					})
				})

			},
			methods:{
				loadData: function(){

					//Ejemplo URL: https://www.mgc.es/asesoramiento-presupuesto?dades=6HYOWzsqDBeMUmw0jMSUMTBYtmJaf56wIzHSaOtde7FWwaRZpixSe9v5iXoMTaVTd7NjXPXd95khjNzdNytqtA
					let url = window.location.href;
					//url = "http://mgc-dev/contratar-seguro?dades=6HYOWzsqDBeMUmw0jMSUMTBYtmJaf56wIzHSaOtde7FWwaRZpixSe9v5iXoMTaVTd7NjXPXd95khjNzdNytqtA"
					var params = {};
					if (url.includes('?')) {
						var param_array = url.split('?')[1].split('&');
						for(var i in param_array){
							let x = param_array[i].split('=');
							params[x[0]] = x[1];
						}
					}

					if (params.dades){
						this.data_input.webData = params.dades;
						//console.log(params.dades)
					}else{
						let data_storage = JSON.parse(sessionStorage.getItem('tariff_results'));
						if(data_storage){
							this.idTarifa = data_storage['ID_TARIFA'];
							this.data_input.idTarifa = data_storage['ID_TARIFA'];
							this.cpOportunidad = sessionStorage.getItem('tarificador_zipcode');
							this.data_input.codiPostal = sessionStorage.getItem('tarificador_zipcode');
							this.data_input.phone = sessionStorage.getItem('tarificador_phone');
						}else{
							//console.log('Dev: return error when finished')
							//this.loading = false;
							this.loadError=true;
							return false;
						}
					}
					this.getBudgetData(this.data_input);
				},
				filterStarterData: function(){
					let app = this;
					if(app.starter_data){
						//console.log(app.starter_data)
						let insured_starter = app.starter_data.infoPressupost.ASSEGURATS;
						app.contract_start_date = app.starter_data.infoPressupost.DATA_EFECTE;
						app.idTarifa = app.starter_data.infoPressupost.PAQUETS.ID_TARIFA;
						app.clientContact = app.starter_data.oportunitat.CLIENT_CONTACTE;
						app.coverage = [];
						app.comercial = app.starter_data.infoPressupost.COMERCIAL;
						//console.log('Comercial: '+app.comercial)
						app.colectiu = app.starter_data.infoPressupost.COLECTIU;
						app.periodicitat = app.starter_data.infoPressupost.PERIODICITAT;
						app.oportunidad = app.starter_data.oportunitat.OPORTUNITAT;

						app.product_name = app.starter_data.infoPressupost.INFORMACIO_PRODUCTE.TITOL;
						if(app.cpOportunidad == ""){
							app.cpOportunidad = app.starter_data.oportunitat.CODI_POSTAL;
						}
						for (let index = 0; index < app.starter_data.infoPressupost.INFORMACIO_PRODUCTE.COBERTURES.length; index++) {
							app.coverage.push(app.starter_data.infoPressupost.INFORMACIO_PRODUCTE.COBERTURES[index]);
						}
						app.insurance_price_with_copayment = {
							total: app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL,
							units: Math.floor(app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL).toString(),
							cents: (app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL % 1).toFixed(2).substring(2)
						}
						app.display_price_with_copayment = {
							total: app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL/12,
							units: Math.floor(app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL/12).toString(),
							cents: ((app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL/12) % 1).toFixed(2).substring(2)
						}
						app.insurance_price_without_copayment = {
							total: app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL_SENSE_COPAG,
							units: Math.floor(app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL_SENSE_COPAG).toString(),
							cents: (app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL_SENSE_COPAG % 1).toFixed(2).substring(2)
						}
						app.display_price_without_copayment = {
							total: app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL_SENSE_COPAG/12,
							units: Math.floor(app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL_SENSE_COPAG/12).toString(),
							cents: ((app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL_SENSE_COPAG/12) % 1).toFixed(2).substring(2)
						}
						for (let i = 0; i < insured_starter.length; i++) {
							let aux_birth_day = parseInt(insured_starter[i].DATANAIX.split("/")[0]);
							let aux_birth_month = parseInt(insured_starter[i].DATANAIX.split("/")[1])-1;
							let aux_birth_year = parseInt(insured_starter[i].DATANAIX.split("/")[2]);
							let parentiu_title = "";
							if(insured_starter[i].PARENTIU == "01"){
								if(lang_code == "es"){
									parentiu_title = "Tomador";
								}else if(lang_code == "ca"){
									parentiu_title = "Prenedor";
								}

							}else{
								parentiu_title = app.parentius_list.find(parentiu => parentiu.codi === insured_starter[i].PARENTIU).descripcio;
							}
							let insured = {}
							insured.relation =  {
								code: insured_starter[i].PARENTIU,
								text: parentiu_title
							}
							insured.personal ={
								name: "",
								surnames: "",
								first_surname: "",
								second_surname: "",
								birthdate: new Date(aux_birth_year, aux_birth_month, aux_birth_day),
								birthdate_string: insured_starter[i].DATANAIX,
								birthdate_num: insured_starter[i].DATANAIX.split("/")[2]+"-"+insured_starter[i].DATANAIX.split("/")[1]+"-"+insured_starter[i].DATANAIX.split("/")[0],
								sex: "00",
								idDocType: "TIPUSDOCIDNIF",
								idDocNum: "",
								profession: "00",
								autonom: "01",
								autonom_bool: true,
								nationality:"00",
								language: "00"
							};
							if (i==0){
								insured.contact = {
									email: app.starter_data.oportunitat.EMAIL,
									phone: app.starter_data.oportunitat.TEL_MOBIL
								}/*
								console.log(insured_starter[i].DADES_COMPLEMENTARIES)
								console.log(JSON.parse(insured_starter[i].DADES_COMPLEMENTARIES)) */
								app.extra_data = JSON.parse(insured_starter[i].DADES_COMPLEMENTARIES)
								app.dailyCompensation = app.extra_data.unitats+"€";
								app.recoverInsuredProfession(app.extra_data, i);
							}
							insured.address ={
								zipcode: "",
								province: "",
								city: "",
								street: "",
							}
							insured.minor = app.checkIfMinor(new Date(aux_birth_year, aux_birth_month, aux_birth_day));
							insured.price_with_copayment = (parseFloat(app.starter_data.infoPressupost.PAQUETS.TARIFA_GRUP[i]["TOTAL TARIFA FINAL"].replace(',', '.')) / 12).toFixed(2).toString().replace('.', ',');
							insured.price_without_copayment = (parseFloat(app.starter_data.infoPressupost.PAQUETS.TARIFA_GRUP_SENSE_COPAG[i]["TOTAL TARIFA FINAL"].replace(',', '.')) / 12).toFixed(2).toString().replace('.', ',');
							app.insuredArr.push(insured);
							//console.log(app.insuredArr)
							app.insured_state_array.push({
								open: false,
								completed: false,
								valid: false,
								input_state: {
									name_error: false,
									name_success: false,
									surnames_error: false,
									surnames_success: false,
									first_surname_error: false,
									first_surname_success: false,
									second_surname_error: false,
									second_surname_success: false,
									idDocNum_error: false,
									idDocNum_success: false,
									email_error: false,
									email_success: false,
									phone_error: false,
									phone_success: false,
									sex_success: false,
									nation_success: false,
									lang_success: false,
									profession_success: false,
									autonom_success: false,
									autonom_error:false
								},
								input_validation: {
									name_valid: false,
									//surnames_valid: false,
									first_surname_valid: false,
									sex_validation: false,
									nation_validation: false,
									lang_validation: false,
									idDocNum_valid: true,
									autonom_valid: true,
								}
							})
							if(!app.insuredArr[i].minor){
								app.insured_state_array[i].input_validation.idDocNum_valid = false;
								//app.insured_state_array[i].input_validation.autonom_validation = false;
								//app.insured_state_array[i].input_validation.profession_validation = false;
							}
							if(i==0){
								app.insured_state_array[i].input_validation.email_valid = false;
								app.insured_state_array[i].input_validation.phone_valid = false;
								app.insured_state_array[i].input_validation.city_valid = false;
								app.insured_state_array[i].input_state.city_error = false;
								app.insured_state_array[i].input_state.city_success = false;
								app.insured_state_array[i].input_validation.city_valid = false;
								app.insured_state_array[i].input_state.city_error = false;
								app.insured_state_array[i].input_state.city_success = false;
								app.insured_state_array[i].input_validation.street_valid = false;
								app.insured_state_array[i].input_state.street_error = false;
								app.insured_state_array[i].input_state.street_success = false;
								app.insured_state_array[i].input_validation.zipcode_valid = false;
								app.insured_state_array[i].input_state.zipcode_error = false;
								app.insured_state_array[i].input_state.zipcode_success = false;
								if(app.starter_data.oportunitat.EMAIL != ""){app.setMail(app.insuredArr[0].contact.email, 0);}
								if(app.starter_data.oportunitat.TEL_MOBIL != ""){app.setPhone(app.insuredArr[0].contact.phone, 0);}
							}
						}
						app.insured_state_array[0].open = true;
					}
				},
				recoverInsuredProfession: function(data_in, index){
					//console.log(data_in);
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=transcribeProfessionCode&code='+data_in.professio+'&lang='+lang_code;
					//console.log(url)
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{ data = JSON.parse(request.response);}
						catch (e)
							{ responseQuality = false; }
						if (responseQuality) {
							this.insuredArr[index].personal.profession = data.professio[0].CODI_PROFESSIO;
						}else{
							/* console.log(request);
							console.log(request.response) */
						}
					}
					request.send();
				},
				checkValidation: function(){
					for (let index = 0; index < this.insured_state_array.length; index++) {
						if(Object.values(this.insured_state_array[index].input_validation).filter((v) => (v === false)).length === 0){
							this.insured_state_array[index].valid = true;
						}else{
							this.insured_state_array[index].valid = false;
						}
					}
				},
				setMail: function(value, insuredId){
					let re = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-]+$");
					let isUnique = true;
					for (let index = 0; index < this.insuredArr.length; index++) {
						if(index!=insuredId){
							if(this.insuredArr[index].contact.email == value){
								isUnique = false;
							}
						}
					}
					if(insuredId > 0 && value == ""){
						this.insured_state_array[insuredId].input_validation.email_valid = true;
						this.insured_state_array[insuredId].input_state.email_error = false;
						this.insured_state_array[insuredId].input_state.email_success = false;
					}else{
						if(re.test(value) && isUnique){
							this.insured_state_array[insuredId].input_validation.email_valid = true;
							this.insured_state_array[insuredId].input_state.email_error = false;
							this.insured_state_array[insuredId].input_state.email_success = true;
						}else{
							this.insured_state_array[insuredId].input_validation.email_valid = false;
							this.insured_state_array[insuredId].input_state.email_success = false;
							this.insured_state_array[insuredId].input_state.email_error = true;
						}
					}
					this.checkValidation();
				},
				setPhone: function(value, insuredId){
					let re = new RegExp("^[0-9]{9}$");
					if(insuredId > 0 && value == ""){
						this.insured_state_array[insuredId].input_validation.phone_valid = true;
						this.insured_state_array[insuredId].input_state.phone_error = false;
						this.insured_state_array[insuredId].input_state.phone_success = false;
					}else{
						if(re.test(value)){
							this.insured_state_array[insuredId].input_validation.phone_valid = true;
							this.insured_state_array[insuredId].input_state.phone_error = false;
							this.insured_state_array[insuredId].input_state.phone_success = true;
						}else{
							this.insured_state_array[insuredId].input_validation.phone_valid = false;
							this.insured_state_array[insuredId].input_state.phone_success = false;
							this.insured_state_array[insuredId].input_state.phone_error = true;
						}
					}
					this.checkValidation();
				},
				setName: function(value, insuredId){
					this.insuredArr[insuredId].personal.name = value;
					let re = new RegExp("^([a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value)){
						this.insured_state_array[insuredId].input_validation.name_valid = true;
						this.insured_state_array[insuredId].input_state.name_error = false;
						this.insured_state_array[insuredId].input_state.name_success = true;
					}else{
						this.insured_state_array[insuredId].input_validation.name_valid = false;
						this.insured_state_array[insuredId].input_state.name_success = false;
						this.insured_state_array[insuredId].input_state.name_error = true;
					}
					this.checkValidation();
				},
				setFirstSurname: function(value, insuredId){
					this.insuredArr[insuredId].personal.first_surname = value;
					let re = new RegExp("^([a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value)){
						this.insured_state_array[insuredId].input_validation.first_surname_valid = true;
						this.insured_state_array[insuredId].input_state.first_surname_error = false;
						this.insured_state_array[insuredId].input_state.first_surname_success = true;
					}else{
						this.insured_state_array[insuredId].input_validation.first_surname_valid = false;
						this.insured_state_array[insuredId].input_state.first_surname_success = false;
						this.insured_state_array[insuredId].input_state.first_surname_error = true;
					}
					this.checkValidation();
				},
				setSecondSurname: function(value, insuredId){
					this.insuredArr[insuredId].personal.second_surname = value;
					let re = new RegExp("^([a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value) || value==""){
						this.insured_state_array[insuredId].input_validation.second_surname_valid = true;
						this.insured_state_array[insuredId].input_state.second_surname_error = false;
						this.insured_state_array[insuredId].input_state.second_surname_success = false;
						if(value!=""){
							this.insured_state_array[insuredId].input_state.second_surname_success = true;
						}
					}else{
						this.insured_state_array[insuredId].input_validation.second_surname_valid = false;
						this.insured_state_array[insuredId].input_state.second_surname_success = false;
						this.insured_state_array[insuredId].input_state.second_surname_error = true;
					}
					this.checkValidation();
				},
				setDocument: function(value, insuredId){
					value = value.toString().toUpperCase();
					this.insuredArr[insuredId].personal.IdDocNum = value;
					let re;
					switch (this.insuredArr[insuredId].personal.idDocType){
						case "TIPUSDOCIDNIF":
							re = new RegExp("^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$");
							break;
						case "TIPUSDOCIDCIF":
							re = new RegExp("^([ABCDEFGHJKLMNPQRSUVW])([0-9]{7})([0-9A-J])$");
							break;
						case "TIPUSDOCIDPSP":
							re = new RegExp("^[A-Z]{3}[0-9]{6}[A-Z]?$");
							break;
						case "TIPUSDOCIDPEX":
							re = new RegExp("^[0-9A-Z]{9}$");
							break;
						case "TIPUSDOCIDNIE":
							re = new RegExp("^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$");
							break;
						default:
							console.log("ERROR");
					}
					let isUnique = true;
					for (let index = 0; index < this.insuredArr.length; index++) {
						if(index!=insuredId){
							if(this.insuredArr[index].personal.idDocNum.toUpperCase() == value){
								isUnique = false;
							}
						}
					}
					if((re.test(value) && isUnique) || (value == "" && this.insuredArr[insuredId].minor)){
						if(value == "" && this.insuredArr[insuredId].minor){
							this.insured_state_array[insuredId].input_validation.idDocNum_valid = true;
							this.insured_state_array[insuredId].input_state.idDocNum_error = false;
							this.insured_state_array[insuredId].input_state.idDocNum_success = false;
						}else{
							if(this.insuredArr[insuredId].personal.idDocType == "TIPUSDOCIDNIF" || this.insuredArr[insuredId].personal.idDocType == "TIPUSDOCIDNIE"){
								let validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
								let nie = value
									.replace(/^[X]/, '0')
									.replace(/^[Y]/, '1')
									.replace(/^[Z]/, '2');
								let letter = value.substr(-1);
								let charIndex = parseInt(nie.substr(0, 8)) % 23;
								if (validChars.charAt(charIndex) === letter) {
									this.insured_state_array[insuredId].input_validation.idDocNum_valid = true;
									this.insured_state_array[insuredId].input_state.idDocNum_error = false;
									this.insured_state_array[insuredId].input_state.idDocNum_success = false;
									if(value!=""){
										this.insured_state_array[insuredId].input_state.idDocNum_success = true;
									}
								}else{
									this.insured_state_array[insuredId].input_validation.idDocNum_valid = false;
									this.insured_state_array[insuredId].input_state.idDocNum_success = false;
									this.insured_state_array[insuredId].input_state.idDocNum_error = true;
								}
							}else if(this.insuredArr[insuredId].personal.idDocType == "TIPUSDOCIDCIF"){
								if(value==""){
									if(this.insuredArr[insuredId].minor){
										this.insured_state_array[insuredId].input_validation.idDocNum_valid = true;
										this.insured_state_array[insuredId].input_state.idDocNum_error = false;
										this.insured_state_array[insuredId].input_state.idDocNum_success = false;
									}else{
										this.insured_state_array[insuredId].input_validation.idDocNum_valid = false;
										this.insured_state_array[insuredId].input_state.idDocNum_error = true;
										this.insured_state_array[insuredId].input_state.idDocNum_success = false;
									}
								}else if(this.isValidCif(value)){
									this.insured_state_array[insuredId].input_validation.idDocNum_valid = true;
									this.insured_state_array[insuredId].input_state.idDocNum_error = false;
									this.insured_state_array[insuredId].input_state.idDocNum_success = true;
								}else{
									this.insured_state_array[insuredId].input_validation.idDocNum_valid = false;
									this.insured_state_array[insuredId].input_state.idDocNum_success = false;
									this.insured_state_array[insuredId].input_state.idDocNum_error = true;
								}
							}else{
								this.insured_state_array[insuredId].input_validation.idDocNum_valid = true;
								this.insured_state_array[insuredId].input_state.idDocNum_error = false;
								this.insured_state_array[insuredId].input_state.idDocNum_success = false;
								if(value!=""){
									this.insured_state_array[insuredId].input_state.idDocNum_success = true;
								}
							}
						}

					}else{
						this.insured_state_array[insuredId].input_validation.idDocNum_valid = false;
						this.insured_state_array[insuredId].input_state.idDocNum_success = false;
						this.insured_state_array[insuredId].input_state.idDocNum_error = true;
					}
					this.checkValidation();
				},
				setZipcode: function(value, insuredId){
					this.insuredArr[insuredId].address.zipcode = value;
					let re = new RegExp("^([0-9]{5})$");
					if(re.test(value) && value == this.cpOportunidad){
						this.insured_state_array[insuredId].input_validation.zipcode_valid = true;
						this.insured_state_array[insuredId].input_state.zipcode_error = false;
						this.insured_state_array[insuredId].input_state.zipcode_success = true;
					}else{
						this.insured_state_array[insuredId].input_validation.zipcode_valid = false;
						this.insured_state_array[insuredId].input_state.zipcode_success = false;
						this.insured_state_array[insuredId].input_state.zipcode_error = true;
					}
					this.setCity(this.insuredArr[insuredId].address.city, 0);
					this.checkValidation();
				},
				setCity: function(value, insuredId){
					if(value.length > 2){
						this.toggleCityDropdown(true);
					}else{
						this.toggleCityDropdown(false);
					}
					this.insuredArr[insuredId].address.city = value.capitalize();
					let aux_cities_reg = this.unique_populations.filter(city => city.regular == (value.capitalize()));
					let aux_cities_norm = this.unique_populations.filter(city => city.normalized.includes(this.normalizeString(value.capitalize())));
					this.city_options = [];
					 if(aux_cities_reg.length > 0){
						for (let i = 0; i < aux_cities_reg.length; i++) {
							this.city_options.push(aux_cities_reg[i].regular);
						}
					}else{
						for (let i = 0; i < aux_cities_norm.length; i++) {
							this.city_options.push(aux_cities_norm[i].regular);
						}
					}

					let cityExistsAndUnique = false;
					let zipcodeCoincides = false;
					let zipcodeValidation;
					if((this.unique_populations.filter(city => city.regular === value)).length == 1){
						cityExistsAndUnique = true;
						zipcodeValidation = this.populations_list.filter(cityZip => cityZip.nom == value);
						for (let i = 0; i < zipcodeValidation.length; i++) {
							const zip = zipcodeValidation[i];
							if((zip.codi == this.insuredArr[insuredId].address.zipcode.toString())){
								zipcodeCoincides = true;
								break;
							}else{
								zipcodeCoincides = false;
							}
						}
					}else{
						cityExistsAndUnique = false;
					}
					let re = new RegExp("^([0-9a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value) && cityExistsAndUnique && zipcodeCoincides){
						this.insured_state_array[insuredId].input_validation.city_valid = true;
						this.insured_state_array[insuredId].input_state.city_error = false;
						this.insured_state_array[insuredId].input_state.city_success = true;
					}else{
						this.insured_state_array[insuredId].input_validation.city_valid = false;
						this.insured_state_array[insuredId].input_state.city_success = false;
						this.insured_state_array[insuredId].input_state.city_error = true;
					}
					this.checkValidation();
				},
				clickCity: function(event){
					event.stopPropagation();
				},
				toggleCityDropdown: function(status, event){
					if(event){
						event.stopPropagation();
					}
					this.cityDropdownState = status;
				},
				selectCity: function(event, city_index){
					event.stopPropagation();
					this.setCity(this.city_options[city_index], 0);
					this.cityDropdownState = false;
				},
				normalizeString: function (inStr) {
					inStr = inStr.toLowerCase();
					return inStr.replace(
						/([àáâãäå])|([çčć])|([èéêë])|([ìíîï])|([ñ])|([òóôõöø])|([ß])|([ùúûü])|([ÿ])|([æ])/g,
						function (str, a, c, e, i, n, o, s, u, y, ae) {
							if (a) return 'a';
							if (c) return 'c';
							if (e) return 'e';
							if (i) return 'i';
							if (n) return 'n';
							if (o) return 'o';
							if (s) return 's';
							if (u) return 'u';
							if (y) return 'y';
							if (ae) return 'ae';
						}
					);
				},
				setStreet: function(value, insuredId){
					if(value.length > 5){
						this.insured_state_array[insuredId].input_validation.street_valid = true;
						this.insured_state_array[insuredId].input_state.street_error = false;
						this.insured_state_array[insuredId].input_state.street_success = true;
					}else{
						this.insured_state_array[insuredId].input_validation.street_valid = false;
						this.insured_state_array[insuredId].input_state.street_success = false;
						this.insured_state_array[insuredId].input_state.street_error = true;
					}
					this.checkValidation();
				},
				nationSelect: function(event, index){
					if(this.shared_nationality && index == 0){
						for (let it = 0; it < this.insuredArr.length; it++) {
							this.insuredArr[it].personal.nationality = event.target.value;
							this.insured_state_array[it].input_validation.nation_validation = true;
							this.insured_state_array[it].input_state.nation_success = true;
						}
					}else{
						this.insuredArr[index].personal.nationality = event.target.value;
						this.insured_state_array[index].input_validation.nation_validation = true;
						this.insured_state_array[index].input_state.nation_success = true;
					}
					this.checkValidation();
				},
				langSelect: function(event, index){
					if(this.shared_lang && index == 0){
						for (let it = 0; it < this.insuredArr.length; it++) {
							this.insuredArr[it].personal.language = event.target.value;
							this.insured_state_array[it].input_validation.lang_validation = true;
							this.insured_state_array[it].input_state.lang_success = true;
						}
					}else{
						this.insuredArr[index].personal.language = event.target.value;
						this.insured_state_array[index].input_validation.lang_validation = true;
						this.insured_state_array[index].input_state.lang_success = true;
					}
					this.checkValidation();
				},
				selectChange: function(event, insuredId, select){
					let app = this;
					if (select == "idDocType"){
						this.setDocument(this.insuredArr[insuredId].personal.idDocNum, insuredId)
					}
					if (select == "sex"){
						this.insured_state_array[insuredId].input_validation.sex_validation = true;
						this.insured_state_array[insuredId].input_state.sex_success = true;
					}
					if (select == "periodicitat"){
						app.display_price_with_copayment = {
							total: app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL/app.periodicitat,
							units: Math.floor(app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL/app.periodicitat).toString(),
							cents: ((app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL/app.periodicitat) % 1).toFixed(2).substring(2)
						}
						app.display_price_withOUT_copayment = {
							total: app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL_SENSE_COPAG/app.periodicitat,
							units: Math.floor(app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL_SENSE_COPAG/app.periodicitat).toString(),
							cents: ((app.starter_data.infoPressupost.PAQUETS.GRAN_TOTAL_SENSE_COPAG/app.periodicitat) % 1).toFixed(2).substring(2)
						}
					}

					/* if (select == "autonom"){
						this.insuredArr[insuredId].personal.autonom = event.target.value;
						this.insured_state_array[insuredId].input_validation.autonom_validation = true;
						this.insured_state_array[insuredId].input_state.autonom_success = true;
					}
					if (select == "profession"){
						this.insuredArr[insuredId].personal.profession = event.target.value;
						this.insured_state_array[insuredId].input_validation.profession_validation = true;
						this.insured_state_array[insuredId].input_state.profession_success = true;
					} */
					this.checkValidation();
				},
				changeActiveInsurer: function(){
					let app = this;
					if(app.changedInsuranceCompany==0){
						app.insurer_selected = "00"
					}
				},
				isValidCif: function(cif) {
					if (!cif || cif.length !== 9) {
						return false;
					}
					let letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
					let digits = cif.substr(1, cif.length - 2);
					let letter = cif.substr(0, 1);
					let control = cif.substr(cif.length - 1);
					let sum = 0;
					let i;
					let digit;
					if (!letter.match(/[A-Z]/)) {
						return false;
					}
					for (i = 0; i < digits.length; ++i) {
						digit = parseInt(digits[i]);
						if (isNaN(digit)) {
							return false;
						}
						if (i % 2 === 0) {
							digit *= 2;
							if (digit > 9) {
								digit = parseInt(digit / 10) + (digit % 10);
							}
							sum += digit;
						} else {
							sum += digit;
						}
					}
					sum %= 10;
					if (sum !== 0) {
						digit = 10 - sum;
					} else {
						digit = sum;
					}
					if (letter.match(/[ABEH]/)) {
						return String(digit) === control;
					}
					if (letter.match(/[NPQRSW]/)) {
						return letters[digit] === control;
					}
					return String(digit) === control || letters[digit] === control;
				},
				checkIfMinor: function(bd) {
					let today = new Date();
					let yearsDiff =  today.getFullYear() - bd.getFullYear();
					let isMinor = false;
					if(yearsDiff < 18){
						isMinor = true;
					}
					return isMinor;
				},
				focusComplexInput: function(event, section){
					if(section != 0 && event.target.value == ""){
						for (let index = 1; index < section + 1; index++) {
							let children = event.target.parentNode.children;
							if (children[index].value == ""){
								let maxLength = parseInt(children[index - 1].attributes["maxlength"].value, 10);
								let myLength = children[index - 1].value.length;
								if (myLength >= maxLength){
									children[index].focus();
								}else{
									children[index - 1].focus();
								}
								break;
							}
						}
					}
				},
				pasteComplexInput: function(event, input){
					let app = this;
					let paste = (event.clipboardData || window.clipboardData).getData('text');
					let wrapper = event.target.closest('.input-wrapper');
					let inputArr = wrapper.querySelectorAll('input');
					if(input == "iban"){
						for (let index = 0; index < inputArr.length; index++) {
							switch (index){
								case(0):
									inputArr[index].value = paste.substring(0, 4);
									app.checkIban(paste.substring(0, 4), index, true);
									break;
								case(1):
									inputArr[index].value = paste.substring(4, 8);
									app.checkIban(paste.substring(4, 8), index, true);
									break;
								case(2):
									inputArr[index].value = paste.substring(8, 12);
									app.checkIban(paste.substring(8, 12), index, true);
									break;
								case(3):
									inputArr[index].value = paste.substring(12, 14);
									app.checkIban(paste.substring(12, 14), index, true);
									break;
								case(4):
									inputArr[index].value = paste.substring(14);
									app.checkIban(paste.substring(14), index, true);
									break;
							}
						}
					}
					if(input == "emailVerification"){
						for (let index = 0; index < inputArr.length; index++) {
							inputArr[index].value = paste.charAt(index);
							app.validationCode[index] = paste.charAt(index);
						}
						app.validationCode_text = paste.substring(0,5)
					}
				},
				checkIban: function(value, section, paste){
					let re;
					let aux_value;
					if(paste){
						aux_value = value;
					}else{
						aux_value = value.toString().toUpperCase();
					}
					switch (section){
						case 0:
							this.iban.section1 = aux_value;
							re = new RegExp("^[ES]{2}[0-9]{2}$");
							if(re.test(this.iban.section1)){
								this.iban.iban_1_valid = true;
								this.iban.iban_1_success = true;
								this.iban.iban_1_error = false;
							}else{
								this.iban.iban_1_valid = false;
								this.iban.iban_1_success = false;
								this.iban.iban_1_error = true;
							}
							break;
						case 1:
							this.iban.section2 = aux_value;
							re = new RegExp("^[0-9]{4}$");
							if(re.test(this.iban.section2)){
								this.iban.iban_2_valid = true;
								this.iban.iban_2_success = true;
								this.iban.iban_2_error = false;
							}else{
								this.iban.iban_2_valid = false;
								this.iban.iban_2_success = false;
								this.iban.iban_2_error = true;
							}
							break;
						case 2:
							this.iban.section3 = aux_value;
							re = new RegExp("^[0-9]{4}?$");
							if(re.test(this.iban.section3)){
								this.iban.iban_3_valid = true;
								this.iban.iban_3_success = true;
								this.iban.iban_3_error = false;
							}else{
								this.iban.iban_3_valid = false;
								this.iban.iban_3_success = false;
								this.iban.iban_3_error = true;
							}
							break;
						case 3:
							this.iban.section4 = aux_value;
							re = new RegExp("^[0-9]{2}$");
							if(re.test(this.iban.section4)){
								this.iban.iban_4_valid = true;
								this.iban.iban_4_success = true;
								this.iban.iban_4_error = false;
							}else{
								this.iban.iban_4_valid = false;
								this.iban.iban_4_success = false;
								this.iban.iban_4_error = true;
							}
							break;
						case 4:
							this.iban.section5 = aux_value;
							re = new RegExp("^[0-9]{10}$");
							if(re.test(this.iban.section5)){
								this.iban.iban_5_valid = true;
								this.iban.iban_5_success = true;
								this.iban.iban_5_error = false;
							}else{
								this.iban.iban_5_valid = false;
								this.iban.iban_5_success = false;
								this.iban.iban_5_error = true;
							}
							break;
						default:
							console.log("ERROR");
					}

					this.iban.final = this.iban.section1 + this.iban.section2 + this.iban.section3 + this.iban.section4 + this.iban.section5;
					if(this.iban.iban_1_valid && this.iban.iban_2_valid && this.iban.iban_3_valid && this.iban.iban_4_valid && this.iban.iban_5_valid){

						if (this.fn_ValidateIBAN(this.iban.final)){
							this.iban.iban_valid = true;

							this.iban.iban_1_success = true;
							this.iban.iban_1_error = false;

							this.iban.iban_2_success = true;
							this.iban.iban_2_error = false;

							this.iban.iban_3_success = true;
							this.iban.iban_3_error = false;

							this.iban.iban_4_success = true;
							this.iban.iban_4_error = false;

							this.iban.iban_5_success = true;
							this.iban.iban_5_error = false;
						}else{
							this.iban.iban_valid = false;

							this.iban.iban_1_success = false;
							this.iban.iban_1_error = true;

							this.iban.iban_2_success = false;
							this.iban.iban_2_error = true;

							this.iban.iban_3_success = false;
							this.iban.iban_3_error = true;

							this.iban.iban_4_success = false;
							this.iban.iban_4_error = true;

							this.iban.iban_5_success = false;
							this.iban.iban_5_error = true;
						}
					}else{
						this.iban.iban_valid = false;
					}
					this.iban.final_dashed = this.iban.section1 + "-" + this.iban.section2 + "-" + this.iban.section3 + "-" + this.iban.section4 + "-" + this.iban.section5;
					this.iban.final = this.iban.section1 + this.iban.section2 + this.iban.section3 + this.iban.section4 + this.iban.section5;
				},
				fn_ValidateIBAN: function(IBAN){
					IBAN = IBAN.toUpperCase();
					IBAN = IBAN.trim();
					IBAN = IBAN.replace(/\s/g, "");
					let letra1,letra2,num1,num2;
					let isbanaux;
					if (IBAN.length != 24) {
						return false;
					}
					letra1 = IBAN.substring(0, 1);
					letra2 = IBAN.substring(1, 2);
					num1 = this.getnumIBAN(letra1);
					num2 = this.getnumIBAN(letra2);
					isbanaux = String(num1) + String(num2) + IBAN.substring(2);
					isbanaux = isbanaux.substring(6) + isbanaux.substring(0,6);
					let resto = this.modulo97(isbanaux);
					if (resto == 1){
						return true;
					}else{
						return false;
					}
				},
				modulo97: function(iban) {
					let parts = Math.ceil(iban.length/7);
					let remainer = "";
					for (var i = 1; i <= parts; i++) {
						remainer = String(parseFloat(remainer+iban.substr((i-1)*7, 7))%97);
					}
					return remainer;
				},
				getnumIBAN: function(letra) {
					let ls_letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
					return ls_letras.search(letra) + 10;
				},
				ibanActivate: function(event){
					let target = event.target;
					let maxLength = parseInt(target.attributes["maxlength"].value, 10);
					let myLength = target.value.length;
					if (myLength >= maxLength) {
						let next = target;
						while (next = next.nextElementSibling) {
							if (next == null)
								break;
							if (next.tagName.toLowerCase() === "input") {
								next.focus();
								break;
							}
						}
					}
					// Move to previous field if empty (user pressed backspace)
					else if (myLength === 0) {
						let previous = target;
						while (previous = previous.previousElementSibling) {
							if (previous == null)
								break;
							if (previous.tagName.toLowerCase() === "input") {
								previous.focus();
								break;
							}
						}
					}
				},
				completeFormItem: function(event, id){
					event.preventDefault();
					event.stopPropagation();
					this.insured_state_array[id].open = false;
					this.insured_state_array[id].complete = true;
					if(this.insured_state_array[id+1]){
						this.insured_state_array[id+1].open = true;
						let nextEl = event.target.closest('.form-section-body').querySelectorAll('.insured-form-item')[id+1];
						let yOffset = -100;
						let y = nextEl.getBoundingClientRect().top + yOffset;
						window.scrollTo({top: y, behavior: 'smooth'});

					}else{
						this.contractDataOpen = false;
						this.contractDataComplete = true;
						this.bankDetailsOpen = true;
						let nextEl = document.querySelector('.bankDetails');
						let yOffset = -100;
						let y = nextEl.getBoundingClientRect().top + yOffset;
						//window.scrollTo({top: nextEl.getBoundingClientRect().top + yOffset, behavior: 'smooth'});
					}
				},
				recoverProfessions: function(){
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverProfessions&lang='+lang_code;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{
								data = JSON.parse(request.response);
							}
						catch (e)
							{ responseQuality = false; }
						if (responseQuality) {
							this.professions_list = data;
						}
					}
					request.send();
				},
				recoverParentius: function(){
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverParentius&lang='+lang_code;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{
								data = JSON.parse(request.response);
							}
						catch (e)
							{
								responseQuality = false;
							}
						if (responseQuality) {
							this.parentius_list = data;
							this.loadData();
						}
					}
					request.send();
				},
				recoverIdDocType: function(){
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverDocType';
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{ data = JSON.parse(request.response);}
						catch (e)
							{ responseQuality = false; }
						if (responseQuality) {
							this.idDocType_list = data;
						}
					}
					request.send();
				},
				recoverPopulations: function(){
					let zipcode = "";
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverPopulations&zipcode=' + zipcode;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{ data = JSON.parse(request.response);}
						catch (e)
							{ responseQuality = false; }
						if (responseQuality) {
							//console.log(data)
							this.populations_list = data;
							this.filterPopulations(this.populations_list);
							//console.log(this.unique_populations)
						}
					}
					request.send();
				},
				filterPopulations: function(arr){
					arr.forEach((c) => {
						if (this.unique_populations.filter(up => up.regular == (c.nom)).length == 0) {
							let cityObject = {regular: c.nom, normalized: this.normalizeString(c.nom)}
							this.unique_populations.push(cityObject);
						}
					});
				},
				recoverNationalities: function(){
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverNacionalitats&lang='+lang_code;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{ data = JSON.parse(request.response);}
						catch (e)
							{ responseQuality = false;}
						if (responseQuality) {
							this.nationalities_list = data;
						}
					}
					request.send();
				},
				recoverLanguages: function(){
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverLanguages';
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{ data = JSON.parse(request.response);}
						catch (e)
							{ responseQuality = false; }
						if (responseQuality) {
							this.languages_list = data;
						}
					}
					request.send();
				},
				recoverInsurers: function(){
					let request = new XMLHttpRequest();
					let url = '/wp-content/themes/mgc/curl_petition.php?petition=recoverInsurers';
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try
							{ data = JSON.parse(request.response);}
						catch (e)
							{ responseQuality = false; }
						if (responseQuality) {
							this.insurers_list = data;
						}
					}
					request.send();
				},
				completeModality: function(event){
					event.preventDefault();
					event.stopPropagation();
					this.modalityOpen = false;
					this.modalityComplete = true;
					this.contractDataOpen = true;
					let nextEl = document.querySelector('.contractData');
					let yOffset = -100;
					let y = nextEl.getBoundingClientRect().top + yOffset;
					window.scrollTo({top: y, behavior: 'smooth'});

				},
				editModality: function(event){

					event.preventDefault();
					event.stopPropagation();
					this.modalityComplete = false;
					this.modalityOpen = true;
					this.contractDataOpen = false;
				},
				completeResume: function(event){
					event.preventDefault();
					event.stopPropagation();
					this.resumeOpen = false;
					this.resumeComplete = true;
					this.contractDataOpen = true;
					let nextEl = document.querySelector('.contractData');
					let yOffset = -100;
					let y = nextEl.getBoundingClientRect().top + yOffset;
					window.scrollTo({top: y, behavior: 'smooth'});

				},
				editResume: function(event){

					event.preventDefault();
					event.stopPropagation();
					this.resumeComplete = false;
					this.resumeOpen = true;
					this.contractDataOpen = false;
				},
				completeContract: function(event){
					event.preventDefault();
					event.stopPropagation();
					this.contractDataOpen = false;
					this.contractDataComplete = true;
					this.bankDetailsOpen = true;
				},
				editContract: function(event, index){
					event.preventDefault();
					event.stopPropagation();
					this.contractDataOpen = true;
					this.contractDataComplete = false;
					this.insured_state_array[index].open = true;
					this.insured_state_array[index].complete = false;

					for (let i = index + 1; i < this.insured_state_array.length; i++) {
						this.insured_state_array[i].open = false;
						this.insured_state_array[i].complete = false;
					}


					this.bankDetailsOpen = false;

				},
				fillingCompleted: function(event){
					//console.log('trigger completed')
					let app = this;
					let email = app.insuredArr[0].contact.email;
					let preferedLang = app.insuredArr[0].personal.language;
					let request = new XMLHttpRequest();
					let url = "/wp-content/themes/mgc/curl_petition.php?petition=generateValidationKey"
						+"&lang="+preferedLang
						+"&email="+email;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						//console.log(request)
						try{
							data = JSON.parse(request.response);
						}catch (e){
							responseQuality = false;
						}
						//console.log(data);
						if (responseQuality) {
							//console.log(data);
							if(data.status=="200"){
								this.fillComplete = true;
								this.hidden_iban = this.iban.final.slice(-4);
								let yOffset = (document.querySelector('.bloque-titulo').clientHeight);
								window.scrollTo({top: yOffset, behavior: 'smooth'});
							}else{
								console.log('ERROR');
							}
						}else{
							console.log('ERROR')
							return false;
						}
					}
					request.send();
				},
				sendValidationMailAgain: function(event){
					event.preventDefault();
					event.stopPropagation();
					let app = this;
					let email = app.insuredArr[0].contact.email;
					let preferedLang = app.insuredArr[0].personal.language;
					let request = new XMLHttpRequest();
					let url = "/wp-content/themes/mgc/curl_petition.php?petition=generateValidationKey"
						+"&lang="+preferedLang
						+"&email="+email;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try{
							data = JSON.parse(request.response);
						}catch (e){
							responseQuality = false;
						}
						if (responseQuality) {
							if(data.status=="200"){
								//console.log('Validation code sent');
							}else{
								console.log('ERROR');
							}
						}else{
							console.log('ERROR')
							return false;
						}
					}
					request.send();
				},
				validateEmail: function(event){
					let app = this;
					let email = app.insuredArr[0].contact.email;
					let code = app.validationCode_text;
					let request = new XMLHttpRequest();
					let url = "/wp-content/themes/mgc/curl_petition.php?petition=checkValidationKey"
						+"&code="+code
						+"&email="+email;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try{
							data = JSON.parse(request.response);
						}catch (e){
							responseQuality = false;
						}
						if (responseQuality) {
							if(data.status=="200"){
								this.validationComplete = true;
								let yOffset = (document.querySelector('.bloque-titulo').clientHeight);
								window.scrollTo({top: yOffset, behavior: 'smooth'});
								setTimeout(function(){
									if($('#confirmationModal')){
										$('footer').append($('#confirmationModal'));
										$('#confirmationModal').on('hide.bs.modal', function(e) {
											window.location = window.home_link;
										});
									}
								}, 100);
								this.informCompleteForm();
							}else{
								app.email_validation_error = true;
							}
						}else{
							console.log('ERROR')
							return false;
						}
					}
					request.send();
				},
				inputValidation: function(value, charPosition){
					this.validationCode[charPosition] = value;
					this.validationCode_text = this.validationCode.join('').toString();
				},
				validationActivate: function(event){
					let target = event.target;
					let maxLength = parseInt(target.attributes["maxlength"].value, 10);
					let myLength = target.value.length;
					if (myLength >= maxLength) {
						let next = target;
						while (next = next.nextElementSibling) {
							if (next == null)
								break;
							if (next.tagName.toLowerCase() === "input") {
								next.focus();
								break;
							}
						}
					}
					// Move to previous field if empty (user pressed backspace)
					else if (myLength === 0) {
						let previous = target;
						while (previous = previous.previousElementSibling) {
							if (previous == null)
								break;
							if (previous.tagName.toLowerCase() === "input") {
								previous.focus();
								break;
							}
						}
					}
				},
				contractInsurance: function(event){
					event.preventDefault();
					event.stopPropagation();
					this.sendAfiliation();
					$("#confirmationModal").modal('show');
				},
				toggleModalContractDataOpen: function(){
					this.modalContractDataOpen = !this.modalContractDataOpen;
				},
				informCompleteForm: function(){
					let app = this;
					let request = new XMLHttpRequest();
					let url = "/wp-content/themes/mgc/curl_petition.php?petition=checkFormComplete"
						+"&clientContact="+app.clientContact
						+"&numOportunity="+app.oportunidad;
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try{
							data = JSON.parse(request.response);
						}catch (e){
							responseQuality = false;
						}
						if (!responseQuality) {
							console.log('ERROR');
						}
					}
					request.send();
				},
				downloadDocument(){
					let app = this;
					let a;
					let request = new XMLHttpRequest();
					let url = "/wp-content/themes/mgc/curl_petition.php?petition=generateAfiliationPDF"
						+"&lang="+lang_code
						+"&identificadorTarifa="+app.idTarifa
						+"&productCode=0083";
					request.open('GET', url);
					request.onload = () => {
						let data;
						data = request.response;
						a = document.createElement("a");
						let pdf_name = "afiliacio_" + app.idTarifa + ".pdf";
						let data_url = "/wp-content/themes/mgc" + data.substring(1);
						a.href = data_url;
						a.setAttribute("download", pdf_name);
						a.click();
						setTimeout(()=>{
							let del_request = new XMLHttpRequest();
							let del_url = "/wp-content/themes/mgc/curl_petition.php?petition=deleteAfiliationPDF"+"&doc="+data;
							del_request.open('GET', del_url);
							del_request.onload = () => {

							}
							del_request.send();
						}, 3000);
					}
				request.send();
				},
				getBudgetData: function(data_input){
					let app = this;
					let request = new XMLHttpRequest();
					let url = "/wp-content/themes/mgc/curl_petition.php?petition=getWebBudgetData"
						+"&lang="+lang_code
						+"&idTarifa="+data_input.idTarifa
						+"&codiPostal="+data_input.codiPostal
						+"&phone="+data_input.phone
						+"&email="+data_input.email
						+"&webData="+data_input.webData
						+"&contactClient="+data_input.contactClient;
					//console.log(url)
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						try{
							data = JSON.parse(request.response);
						}catch (e){
							responseQuality = false;
						}
						if (responseQuality) {
							if (data.resultat && data.status == "200") {
								app.starter_data = data.resultat;
								app.filterStarterData();
								app.loading = false;
								//console.log(data)
							}else{
								if(data.status=="204"){
									//console.log(data)
									app.loadError = true;
								}
							}
						}else{
							//console.log(request.response);
							console.log('ERROR');
							app.loadError = true;
						}
					}
					request.send();
				},
				sendAfiliation: function(){

					let app = this;
					//let comercial = app.comercial;
					let comercial = "";
					let identificadorTarifa = app.idTarifa;
					let iban = app.iban.final_dashed;
					let prenedorName;
					let prenedorPriCognom;
					let prenedorSegCognom;
					let prenedorAdreca;
					let prenedorCodiPostal;
					let prenedorNomPoble;
					if(app.ibanTomador){
						prenedorName = app.insuredArr[0].personal.name;
						prenedorPriCognom = app.insuredArr[0].personal.first_surname;
						prenedorSegCognom = app.insuredArr[0].personal.second_surname;
						prenedorAdreca = app.insuredArr[0].address.street.replaceAll(",","_");
						prenedorCodiPostal = app.insuredArr[0].address.zipcode;
						prenedorNomPoble = app.insuredArr[0].address.city;
					}else{
						prenedorName = app.ibanHolderData.name;
						prenedorPriCognom = app.ibanHolderData.first_surname;
						prenedorSegCognom = app.ibanHolderData.second_surname;
						prenedorAdreca = app.ibanHolderData.street.replaceAll(",","_");
						prenedorCodiPostal = app.ibanHolderData.zipcode;
						prenedorNomPoble = app.ibanHolderData.city;
					}
					let prenedorEmail = app.insuredArr[0].contact.email
					let prenedorFreqCobrament = app.periodicitat;



					let names = [];
					let surnames = [];
					let second_surnames = [];
					let sexes = [];
					let birthdays = [];
					let relations = [];
					let professions = [];
					let nationalities = [];
					let nif = [];
					let docType = [];
					let address = [];
					let zipcodes = [];
					let cities = [];
					let emails = [];
					let phones = [];
					let mobilePhones = [];
					let autonoms = [];
					let languages = [];
					let companies = [];

					for (let i = 0; i < app.insuredArr.length; i++) {
						names.push(app.insuredArr[i].personal.name);
						surnames.push(app.insuredArr[i].personal.first_surname);
						second_surnames.push(app.insuredArr[i].personal.second_surname);
						sexes.push(app.insuredArr[i].personal.sex);
						birthdays.push(app.insuredArr[i].personal.birthdate_string);
						relations.push(app.insuredArr[i].relation.code);

						if(app.insuredArr[i].personal.profession != "00"){
							let profession = app.professions_list.filter(prof => prof.codi == app.insuredArr[i].personal.profession)
							professions.push(profession[0].descripcio.replaceAll(",","_"))
						}else{
							professions.push("");
						}
						nationalities.push(app.insuredArr[i].personal.nationality)
						nif.push(app.insuredArr[i].personal.idDocNum);
						docType.push(app.insuredArr[i].personal.idDocType);
						address.push(app.insuredArr[0].address.street.replaceAll(",","_"));
						zipcodes.push(app.insuredArr[0].address.zipcode);
						cities.push(app.insuredArr[0].address.city);
						if(app.insuredArr[i].contact){
							emails.push(app.insuredArr[i].contact.email);
						}else{
							emails.push("");
						}
						if(app.insuredArr[i].contact){
							if(app.insuredArr[i].contact.phone){
								if(app.insuredArr[i].contact.phone.substring(0) == 9){
									phones.push(app.insuredArr[i].contact.phone);
									mobilePhones.push("");
								}else{
									phones.push("");
									mobilePhones.push(app.insuredArr[i].contact.phone);
								}
							}else{
								if(app.insuredArr[0].contact.phone.substring(0) == 9){
									phones.push(app.insuredArr[0].contact.phone);
									mobilePhones.push("");
								}else{
									phones.push("");
									mobilePhones.push(app.insuredArr[0].contact.phone);
								}
							}
						}
						if (app.insuredArr[i].personal.autonom == "none") {
							autonoms.push("");
						}else{
							autonoms.push(app.insuredArr[i].personal.autonom);
						}
						if (app.insuredArr[i].personal.language != "00") {
							languages.push(app.insuredArr[i].personal.language);
						}else{
							languages.push(lang_code.toUpperCase());
						}
						if(app.insurer_selected == "00"){
							companies.push("");
						}else{
							companies.push(app.insurer_selected);
						}


					}

					comercial = app.comercial;
					let user = "";
					let clientContact = app.clientContact;
					let oportunityNumber = app.oportunidad;
					let globalCollective = app.colectiu;
					let mutua = "";
					let mutuaName = "";
					let timetableQM = "I";
					let observationsQM = "";
					let copayment = this.insurance_modality_chosen;


				let url = "/wp-content/themes/mgc/curl_petition.php?petition=particularAffiliationILT"+
					"&comercial=" + comercial +
					"&identificadorTarifa=" + identificadorTarifa +
					"&iban=" + iban +
					"&prenedorName=" + prenedorName +
					"&prenedorPriCognom=" + prenedorPriCognom +
					"&prenedorSegCognom=" + prenedorSegCognom +
					"&prenedorAdreca=" + prenedorAdreca +
					"&prenedorCodiPostal=" + prenedorCodiPostal +
					"&prenedorNomPoble=" + prenedorNomPoble +
					"&prenedorFreqCobrament=" + prenedorFreqCobrament +
					"&prenedorEmail=" + prenedorEmail +


					"&da_nom=" + names +
					"&da_priCognom=" + surnames +
					"&da_segCognom=" + second_surnames +
					"&da_sexe=" + sexes +
					"&da_data_naix=" + birthdays +
					"&da_parentiu=" + relations +
					"&da_professio=" + professions +
					"&da_nacionalitat=" + nationalities +
					"&da_nif=" + nif +
					"&da_tipusNif=" + docType +
					"&da_adreca=" + address +
					"&da_codiPostal=" + zipcodes +
					"&da_nomPoble=" + cities +
					"&da_email=" + emails +
					"&da_telefon=" + phones +
					"&da_telefonMobil=" + mobilePhones +
					"&da_autonom=" + autonoms +
					"&da_idioma=" + languages +
					"&da_companyia=" + companies +
					"&da_usuariGestio=" + user +
					"&da_clientContacte=" + clientContact +
					"&da_numOportunitat=" + oportunityNumber +
					"&da_colectiuGlobal=" + globalCollective +
					"&da_mutua=" + mutua +
					"&da_nomMutua=" + mutuaName +
					"&horariQM=" + timetableQM +
					"&observacionsQM=" + observationsQM +
					"&copagament=" + copayment;




					let request = new XMLHttpRequest();
					//let url = "/wp-content/themes/mgc/curl_petition.php?petition=afiliate";
					let responseQuality = true;
					request.open('GET', url);
					request.onload = () => {
						let data;
						//console.log(request.response);
						try
							{ data = JSON.parse(request.response); }
						catch (e)
							{ responseQuality = false }
						if (responseQuality) {
							if (data.status == "200") {
								app.modalLoad = false;
							}else{
								app.modalLoadError = true;
							}
						}else{
							console.log('ERROR');
							app.modalLoadError = true;
						}
					}
					request.send();
				},
				setNameIban: function(value, insuredId){
					this.ibanHolderData.name = value;
					let re = new RegExp("^([a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value)){
						this.ibanHolderData.validation.name_valid = true;
						this.ibanHolderData.name_error = false;
						this.ibanHolderData.name_success = true;
					}else{
						this.ibanHolderData.validation.name_valid = false;
						this.ibanHolderData.name_success = false;
						this.ibanHolderData.name_error = true;
					}
					this.checkIbanDataValidation();
				},
				setFirstSurnameIban: function(value, insuredId){
					this.ibanHolderData.first_surname = value;
					let re = new RegExp("^([a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value)){
						this.ibanHolderData.validation.first_surname_valid = true;
						this.ibanHolderData.first_surname_error = false;
						this.ibanHolderData.first_surname_success = true;
					}else{
						this.ibanHolderData.validation.first_surname_valid = false;
						this.ibanHolderData.first_surname_success = false;
						this.ibanHolderData.first_surname_error = true;
					}
					this.checkIbanDataValidation();
				},
				setSecondSurnameIban: function(value, insuredId){
					this.ibanHolderData.second_surname = value;
					let re = new RegExp("^([a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value) || value==""){
						this.ibanHolderData.validation.second_surname_valid = true;
						this.ibanHolderData.second_surname_error = false;
						this.ibanHolderData.second_surname_success = false;
						if(value!=""){
							this.ibanHolderData.second_surname_success = true;
						}
					}else{
						this.ibanHolderData.validation.second_surname_valid = false;
						this.ibanHolderData.second_surname_success = false;
						this.ibanHolderData.second_surname_error = true;
					}
					this.checkIbanDataValidation();
				},
				setStreetIban: function(value, insuredId){
					if(value.length > 5){
						this.ibanHolderData.validation.street_valid = true;
						this.ibanHolderData.street_error = false;
						this.ibanHolderData.street_success = true;
					}else{
						this.ibanHolderData.validation.street_valid = false;
						this.ibanHolderData.street_success = false;
						this.ibanHolderData.street_error = true;
					}
					this.checkIbanDataValidation();
				},
				setZipcodeIban: function(value, insuredId){
					this.ibanHolderData.zipcode = value;
					let re = new RegExp("^([0-9]{5})$");
					//if(re.test(value) && value == this.cpOportunidad){
					if(re.test(value)){
						this.ibanHolderData.validation.zipcode_valid = true;
						this.ibanHolderData.zipcode_error = false;
						this.ibanHolderData.zipcode_success = true;
					}else{
						this.ibanHolderData.validation.zipcode_valid = false;
						this.ibanHolderData.zipcode_success = false;
						this.ibanHolderData.zipcode_error = true;
					}
					this.setCityIban(this.ibanHolderData.city, 0);
					this.checkIbanDataValidation();
				},
				setCityIban: function(value){
					if(value.length > 2){
						this.toggleCityDropdown(true);
					}else{
						this.toggleCityDropdown(false);
					}
					this.ibanHolderData.city = value.capitalize();
					let aux_cities_reg = this.unique_populations.filter(city => city.regular == (value.capitalize()));
					let aux_cities_norm = this.unique_populations.filter(city => city.normalized.includes(this.normalizeString(value.capitalize())));
					this.city_options = [];
					 if(aux_cities_reg.length > 0){
						for (let i = 0; i < aux_cities_reg.length; i++) {
							this.city_options.push(aux_cities_reg[i].regular);
						}
					}else{
						for (let i = 0; i < aux_cities_norm.length; i++) {
							this.city_options.push(aux_cities_norm[i].regular);
						}
					}

					let cityExistsAndUnique = false;
					let zipcodeCoincides = false;
					let zipcodeValidation;
					if((this.unique_populations.filter(city => city.regular === value)).length == 1){
						cityExistsAndUnique = true;
						zipcodeValidation = this.populations_list.filter(cityZip => cityZip.nom == value);
						for (let i = 0; i < zipcodeValidation.length; i++) {
							const zip = zipcodeValidation[i];
							if((zip.codi == this.ibanHolderData.zipcode.toString())){
								zipcodeCoincides = true;
								break;
							}else{
								zipcodeCoincides = false;
							}
						}
					}else{
						cityExistsAndUnique = false;
					}
					let re = new RegExp("^([0-9a-zA-Z\u00C0-\u017F ]{3,})$");
					if(re.test(value) && cityExistsAndUnique && zipcodeCoincides){
						this.ibanHolderData.validation.city_valid = true;
						this.ibanHolderData.city_error = false;
						this.ibanHolderData.city_success = true;
					}else{
						this.ibanHolderData.validation.city_valid = false;
						this.ibanHolderData.city_success = false;
						this.ibanHolderData.city_error = true;
					}
					this.checkIbanDataValidation();
				},
				selectCityIban: function(event, city_index){
					event.stopPropagation();
					this.setCityIban(this.city_options[city_index]);
					this.cityDropdownState = false;
				},
				checkIbanDataValidation: function(){
					if(Object.values(this.ibanHolderData.validation).filter((v) => (v === false)).length === 0){
						this.ibanHolderData.info_valid = true;
					}else{
						this.ibanHolderData.info_valid = false;
					}
				},
				changeAutonom: function(event, i){
					let app = this;
				/* 	console.log(event.currentTarget.checked)
					console.log(app.insuredArr[i].personal)
					console.log(app.insuredArr[i].personal.autonom_bool) */
					//if (event.currentTarget.checked) {
					if (app.insuredArr[i].personal.autonom_bool) {
						app.insuredArr[i].personal.autonom = "01";
						app.insured_state_array[i].input_state.autonom_error = false;
						app.insured_state_array[i].input_state.autonom_success = true;
						app.insured_state_array[i].input_validation.autonom_valid = true;
					}else{
						app.insuredArr[i].personal.autonom = "00";
						app.insured_state_array[i].input_state.autonom_error = true;
						app.insured_state_array[i].input_state.autonom_success = false;
						app.insured_state_array[i].input_validation.autonom_valid = false;
					}
					app.checkValidation();
				}
			}
		});
	}
});








String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

$(function(){
	if($('.modulo-faqs').length){


		let faqCategorySelector = document.getElementById('faq-category-selector');
		let faqCategorySelectorLinks = Array(document.querySelectorAll('[data-item="faqCatIndex"]'));
		let faqCategoryItems = Array(document.querySelectorAll('[data-item="faqCatItem"]'));


		faqCategorySelectorLinks[0].forEach(btn=>{
			let parent = btn.closest('.category-index-item');
			let ref = btn.dataset['ref'];
			btn.addEventListener('click', (e)=>{
				e.preventDefault();
				$('#faq-category-selector').val(ref);
				$('#faq-category-selector').change();
			});
		});
		faqCategorySelector.onchange = (event) => {
			var ref = event.target.value;

			faqCategorySelectorLinks[0].forEach(aux_btn=>{aux_btn.closest('.category-index-item').classList.remove('active')})
			faqCategoryItems[0].forEach(item=>{item.classList.remove('active')});

			let aux_index_arr = Array.from(faqCategorySelectorLinks[0]);
			let aux_item_arr = Array.from(faqCategoryItems[0]);

			let activeIndex = aux_index_arr.filter(obj=>obj.dataset['ref']==ref);
			activeIndex[0].closest('.category-index-item').classList.add('active');
			let activeItem = aux_item_arr.filter(obj=>obj.dataset['ref']==ref);
			activeItem[0].classList.add('active');
		}
	}
});




//WPCF moved from functions to avoid load order problems with jQuery
$(".wpcf7-form").submit(function(event) {
	//console.log($(this));
	$(this).find('input[type="submit"]').prop("disabled", true);
});
document.addEventListener('wpcf7invalid', function(event) {
	console.trace('[form] submit error');
	$(this).find('input[type="submit"]').prop("disabled", false);
}, false);

// Detecció formulari enviat
document.addEventListener('wpcf7mailsent', function(event) {
	var input_eventlabel = event.detail.inputs.find(d => d.name === 'eventlabel');
	var eventlabel = input_eventlabel ? input_eventlabel.value : 'contacte';

	// Comprovem si el formulari és lead per generar conversió
	var input_islead = event.detail.inputs.find(d => d.name === 'islead');
	var islead = input_islead ? input_islead.value : '';
	if (islead) {
		// Conversió programàtica
		var ssaUrl = 'https://' + 'clickserv.sitescout.com/conv/91378a4e4dcb40b3';new Image().src = ssaUrl; (function(d) {  var syncUrl = 'https://' + 'pixel.sitescout.com/dmp/asyncPixelSync'; var iframe = d.createElement('iframe'); (iframe.frameElement || iframe).style.cssText = "width: 0; height: 0; border: 0;"; iframe.src = "javascript:false"; d.body.appendChild(iframe); var doc = iframe.contentWindow.document; doc.open().write('<body onload="window.location.href=\''+syncUrl+'\'">'); doc.close(); })(document);
		eventlabel = 'envioform';
	}

	// Event per a Analytics i Adwords
	/* gtag('event', 'clic', {
		'event_category': 'boton',
		'event_label': eventlabel
	}); */

	console.trace('[form] eventlabel = ' + eventlabel);

}, false);
